import * as styles from './styles.css';
export { styles as iconStyles };
import _extends from '@babel/runtime/helpers/esm/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import React from 'react';
import { fallbackVar } from '@vanilla-extract/css';
import { cx, getColor, contextColors, svgBasePath } from '@paypalcorp/pp-react-utils';

var _excluded$2 = ["as", "size", "color", "className", "children"];
var IconContainer = function (_ref) {
  var _ref$as = _ref.as,
    as = _ref$as === void 0 ? 'span' : _ref$as,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'md' : _ref$size,
    color = _ref.color,
    className = _ref.className,
    children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded$2);
  var classNames = cx(styles.svg, size === 'xs' && styles.sizeXs, size === 'sm' && styles.sizeSm, size === 'md' && styles.sizeMd, size === 'lg' && styles.sizeLg, size === 'xl' && styles.sizeXl, className);
  return /*#__PURE__*/React.createElement(as, _extends({
    role: "img",
    style: color ? function (color) {
      var iconColor = getColor(color, styles.legalColors, styles.ICON_FALLBACK_COLOR);
      return {
        color: fallbackVar(contextColors.main, iconColor)
      };
    }(color) : null,
    className: classNames,
    "data-ppui-info": "icons_9.12.1__8.16.2"
  }, rest), children);
};

var _excluded$1 = ["svgElementRef"],
  _excluded2 = ["svgElementRef"],
  _excluded3 = ["svgElementRef"],
  _excluded4 = ["svgElementRef"],
  _excluded5 = ["svgElementRef"],
  _excluded6 = ["svgElementRef"],
  _excluded7 = ["svgElementRef"],
  _excluded8 = ["svgElementRef"],
  _excluded9 = ["svgElementRef"],
  _excluded10 = ["svgElementRef"],
  _excluded11 = ["svgElementRef"],
  _excluded12 = ["svgElementRef"],
  _excluded13 = ["svgElementRef"],
  _excluded14 = ["svgElementRef"],
  _excluded15 = ["svgElementRef"],
  _excluded16 = ["svgElementRef"],
  _excluded17 = ["svgElementRef"],
  _excluded18 = ["svgElementRef"],
  _excluded19 = ["svgElementRef"],
  _excluded20 = ["svgElementRef"],
  _excluded21 = ["svgElementRef"],
  _excluded22 = ["svgElementRef"],
  _excluded23 = ["svgElementRef"],
  _excluded24 = ["svgElementRef"],
  _excluded25 = ["svgElementRef"],
  _excluded26 = ["svgElementRef"],
  _excluded27 = ["svgElementRef"],
  _excluded28 = ["svgElementRef"],
  _excluded29 = ["svgElementRef"],
  _excluded30 = ["svgElementRef"],
  _excluded31 = ["svgElementRef"],
  _excluded32 = ["svgElementRef"],
  _excluded33 = ["svgElementRef"],
  _excluded34 = ["svgElementRef"],
  _excluded35 = ["svgElementRef"],
  _excluded36 = ["svgElementRef"],
  _excluded37 = ["svgElementRef"],
  _excluded38 = ["svgElementRef"],
  _excluded39 = ["svgElementRef"],
  _excluded40 = ["svgElementRef"],
  _excluded41 = ["svgElementRef"],
  _excluded42 = ["svgElementRef"],
  _excluded43 = ["svgElementRef"],
  _excluded44 = ["svgElementRef"],
  _excluded45 = ["svgElementRef"],
  _excluded46 = ["svgElementRef"],
  _excluded47 = ["svgElementRef"],
  _excluded48 = ["svgElementRef"],
  _excluded49 = ["svgElementRef"],
  _excluded50 = ["svgElementRef"],
  _excluded51 = ["svgElementRef"],
  _excluded52 = ["svgElementRef"],
  _excluded53 = ["svgElementRef"],
  _excluded54 = ["svgElementRef"],
  _excluded55 = ["svgElementRef"],
  _excluded56 = ["svgElementRef"],
  _excluded57 = ["svgElementRef"],
  _excluded58 = ["svgElementRef"],
  _excluded59 = ["svgElementRef"],
  _excluded60 = ["svgElementRef"],
  _excluded61 = ["svgElementRef"],
  _excluded62 = ["svgElementRef"],
  _excluded63 = ["svgElementRef"],
  _excluded64 = ["svgElementRef"],
  _excluded65 = ["svgElementRef"],
  _excluded66 = ["svgElementRef"],
  _excluded67 = ["svgElementRef"],
  _excluded68 = ["svgElementRef"],
  _excluded69 = ["svgElementRef"],
  _excluded70 = ["svgElementRef"],
  _excluded71 = ["svgElementRef"],
  _excluded72 = ["svgElementRef"],
  _excluded73 = ["svgElementRef"],
  _excluded74 = ["svgElementRef"],
  _excluded75 = ["svgElementRef"],
  _excluded76 = ["svgElementRef"],
  _excluded77 = ["svgElementRef"],
  _excluded78 = ["svgElementRef"],
  _excluded79 = ["svgElementRef"],
  _excluded80 = ["svgElementRef"],
  _excluded81 = ["svgElementRef"],
  _excluded82 = ["svgElementRef"],
  _excluded83 = ["svgElementRef"],
  _excluded84 = ["svgElementRef"],
  _excluded85 = ["svgElementRef"],
  _excluded86 = ["svgElementRef"],
  _excluded87 = ["svgElementRef"],
  _excluded88 = ["svgElementRef"],
  _excluded89 = ["svgElementRef"],
  _excluded90 = ["svgElementRef"],
  _excluded91 = ["svgElementRef"],
  _excluded92 = ["svgElementRef"],
  _excluded93 = ["svgElementRef"],
  _excluded94 = ["svgElementRef"],
  _excluded95 = ["svgElementRef"],
  _excluded96 = ["svgElementRef"],
  _excluded97 = ["svgElementRef"],
  _excluded98 = ["svgElementRef"],
  _excluded99 = ["svgElementRef"],
  _excluded100 = ["svgElementRef"],
  _excluded101 = ["svgElementRef"],
  _excluded102 = ["svgElementRef"],
  _excluded103 = ["svgElementRef"],
  _excluded104 = ["svgElementRef"],
  _excluded105 = ["svgElementRef"],
  _excluded106 = ["svgElementRef"],
  _excluded107 = ["svgElementRef"],
  _excluded108 = ["svgElementRef"],
  _excluded109 = ["svgElementRef"],
  _excluded110 = ["svgElementRef"],
  _excluded111 = ["svgElementRef"],
  _excluded112 = ["svgElementRef"],
  _excluded113 = ["svgElementRef"],
  _excluded114 = ["svgElementRef"],
  _excluded115 = ["svgElementRef"],
  _excluded116 = ["svgElementRef"],
  _excluded117 = ["svgElementRef"],
  _excluded118 = ["svgElementRef"],
  _excluded119 = ["svgElementRef"],
  _excluded120 = ["svgElementRef"],
  _excluded121 = ["svgElementRef"],
  _excluded122 = ["svgElementRef"],
  _excluded123 = ["svgElementRef"],
  _excluded124 = ["svgElementRef"],
  _excluded125 = ["svgElementRef"],
  _excluded126 = ["svgElementRef"],
  _excluded127 = ["svgElementRef"],
  _excluded128 = ["svgElementRef"],
  _excluded129 = ["svgElementRef"],
  _excluded130 = ["svgElementRef"],
  _excluded131 = ["svgElementRef"],
  _excluded132 = ["svgElementRef"],
  _excluded133 = ["svgElementRef"],
  _excluded134 = ["svgElementRef"],
  _excluded135 = ["svgElementRef"],
  _excluded136 = ["svgElementRef"],
  _excluded137 = ["svgElementRef"],
  _excluded138 = ["svgElementRef"],
  _excluded139 = ["svgElementRef"],
  _excluded140 = ["svgElementRef"],
  _excluded141 = ["svgElementRef"],
  _excluded142 = ["svgElementRef"],
  _excluded143 = ["svgElementRef"],
  _excluded144 = ["svgElementRef"],
  _excluded145 = ["svgElementRef"],
  _excluded146 = ["svgElementRef"],
  _excluded147 = ["svgElementRef"],
  _excluded148 = ["svgElementRef"],
  _excluded149 = ["svgElementRef"],
  _excluded150 = ["svgElementRef"],
  _excluded151 = ["svgElementRef"],
  _excluded152 = ["svgElementRef"],
  _excluded153 = ["svgElementRef"],
  _excluded154 = ["svgElementRef"],
  _excluded155 = ["svgElementRef"],
  _excluded156 = ["svgElementRef"],
  _excluded157 = ["svgElementRef"],
  _excluded158 = ["svgElementRef"],
  _excluded159 = ["svgElementRef"],
  _excluded160 = ["svgElementRef"],
  _excluded161 = ["svgElementRef"],
  _excluded162 = ["svgElementRef"],
  _excluded163 = ["svgElementRef"],
  _excluded164 = ["svgElementRef"],
  _excluded165 = ["svgElementRef"],
  _excluded166 = ["svgElementRef"],
  _excluded167 = ["svgElementRef"],
  _excluded168 = ["svgElementRef"],
  _excluded169 = ["svgElementRef"],
  _excluded170 = ["svgElementRef"],
  _excluded171 = ["svgElementRef"],
  _excluded172 = ["svgElementRef"],
  _excluded173 = ["svgElementRef"],
  _excluded174 = ["svgElementRef"],
  _excluded175 = ["svgElementRef"],
  _excluded176 = ["svgElementRef"],
  _excluded177 = ["svgElementRef"],
  _excluded178 = ["svgElementRef"],
  _excluded179 = ["svgElementRef"],
  _excluded180 = ["svgElementRef"],
  _excluded181 = ["svgElementRef"],
  _excluded182 = ["svgElementRef"],
  _excluded183 = ["svgElementRef"],
  _excluded184 = ["svgElementRef"],
  _excluded185 = ["svgElementRef"],
  _excluded186 = ["svgElementRef"],
  _excluded187 = ["svgElementRef"],
  _excluded188 = ["svgElementRef"],
  _excluded189 = ["svgElementRef"],
  _excluded190 = ["svgElementRef"],
  _excluded191 = ["svgElementRef"],
  _excluded192 = ["svgElementRef"],
  _excluded193 = ["svgElementRef"],
  _excluded194 = ["svgElementRef"],
  _excluded195 = ["svgElementRef"],
  _excluded196 = ["svgElementRef"],
  _excluded197 = ["svgElementRef"],
  _excluded198 = ["svgElementRef"],
  _excluded199 = ["svgElementRef"],
  _excluded200 = ["svgElementRef"],
  _excluded201 = ["svgElementRef"],
  _excluded202 = ["svgElementRef"],
  _excluded203 = ["svgElementRef"],
  _excluded204 = ["svgElementRef"],
  _excluded205 = ["svgElementRef"],
  _excluded206 = ["svgElementRef"],
  _excluded207 = ["svgElementRef"],
  _excluded208 = ["svgElementRef"],
  _excluded209 = ["svgElementRef"],
  _excluded210 = ["svgElementRef"],
  _excluded211 = ["svgElementRef"],
  _excluded212 = ["svgElementRef"],
  _excluded213 = ["svgElementRef"],
  _excluded214 = ["svgElementRef"],
  _excluded215 = ["svgElementRef"],
  _excluded216 = ["svgElementRef"],
  _excluded217 = ["svgElementRef"],
  _excluded218 = ["svgElementRef"],
  _excluded219 = ["svgElementRef"],
  _excluded220 = ["svgElementRef"],
  _excluded221 = ["svgElementRef"],
  _excluded222 = ["svgElementRef"],
  _excluded223 = ["svgElementRef"],
  _excluded224 = ["svgElementRef"],
  _excluded225 = ["svgElementRef"],
  _excluded226 = ["svgElementRef"],
  _excluded227 = ["svgElementRef"],
  _excluded228 = ["svgElementRef"],
  _excluded229 = ["svgElementRef"],
  _excluded230 = ["svgElementRef"],
  _excluded231 = ["svgElementRef"],
  _excluded232 = ["svgElementRef"],
  _excluded233 = ["svgElementRef"],
  _excluded234 = ["svgElementRef"],
  _excluded235 = ["svgElementRef"],
  _excluded236 = ["svgElementRef"],
  _excluded237 = ["svgElementRef"],
  _excluded238 = ["svgElementRef"],
  _excluded239 = ["svgElementRef"],
  _excluded240 = ["svgElementRef"],
  _excluded241 = ["svgElementRef"],
  _excluded242 = ["svgElementRef"],
  _excluded243 = ["svgElementRef"],
  _excluded244 = ["svgElementRef"],
  _excluded245 = ["svgElementRef"],
  _excluded246 = ["svgElementRef"],
  _excluded247 = ["svgElementRef"],
  _excluded248 = ["svgElementRef"],
  _excluded249 = ["svgElementRef"],
  _excluded250 = ["svgElementRef"],
  _excluded251 = ["svgElementRef"],
  _excluded252 = ["svgElementRef"],
  _excluded253 = ["svgElementRef"],
  _excluded254 = ["svgElementRef"],
  _excluded255 = ["svgElementRef"],
  _excluded256 = ["svgElementRef"],
  _excluded257 = ["svgElementRef"],
  _excluded258 = ["svgElementRef"],
  _excluded259 = ["svgElementRef"],
  _excluded260 = ["svgElementRef"],
  _excluded261 = ["svgElementRef"],
  _excluded262 = ["svgElementRef"],
  _excluded263 = ["svgElementRef"],
  _excluded264 = ["svgElementRef"],
  _excluded265 = ["svgElementRef"],
  _excluded266 = ["svgElementRef"],
  _excluded267 = ["svgElementRef"],
  _excluded268 = ["svgElementRef"],
  _excluded269 = ["svgElementRef"],
  _excluded270 = ["svgElementRef"],
  _excluded271 = ["svgElementRef"],
  _excluded272 = ["svgElementRef"],
  _excluded273 = ["svgElementRef"],
  _excluded274 = ["svgElementRef"],
  _excluded275 = ["svgElementRef"],
  _excluded276 = ["svgElementRef"],
  _excluded277 = ["svgElementRef"],
  _excluded278 = ["svgElementRef"],
  _excluded279 = ["svgElementRef"],
  _excluded280 = ["svgElementRef"],
  _excluded281 = ["svgElementRef"],
  _excluded282 = ["svgElementRef"],
  _excluded283 = ["svgElementRef"],
  _excluded284 = ["svgElementRef"],
  _excluded285 = ["svgElementRef"],
  _excluded286 = ["svgElementRef"],
  _excluded287 = ["svgElementRef"],
  _excluded288 = ["svgElementRef"],
  _excluded289 = ["svgElementRef"],
  _excluded290 = ["svgElementRef"],
  _excluded291 = ["svgElementRef"],
  _excluded292 = ["svgElementRef"],
  _excluded293 = ["svgElementRef"],
  _excluded294 = ["svgElementRef"],
  _excluded295 = ["svgElementRef"],
  _excluded296 = ["svgElementRef"],
  _excluded297 = ["svgElementRef"],
  _excluded298 = ["svgElementRef"],
  _excluded299 = ["svgElementRef"],
  _excluded300 = ["svgElementRef"],
  _excluded301 = ["svgElementRef"],
  _excluded302 = ["svgElementRef"],
  _excluded303 = ["svgElementRef"],
  _excluded304 = ["svgElementRef"],
  _excluded305 = ["svgElementRef"],
  _excluded306 = ["svgElementRef"],
  _excluded307 = ["svgElementRef"],
  _excluded308 = ["svgElementRef"],
  _excluded309 = ["svgElementRef"],
  _excluded310 = ["svgElementRef"],
  _excluded311 = ["svgElementRef"],
  _excluded312 = ["svgElementRef"],
  _excluded313 = ["svgElementRef"],
  _excluded314 = ["svgElementRef"],
  _excluded315 = ["svgElementRef"],
  _excluded316 = ["svgElementRef"],
  _excluded317 = ["svgElementRef"],
  _excluded318 = ["svgElementRef"],
  _excluded319 = ["svgElementRef"],
  _excluded320 = ["svgElementRef"],
  _excluded321 = ["svgElementRef"],
  _excluded322 = ["svgElementRef"],
  _excluded323 = ["svgElementRef"],
  _excluded324 = ["svgElementRef"],
  _excluded325 = ["svgElementRef"],
  _excluded326 = ["svgElementRef"],
  _excluded327 = ["svgElementRef"],
  _excluded328 = ["svgElementRef"],
  _excluded329 = ["svgElementRef"],
  _excluded330 = ["svgElementRef"],
  _excluded331 = ["svgElementRef"],
  _excluded332 = ["svgElementRef"],
  _excluded333 = ["svgElementRef"],
  _excluded334 = ["svgElementRef"],
  _excluded335 = ["svgElementRef"],
  _excluded336 = ["svgElementRef"],
  _excluded337 = ["svgElementRef"],
  _excluded338 = ["svgElementRef"],
  _excluded339 = ["svgElementRef"],
  _excluded340 = ["svgElementRef"],
  _excluded341 = ["svgElementRef"],
  _excluded342 = ["svgElementRef"],
  _excluded343 = ["svgElementRef"],
  _excluded344 = ["svgElementRef"],
  _excluded345 = ["svgElementRef"],
  _excluded346 = ["svgElementRef"],
  _excluded347 = ["svgElementRef"],
  _excluded348 = ["svgElementRef"],
  _excluded349 = ["svgElementRef"],
  _excluded350 = ["svgElementRef"],
  _excluded351 = ["svgElementRef"],
  _excluded352 = ["svgElementRef"],
  _excluded353 = ["svgElementRef"],
  _excluded354 = ["svgElementRef"],
  _excluded355 = ["svgElementRef"],
  _excluded356 = ["svgElementRef"],
  _excluded357 = ["svgElementRef"],
  _excluded358 = ["svgElementRef"],
  _excluded359 = ["svgElementRef"],
  _excluded360 = ["svgElementRef"],
  _excluded361 = ["svgElementRef"],
  _excluded362 = ["svgElementRef"],
  _excluded363 = ["svgElementRef"],
  _excluded364 = ["svgElementRef"],
  _excluded365 = ["svgElementRef"],
  _excluded366 = ["svgElementRef"],
  _excluded367 = ["svgElementRef"],
  _excluded368 = ["svgElementRef"],
  _excluded369 = ["svgElementRef"],
  _excluded370 = ["svgElementRef"],
  _excluded371 = ["svgElementRef"],
  _excluded372 = ["svgElementRef"],
  _excluded373 = ["svgElementRef"];
var AcornsIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded$1);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "acorns icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.75 9.75A5.256 5.256 0 0 0 16.5 4.5h-3.75A2.25 2.25 0 0 1 15 2.25a.75.75 0 1 0 0-1.5 3.75 3.75 0 0 0-3.75 3.75H7.5a5.256 5.256 0 0 0-5.25 5.25A1.5 1.5 0 0 0 3 11.047V12c0 3.33 3.105 5.824 5.6 7.827 1.118.898 2.65 2.127 2.65 2.673a.75.75 0 1 0 1.5 0c0-.546 1.532-1.775 2.65-2.673C17.894 17.824 21 15.331 21 12v-.953a1.5 1.5 0 0 0 .75-1.297zM7.5 6h9a3.756 3.756 0 0 1 3.75 3.75H3.75A3.75 3.75 0 0 1 7.5 6zm6.96 12.656c-.995.799-1.874 1.5-2.46 2.191-.586-.686-1.465-1.392-2.46-2.19C7.293 16.854 4.5 14.611 4.5 12v-.75h15V12c0 2.612-2.794 4.855-5.04 6.656z",
    "data-ppui": "true"
  })), props.children);
};
var ActivityIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded2);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "activity icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.75 9.75A.75.75 0 0 1 7.5 9h9a.75.75 0 1 1 0 1.5h-9a.75.75 0 0 1-.75-.75zm.75 3.75h9a.75.75 0 1 0 0-1.5h-9a.75.75 0 1 0 0 1.5zm14.25-8.25V19.5a.75.75 0 0 1-1.086.67L18 18.838l-2.664 1.332a.75.75 0 0 1-.672 0L12 18.838 9.336 20.17a.75.75 0 0 1-.672 0L6 18.838 3.336 20.17a.75.75 0 0 1-1.086-.67V5.25a1.5 1.5 0 0 1 1.5-1.5h16.5a1.5 1.5 0 0 1 1.5 1.5zm-1.5 0H3.75v13.037l1.914-.958a.75.75 0 0 1 .672 0L9 18.662l2.664-1.333a.75.75 0 0 1 .672 0L15 18.662l2.664-1.333a.75.75 0 0 1 .672 0l1.914.958V5.25z",
    "data-ppui": "true"
  })), props.children);
};
var AddCameraIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded3);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "add camera icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.75 12.75a.75.75 0 0 1-.75.75h-2.25v2.25a.75.75 0 1 1-1.5 0V13.5H9A.75.75 0 1 1 9 12h2.25V9.75a.75.75 0 1 1 1.5 0V12H15a.75.75 0 0 1 .75.75zm6-5.25V18a2.25 2.25 0 0 1-2.25 2.25h-15A2.25 2.25 0 0 1 2.25 18V7.5A2.25 2.25 0 0 1 4.5 5.25h2.599l1.057-1.583A1.5 1.5 0 0 1 9.401 3H14.6a1.5 1.5 0 0 1 1.245.667L16.9 5.25h2.6a2.25 2.25 0 0 1 2.25 2.25zm-1.5 0a.75.75 0 0 0-.75-.75h-3a.75.75 0 0 1-.624-.334L14.599 4.5H9.4L8.124 6.416a.75.75 0 0 1-.624.334h-3a.75.75 0 0 0-.75.75V18a.75.75 0 0 0 .75.75h15a.75.75 0 0 0 .75-.75V7.5z",
    "data-ppui": "true"
  })), props.children);
};
var AddCashIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded4);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "add cash icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.78 12.53a.75.75 0 0 0-.53-1.28h-1.5v-1.5a.75.75 0 1 0-1.5 0v1.5h-1.5a.75.75 0 1 0 0 1.5h1.5v1.5a.75.75 0 1 0 1.5 0v-1.5h1.5a.75.75 0 0 0 .53-.22z",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M1.5 5.25h21a.75.75 0 0 1 .75.75v12a.75.75 0 0 1-.75.75h-21A.75.75 0 0 1 .75 18V6a.75.75 0 0 1 .75-.75zm4.345 12h12.31a5.324 5.324 0 0 1 3.595-3.595v-3.31a5.323 5.323 0 0 1-3.595-3.595H5.845a5.323 5.323 0 0 1-3.595 3.595v3.31a5.324 5.324 0 0 1 3.595 3.595zm13.902-10.5a3.826 3.826 0 0 0 2.003 2.003V6.75h-2.003zM2.25 8.753A3.826 3.826 0 0 0 4.253 6.75H2.25v2.003zm2.003 8.497a3.826 3.826 0 0 0-2.003-2.003v2.003h2.003zm17.497-2.003a3.826 3.826 0 0 0-2.003 2.003h2.003v-2.003z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};
var AddUserIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded5);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "add user icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 12.75a.75.75 0 0 1-.75.75h-1.5V15a.75.75 0 1 1-1.5 0v-1.5h-1.5a.75.75 0 1 1 0-1.5h1.5v-1.5a.75.75 0 1 1 1.5 0V12h1.5a.75.75 0 0 1 .75.75zm-5.425 5.517a.75.75 0 0 1-1.15.966c-1.886-2.246-4.48-3.483-7.3-3.483-2.82 0-5.414 1.237-7.3 3.483a.75.75 0 1 1-1.149-.966c1.4-1.667 3.143-2.85 5.079-3.484a6.375 6.375 0 1 1 6.74 0c1.936.633 3.678 1.817 5.08 3.484zm-8.45-4.017a4.875 4.875 0 1 0 0-9.75 4.875 4.875 0 0 0 0 9.75z",
    "data-ppui": "true"
  })), props.children);
};
var AddVideoIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded6);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "add video icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.612 12.53a.75.75 0 0 0-.53-1.28h-1.5v-1.5a.75.75 0 1 0-1.5 0v1.5h-1.5a.75.75 0 1 0 0 1.5h1.5v1.5a.75.75 0 1 0 1.5 0v-1.5h1.5a.75.75 0 0 0 .53-.22z",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M23.213 6.756A.75.75 0 0 1 24 7.5v9a.75.75 0 0 1-.75.75.75.75 0 0 1-.416-.12L19.5 14.905v2.344a1.5 1.5 0 0 1-1.5 1.5H3a1.5 1.5 0 0 1-1.5-1.5V6.75A1.5 1.5 0 0 1 3 5.25h15a1.5 1.5 0 0 1 1.5 1.5v2.348l3.334-2.218a.75.75 0 0 1 .38-.124zM3 17.25h15V6.75H3v10.5zm16.5-4.151l3 2V8.905l-3 1.995v2.2z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};
var AddIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded7);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "add icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 12a.75.75 0 0 1-.75.75h-7.5v7.5a.75.75 0 1 1-1.5 0v-7.5h-7.5a.75.75 0 1 1 0-1.5h7.5v-7.5a.75.75 0 1 1 1.5 0v7.5h7.5A.75.75 0 0 1 21 12z",
    "data-ppui": "true"
  })), props.children);
};
var AlarmClockIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded8);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "alarm clock icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 3.75a9 9 0 1 0 9 9 9.01 9.01 0 0 0-9-9zm0 16.5a7.5 7.5 0 1 1 7.5-7.5 7.51 7.51 0 0 1-7.5 7.5zM5.78 3.53l-3 3a.75.75 0 1 1-1.06-1.06l3-3a.75.75 0 1 1 1.06 1.06zm16.5 3a.75.75 0 0 1-1.06 0l-3-3a.75.75 0 0 1 1.06-1.06l3 3a.751.751 0 0 1 0 1.06zM17.25 12a.75.75 0 0 1 0 1.5H12a.75.75 0 0 1-.75-.75V7.5a.75.75 0 1 1 1.5 0V12h4.5z",
    "data-ppui": "true"
  })), props.children);
};
var AnimalsIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded9);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "animals icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5 6.375a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0zm6 1.125a.749.749 0 0 1-.334.624L20.25 9.401v1.849A9.76 9.76 0 0 1 10.5 21H2.25a1.5 1.5 0 0 1-1.17-2.438l.008-.01L9 9.058V7.21c0-3.134 2.512-5.694 5.598-5.709h.027a5.625 5.625 0 0 1 5.363 3.924l2.178 1.452a.75.75 0 0 1 .334.624zm-2.102 0l-1.47-.98a.75.75 0 0 1-.31-.436A4.125 4.125 0 0 0 14.625 3h-.02C12.34 3.011 10.5 4.898 10.5 7.208V9.33a.75.75 0 0 1-.173.48L2.25 19.5h2.522l6.65-7.98a.748.748 0 0 1 1.333.408.749.749 0 0 1-.18.552L6.727 19.5H10.5a8.26 8.26 0 0 0 8.25-8.25V9a.749.749 0 0 1 .334-.624l1.314-.876z",
    "data-ppui": "true"
  })), props.children);
};
var AppMenuIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded10);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "app menu icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.75 5.625a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0zM12 4.5a1.125 1.125 0 1 0 0 2.25 1.125 1.125 0 0 0 0-2.25zm6.375 2.25a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25zm-12.75 4.125a1.125 1.125 0 1 0 0 2.25 1.125 1.125 0 0 0 0-2.25zm6.375 0a1.125 1.125 0 1 0 0 2.25 1.125 1.125 0 0 0 0-2.25zm6.375 0a1.125 1.125 0 1 0 0 2.25 1.125 1.125 0 0 0 0-2.25zM5.625 17.25a1.125 1.125 0 1 0 0 2.25 1.125 1.125 0 0 0 0-2.25zm6.375 0a1.125 1.125 0 1 0 0 2.25 1.125 1.125 0 0 0 0-2.25zm6.375 0a1.125 1.125 0 1 0 0 2.25 1.125 1.125 0 0 0 0-2.25z",
    "data-ppui": "true"
  })), props.children);
};
var AppliancesIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded11);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "appliances icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.19 13.955l-4.5-10.5A.75.75 0 0 0 18 3H6a.75.75 0 0 0-.689.455l-4.5 10.5A.75.75 0 0 0 1.5 15h9.75v4.5H9A.75.75 0 1 0 9 21h6a.75.75 0 1 0 0-1.5h-2.25V15H18v3a.75.75 0 1 0 1.5 0v-3h3a.75.75 0 0 0 .69-1.045zM2.636 13.5l3.858-9h11.01l3.858 9H2.637z",
    "data-ppui": "true"
  })), props.children);
};
var ArchiveIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded12);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "archive icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 4.5H3A1.5 1.5 0 0 0 1.5 6v2.25A1.5 1.5 0 0 0 3 9.75V18a1.5 1.5 0 0 0 1.5 1.5h15A1.5 1.5 0 0 0 21 18V9.75a1.5 1.5 0 0 0 1.5-1.5V6A1.5 1.5 0 0 0 21 4.5zM19.5 18h-15V9.75h15V18zM21 8.25H3V6h18v2.25zm-12 4.5a.75.75 0 0 1 .75-.75h4.5a.75.75 0 1 1 0 1.5h-4.5a.75.75 0 0 1-.75-.75z",
    "data-ppui": "true"
  })), props.children);
};
var ArrowDownSmIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded13);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "arrow down sm icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 18 18",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.28 9.53l-6.75 5.75a.751.751 0 0 1-1.06 0L1.72 9.53a.75.75 0 1 1 1.06-1.06l5.47 4.47V3.25a.75.75 0 1 1 1.5 0v9.69l5.47-4.47a.75.75 0 1 1 1.06 1.06z",
    "data-ppui": "true"
  })), props.children);
};
var ArrowDownIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded14);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "arrow down icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.28 14.03l-6.75 6.75a.747.747 0 0 1-1.06 0l-6.75-6.75a.75.75 0 1 1 1.06-1.06l5.47 5.47V3.75a.75.75 0 1 1 1.5 0v14.69l5.47-5.47a.75.75 0 1 1 1.06 1.06z",
    "data-ppui": "true"
  })), props.children);
};
var ArrowLeftIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded15);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "arrow left icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 12a.75.75 0 0 1-.75.75H5.56l5.47 5.47a.75.75 0 1 1-1.06 1.06l-6.75-6.75a.75.75 0 0 1 0-1.06l6.75-6.75a.75.75 0 1 1 1.06 1.06l-5.47 5.47h14.69A.75.75 0 0 1 21 12z",
    "data-ppui": "true"
  })), props.children);
};
var ArrowRightIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded16);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "arrow right icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.78 12.53l-6.75 6.75a.75.75 0 0 1-1.06-1.06l5.47-5.47H3.75a.75.75 0 1 1 0-1.5h14.69l-5.47-5.47a.75.75 0 1 1 1.06-1.06l6.75 6.75a.75.75 0 0 1 0 1.06z",
    "data-ppui": "true"
  })), props.children);
};
var ArrowUpSmIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded17);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "arrow up sm icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 18 18",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.72 8.47l6.75-5.75a.75.75 0 0 1 1.06 0l6.75 5.75a.75.75 0 1 1-1.06 1.06L9.75 5.06v9.69a.75.75 0 1 1-1.5 0V5.06L2.78 9.53a.75.75 0 0 1-1.06-1.06z",
    "data-ppui": "true"
  })), props.children);
};
var ArrowUpIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded18);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "arrow up icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.28 11.03a.748.748 0 0 1-1.06 0l-5.47-5.47v14.69a.75.75 0 1 1-1.5 0V5.56l-5.47 5.47a.75.75 0 1 1-1.06-1.06l6.75-6.75a.749.749 0 0 1 1.06 0l6.75 6.75a.749.749 0 0 1 0 1.06z",
    "data-ppui": "true"
  })), props.children);
};
var ArrowsInIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded19);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "arrows in icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.03 5.03l-4.72 4.72H18a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1-.75-.75V6a.75.75 0 1 1 1.5 0v2.69l4.72-4.72a.75.75 0 1 1 1.06 1.06zm-9.53 7.72H6a.75.75 0 1 0 0 1.5h2.69l-4.72 4.72a.75.75 0 1 0 1.06 1.06l4.72-4.72V18a.75.75 0 0 0 1.5 0v-4.5a.75.75 0 0 0-.75-.75z",
    "data-ppui": "true"
  })), props.children);
};
var ArrowsOutIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded20);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "arrows out icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.25 4.5V9a.75.75 0 1 1-1.5 0V6.31l-4.72 4.72a.75.75 0 1 1-1.06-1.06l4.72-4.72H15a.75.75 0 1 1 0-1.5h4.5a.75.75 0 0 1 .75.75zM9.97 12.97l-4.72 4.72V15a.75.75 0 1 0-1.5 0v4.5a.75.75 0 0 0 .75.75H9a.75.75 0 1 0 0-1.5H6.31l4.72-4.72a.75.75 0 1 0-1.06-1.06z",
    "data-ppui": "true"
  })), props.children);
};
var ArrowsUpDownIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded21);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "arrows up down icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.03 8.03a.751.751 0 0 0 0-1.06l-3-3a.75.75 0 0 0-1.06 0l-3 3a.75.75 0 1 0 1.06 1.06l1.72-1.72V19.5a.75.75 0 0 0 1.5 0V6.31l1.718 1.72a.749.749 0 0 0 1.062 0zm9 9l-3 3a.75.75 0 0 1-1.06 0l-3-3a.75.75 0 0 1 1.06-1.06l1.72 1.72V4.5a.75.75 0 1 1 1.5 0v13.19l1.719-1.72a.75.75 0 0 1 1.061 1.06z",
    "data-ppui": "true"
  })), props.children);
};
var ArtIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded22);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "art icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.822 5.052A9.682 9.682 0 0 0 12 2.25h-.1A9.75 9.75 0 0 0 2.25 12c0 4.031 2.492 7.412 6.502 8.828A3 3 0 0 0 12.75 18a1.5 1.5 0 0 1 1.5-1.5h4.332a2.982 2.982 0 0 0 2.925-2.332c.168-.739.25-1.494.243-2.25a9.685 9.685 0 0 0-2.928-6.866zm1.219 8.785A1.49 1.49 0 0 1 18.582 15H14.25a3 3 0 0 0-3 3 1.5 1.5 0 0 1-1.998 1.413C5.858 18.216 3.75 15.375 3.75 12a8.25 8.25 0 0 1 8.165-8.25h.084a8.283 8.283 0 0 1 8.25 8.18 8.334 8.334 0 0 1-.204 1.908h-.004zm-6.916-6.712a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0zM9 9.375a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0zm0 5.25a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0zm8.25-5.25a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0z",
    "data-ppui": "true"
  })), props.children);
};
var AttachIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded23);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "attach icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.656 11.47a.75.75 0 0 1 0 1.06l-7.692 7.688a5.25 5.25 0 0 1-7.426-7.426l9.306-9.442a3.75 3.75 0 1 1 5.307 5.301l-9.307 9.443a2.254 2.254 0 1 1-3.188-3.188l7.81-7.933a.75.75 0 1 1 1.068 1.052l-7.81 7.942a.751.751 0 0 0 1.057 1.065l9.306-9.438a2.251 2.251 0 1 0-3.18-3.188l-9.304 9.439a3.751 3.751 0 0 0 5.3 5.308l7.692-7.687a.75.75 0 0 1 1.06.003z",
    "data-ppui": "true"
  })), props.children);
};
var AutoIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded24);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "auto icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5 9.75h-1.012l-2.605-5.86a1.5 1.5 0 0 0-1.37-.89H6.486a1.5 1.5 0 0 0-1.37.89L2.513 9.75H1.5a.75.75 0 0 0 0 1.5h.75v7.5a1.5 1.5 0 0 0 1.5 1.5H6a1.5 1.5 0 0 0 1.5-1.5v-1.5h9v1.5a1.5 1.5 0 0 0 1.5 1.5h2.25a1.5 1.5 0 0 0 1.5-1.5v-7.5h.75a.75.75 0 1 0 0-1.5zM6.488 4.5h11.024l2.334 5.25H4.154L6.487 4.5zM6 18.75H3.75v-1.5H6v1.5zm12 0v-1.5h2.25v1.5H18zm2.25-3H3.75v-4.5h16.5v4.5zm-15-2.25a.75.75 0 0 1 .75-.75h1.5a.75.75 0 1 1 0 1.5H6a.75.75 0 0 1-.75-.75zm10.5 0a.75.75 0 0 1 .75-.75H18a.75.75 0 1 1 0 1.5h-1.5a.75.75 0 0 1-.75-.75z",
    "data-ppui": "true"
  })), props.children);
};
var AutopayNoIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded25);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "autopay no icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.75 12.812A9.76 9.76 0 1 1 11.188 2.25a.753.753 0 1 1 .124 1.5 8.261 8.261 0 1 0 8.938 8.938.753.753 0 0 1 1.5.124zM11.25 6.75V12a.75.75 0 0 0 .75.75h5.25a.75.75 0 1 0 0-1.5h-4.5v-4.5a.75.75 0 1 0-1.5 0zM15 4.5a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25zm3.375 2.25a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25zm2.25 3.375a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25z",
    "data-ppui": "true"
  })), props.children);
};
var AutopayIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded26);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "autopay icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.75 7.5v4.075l3.386 2.032a.75.75 0 1 1-.772 1.286l-3.75-2.25A.75.75 0 0 1 11.25 12V7.5a.75.75 0 1 1 1.5 0zM21 5.25a.75.75 0 0 0-.75.75v1.688a40.708 40.708 0 0 0-1.886-2.047 9 9 0 1 0-.188 12.91.75.75 0 1 0-1.031-1.092 7.502 7.502 0 0 1-12.643-5.566 7.5 7.5 0 0 1 12.799-5.2A42.171 42.171 0 0 1 19.406 9H17.25a.75.75 0 1 0 0 1.5H21a.75.75 0 0 0 .75-.75V6a.75.75 0 0 0-.75-.75z",
    "data-ppui": "true"
  })), props.children);
};
var BabyProductsIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded27);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "baby products icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 3h-.75a1.5 1.5 0 0 0-1.5 1.5v5.25H5.175a3.756 3.756 0 0 0-3.675-3 .75.75 0 0 0 0 1.5 2.25 2.25 0 0 1 2.25 2.25 7.508 7.508 0 0 0 7.5 7.5H15a7.5 7.5 0 0 0 0-15zm5.951 6.75h-5.313l3.925-3.14a5.975 5.975 0 0 1 1.388 3.14zM15 4.5a5.961 5.961 0 0 1 3.44 1.088L14.25 8.94V4.5H15zm0 12h-3.75a6.009 6.009 0 0 1-5.953-5.25h15.656A6.009 6.009 0 0 1 15 16.5zM9.75 21a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm9.75 0a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z",
    "data-ppui": "true"
  })), props.children);
};
var BackspaceIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded28);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "backspace icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.25 3.75H6.425a1.511 1.511 0 0 0-1.287.728L.857 11.614a.75.75 0 0 0 0 .772l4.281 7.136a1.511 1.511 0 0 0 1.287.728H20.25a1.5 1.5 0 0 0 1.5-1.5V5.25a1.5 1.5 0 0 0-1.5-1.5zm-4.72 9.97a.75.75 0 1 1-1.06 1.06l-1.72-1.72-1.72 1.72a.75.75 0 0 1-1.06-1.06L11.69 12l-1.72-1.72a.75.75 0 1 1 1.06-1.06l1.72 1.72 1.72-1.72a.75.75 0 1 1 1.06 1.06L13.81 12l1.72 1.72z",
    "data-ppui": "true"
  })), props.children);
};
var BankDepositIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded29);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "bank deposit icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.72 6.03a.75.75 0 0 0-.53-1.281h-1.5v-1.5a.75.75 0 1 0-1.5 0v1.5h-1.5a.75.75 0 0 0 0 1.5h1.5v1.5a.75.75 0 0 0 1.5 0v-1.5h1.5a.75.75 0 0 0 .53-.22z",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2.32 12.811a.749.749 0 0 1-.393-1.387l8.18-5.034a.75.75 0 0 1 .785 0l8.181 5.034a.75.75 0 0 1-.392 1.387h-1.768v4.795h1.138a.75.75 0 0 1 0 1.498H2.95a.75.75 0 0 1 0-1.498h1.138V12.81H2.32zm5.543 0H5.586v4.795h2.277V12.81zm3.776 0H9.36v4.795h2.277V12.81zm1.498 4.795h2.277V12.81h-2.277v4.795zm2.897-6.293L10.5 7.907l-5.534 3.406h11.068z",
    clipRule: "evenodd",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.06 20.872a.75.75 0 0 1-.75.75H1.69a.75.75 0 0 1 0-1.5h17.62a.75.75 0 0 1 .75.75z",
    "data-ppui": "true"
  })), props.children);
};
var BankInfoIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded30);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "bank info icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2.25 9.75H4.5v6H3a.75.75 0 1 0 0 1.5h11.25a.75.75 0 0 0 .75-.75V9.75h6.76a.75.75 0 0 0 .383-1.388l-9.75-6a.75.75 0 0 0-.786 0l-9.75 6A.75.75 0 0 0 2.25 9.75zm3.75 6h3v-6H6v6zm4.5-6v6h3v-6h-3zM12 3.88l7.1 4.37H4.9L12 3.88z",
    clipRule: "evenodd",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.25 20.25a.75.75 0 1 0 0-1.5H1.5a.75.75 0 1 0 0 1.5h12.75zm6.554 1.28a.75.75 0 0 0-.53-1.28v-3a1.5 1.5 0 0 0-1.5-1.5.75.75 0 0 0 0 1.5v3a1.5 1.5 0 0 0 1.5 1.5.75.75 0 0 0 .53-.22zm-2.591-9.03a1.125 1.125 0 1 0 1.871 1.25 1.125 1.125 0 0 0-1.87-1.25z",
    "data-ppui": "true"
  })), props.children);
};
var BankIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded31);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "bank icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.25 9.75H4.5v6H3a.75.75 0 1 0 0 1.5h18a.75.75 0 1 0 0-1.5h-1.5v-6h2.25a.75.75 0 0 0 .393-1.388l-9.75-6a.75.75 0 0 0-.786 0l-9.75 6A.75.75 0 0 0 2.25 9.75zm3.75 0h3v6H6v-6zm7.5 0v6h-3v-6h3zm4.5 6h-3v-6h3v6zM12 3.88l7.1 4.37H4.9L12 3.88zM23.25 19.5a.75.75 0 0 1-.75.75h-21a.75.75 0 1 1 0-1.5h21a.75.75 0 0 1 .75.75z",
    "data-ppui": "true"
  })), props.children);
};
var BeautyIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded32);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "beauty icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.75 8.25a3 3 0 1 0-6 0 3 3 0 0 0 6 0zm-3 1.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm.883 9.62l2.96-6.52a6 6 0 0 0-3.843-10.6.788.788 0 0 0-.124.01L2.753 4.406A1.5 1.5 0 0 0 1.5 5.886v4.728a1.5 1.5 0 0 0 1.253 1.48L12 13.635v5.115a1.5 1.5 0 0 0 1.5 1.5A3.75 3.75 0 0 0 17.25 24h1.5a.75.75 0 1 0 0-1.5h-1.5A2.25 2.25 0 0 1 15 20.25h.267a1.5 1.5 0 0 0 1.366-.88zM3 5.887L15.81 3.75a4.5 4.5 0 1 1 0 9L3 10.615v-4.73zm12.626 8.354a.79.79 0 0 0 .124.01 5.97 5.97 0 0 0 1.67-.238l-2.156 4.738H13.5v-4.865l2.126.355z",
    "data-ppui": "true"
  })), props.children);
};
var BigPurchaseIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded33);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "big purchase icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.724 10.368L19.5 9.959V5.25a1.5 1.5 0 0 0-1.5-1.5h-5.25v-1.5a.75.75 0 1 0-1.5 0v1.5H6a1.5 1.5 0 0 0-1.5 1.5v4.71l-1.224.408A1.5 1.5 0 0 0 2.25 11.79v2.459c0 5.77 9.177 8.13 9.568 8.227.12.03.245.03.364 0 .39-.097 9.568-2.458 9.568-8.227v-2.46a1.5 1.5 0 0 0-1.026-1.422zM6 5.25h12v4.21l-5.763-1.922a.75.75 0 0 0-.474 0L6 9.46V5.25zm14.25 9c0 2.335-2.22 4.031-4.083 5.047A21.392 21.392 0 0 1 12 20.974a21.275 21.275 0 0 1-4.143-1.662C4.463 17.47 3.75 15.543 3.75 14.25v-2.46l7.5-2.5v6.46a.75.75 0 1 0 1.5 0V9.29l7.5 2.5v2.46z",
    "data-ppui": "true"
  })), props.children);
};
var BillPaymentIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded34);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "bill payment icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.03 7.72l-5.25-5.25a.75.75 0 0 0-.53-.22h-9a1.5 1.5 0 0 0-1.5 1.5v16.5a1.5 1.5 0 0 0 1.5 1.5h13.5a1.5 1.5 0 0 0 1.5-1.5v-12a.75.75 0 0 0-.22-.53zM15 4.81l2.69 2.69H15V4.81zm3.75 15.44H5.25V3.75h8.25v4.5a.75.75 0 0 0 .75.75h4.5v11.25zm-3-7.5a.75.75 0 0 1-.75.75H9A.75.75 0 1 1 9 12h6a.75.75 0 0 1 .75.75zm0 3a.75.75 0 0 1-.75.75H9A.75.75 0 1 1 9 15h6a.75.75 0 0 1 .75.75z",
    "data-ppui": "true"
  })), props.children);
};
var BirthdayIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded35);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "birthday icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.75 10.5a2.25 2.25 0 0 0-2.25-2.25h-6.75v-.844A3.006 3.006 0 0 0 15 4.5C15 1.875 12.521.196 12.416.126a.75.75 0 0 0-.832 0C11.479.196 9 1.875 9 4.5a3.006 3.006 0 0 0 2.25 2.906v.844H4.5a2.25 2.25 0 0 0-2.25 2.25v2.187c0 .818.264 1.615.75 2.273v3.79A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75v-3.79c.486-.658.75-1.455.75-2.273V10.5zm-11.25-6c0-1.272.938-2.293 1.5-2.793.563.5 1.5 1.52 1.5 2.793a1.5 1.5 0 1 1-3 0zm-6.75 6a.75.75 0 0 1 .75-.75h15a.75.75 0 0 1 .75.75v2.187c0 1.242-.98 2.28-2.186 2.312a2.25 2.25 0 0 1-2.314-2.249.75.75 0 1 0-1.5 0 2.25 2.25 0 0 1-4.5 0 .75.75 0 1 0-1.5 0A2.25 2.25 0 0 1 5.936 15c-1.205-.034-2.186-1.07-2.186-2.313V10.5zm15 9H5.25a.75.75 0 0 1-.75-.75v-2.573c.439.2.913.31 1.395.323A3.72 3.72 0 0 0 9 15a3.751 3.751 0 0 0 6 0c.118.156.247.302.387.438A3.72 3.72 0 0 0 18 16.5h.107a3.635 3.635 0 0 0 1.393-.323v2.573a.75.75 0 0 1-.75.75z",
    "data-ppui": "true"
  })), /*#__PURE__*/React.createElement("defs", {
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "a",
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    "data-ppui": "true"
  })))), props.children);
};
var BitcoinCashIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded36);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "bitcoin cash icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.396 9.842a4.124 4.124 0 0 0-4.23-6.195l-.393-1.466a.75.75 0 0 0-1.45.388l.389 1.45-1.449.387-.388-1.449a.75.75 0 1 0-1.449.389l.388 1.449-2.898.776a.75.75 0 1 0 .389 1.449l.724-.194 3.3 12.315-.724.195a.75.75 0 1 0 .388 1.448l2.898-.776.388 1.449a.75.75 0 0 0 1.449-.388l-.389-1.45 1.45-.388.388 1.45a.75.75 0 1 0 1.448-.389l-.388-1.449.725-.194a4.5 4.5 0 0 0-.566-8.807zm-.994-2.81a2.625 2.625 0 0 1-1.856 3.215l-4.71 1.262-1.358-5.071 4.709-1.262a2.625 2.625 0 0 1 3.215 1.856zM16.573 17.2l-5.795 1.553-1.553-5.795 5.796-1.553a3 3 0 0 1 1.552 5.795z",
    "data-ppui": "true"
  })), props.children);
};
var BitcoinIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded37);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "bitcoin icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.801 11.86a4.126 4.126 0 0 0-.645-7.473l.377-1.47a.75.75 0 1 0-1.453-.373l-.373 1.453-1.453-.373.373-1.453a.75.75 0 1 0-1.453-.373L11.8 3.251l-2.906-.745a.75.75 0 0 0-.373 1.453l.727.186-3.168 12.35-.727-.186a.75.75 0 1 0-.373 1.453l2.906.745-.372 1.453a.75.75 0 0 0 1.452.373l.373-1.453 1.453.373-.373 1.453a.75.75 0 0 0 1.453.373l.373-1.453.727.186a4.5 4.5 0 0 0 3.828-7.951zm.513-2.936a2.625 2.625 0 0 1-3.195 1.89l-4.722-1.21 1.305-5.086 4.722 1.211a2.625 2.625 0 0 1 1.89 3.195zm-3.969 9.435l-5.811-1.49 1.49-5.813 5.812 1.491a3 3 0 0 1-1.49 5.812z",
    "data-ppui": "true"
  })), props.children);
};
var BlockIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded38);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "block icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 2.25A9.75 9.75 0 1 0 21.75 12 9.76 9.76 0 0 0 12 2.25zM20.25 12a8.209 8.209 0 0 1-1.913 5.276L6.724 5.662A8.25 8.25 0 0 1 20.25 12zm-16.5 0a8.209 8.209 0 0 1 1.913-5.276l11.613 11.613A8.25 8.25 0 0 1 3.75 12z",
    "data-ppui": "true"
  })), props.children);
};
var BooksIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded39);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "books icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.75 4.5H15A3.75 3.75 0 0 0 12 6a3.75 3.75 0 0 0-3-1.5H2.25a.75.75 0 0 0-.75.75v13.5a.75.75 0 0 0 .75.75H9a2.25 2.25 0 0 1 2.25 2.25.75.75 0 1 0 1.5 0A2.25 2.25 0 0 1 15 19.5h6.75a.75.75 0 0 0 .75-.75V5.25a.75.75 0 0 0-.75-.75zM9 18H3V6h6a2.25 2.25 0 0 1 2.25 2.25v10.5A3.732 3.732 0 0 0 9 18zm12 0h-6a3.732 3.732 0 0 0-2.25.75V8.25A2.25 2.25 0 0 1 15 6h6v12z",
    "data-ppui": "true"
  })), props.children);
};
var BoxIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded40);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "box icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.97 6.201l-8.25-4.514a1.489 1.489 0 0 0-1.44 0L3.03 6.203a1.5 1.5 0 0 0-.78 1.313v8.966a1.5 1.5 0 0 0 .78 1.313l8.25 4.515a1.489 1.489 0 0 0 1.44 0l8.25-4.515a1.5 1.5 0 0 0 .78-1.313V7.517a1.5 1.5 0 0 0-.78-1.316zM12 3l7.532 4.125-2.791 1.528-7.533-4.125L12 3zm0 8.25L4.468 7.125l3.178-1.74 7.532 4.125L12 11.25zM3.75 8.437l7.5 4.105v8.043l-7.5-4.102V8.437zm16.5 8.042l-7.5 4.106v-8.04l3-1.641v3.346a.75.75 0 1 0 1.5 0v-4.167l3-1.646v8.042z",
    "data-ppui": "true"
  })), props.children);
};
var BusinessIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded41);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "business icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.25 5.25H16.5V4.5a2.25 2.25 0 0 0-2.25-2.25h-4.5A2.25 2.25 0 0 0 7.5 4.5v.75H3.75a1.5 1.5 0 0 0-1.5 1.5v12a1.5 1.5 0 0 0 1.5 1.5h16.5a1.5 1.5 0 0 0 1.5-1.5v-12a1.5 1.5 0 0 0-1.5-1.5zM9 4.5a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 .75.75v.75H9V4.5zm11.25 2.25v3.9a17.257 17.257 0 0 1-16.5.001V6.75h16.5zm0 12H3.75v-6.409a18.772 18.772 0 0 0 16.5 0v6.409zM9.75 10.5a.75.75 0 0 1 .75-.75h3a.75.75 0 1 1 0 1.5h-3a.75.75 0 0 1-.75-.75z",
    "data-ppui": "true"
  })), props.children);
};
var ButtonIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded42);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "button icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.16 12.589a.757.757 0 0 1 0-1.164l2.295-1.913a.758.758 0 0 1 .97 1.165l-1.597 1.33 1.594 1.329a.758.758 0 1 1-.97 1.164L6.16 12.589zm11.68-1.164a.756.756 0 0 1 0 1.164l-2.292 1.91a.757.757 0 1 1-.97-1.163l1.594-1.329-1.596-1.33a.757.757 0 1 1 .97-1.165l2.295 1.913zm-3.6-3.369a.75.75 0 0 0-1.41-.513l-3.074 8.433a.75.75 0 0 0 1.41.514l3.073-8.434z",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M15.001 3.759H9a8.249 8.249 0 0 0 0 16.497h6a8.249 8.249 0 1 0 0-16.497zM2.25 12.007A6.749 6.749 0 0 1 8.999 5.26H15a6.749 6.749 0 0 1 0 13.497H9a6.749 6.749 0 0 1-6.749-6.749z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};
var CalculatorIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded43);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "calculator icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 11.25h9a.75.75 0 0 0 .75-.75V6a.75.75 0 0 0-.75-.75h-9a.75.75 0 0 0-.75.75v4.5a.75.75 0 0 0 .75.75zm.75-4.5h7.5v3h-7.5v-3zm10.5-4.5H5.25a1.5 1.5 0 0 0-1.5 1.5v16.5a1.5 1.5 0 0 0 1.5 1.5h13.5a1.5 1.5 0 0 0 1.5-1.5V3.75a1.5 1.5 0 0 0-1.5-1.5zm0 18H5.25V3.75h13.5v16.5zm-9.375-6.375a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0zm3.75 0a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0zm3.75 0a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0zm-7.5 3.75a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0zm3.75 0a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0zm3.75 0a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0z",
    "data-ppui": "true"
  })), props.children);
};
var CalendarPausedIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded44);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "calendar paused icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.125 12v4.5a.75.75 0 1 0 1.5 0V12a.75.75 0 1 0-1.5 0zm-3.75 0v4.5a.75.75 0 1 0 1.5 0V12a.75.75 0 1 0-1.5 0z",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M17.25 3h2.25A1.5 1.5 0 0 1 21 4.5v15a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 3 19.5v-15A1.5 1.5 0 0 1 4.5 3h2.25v-.75a.75.75 0 0 1 1.5 0V3h7.5v-.75a.75.75 0 1 1 1.5 0V3zM6.75 5.25V4.5H4.5v3h15v-3h-2.25v.75a.75.75 0 1 1-1.5 0V4.5h-7.5v.75a.75.75 0 0 1-1.5 0zM4.5 19.5h15V9h-15v10.5z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};
var CalendarSmIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded45);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "calendar sm icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 18 18",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M13.137 2.05h1.488a1.325 1.325 0 0 1 1.325 1.325v11.25a1.325 1.325 0 0 1-1.325 1.325H3.375a1.325 1.325 0 0 1-1.325-1.325V3.375A1.325 1.325 0 0 1 3.375 2.05h1.487v-.363a.762.762 0 1 1 1.525 0v.363h5.226v-.363a.762.762 0 1 1 1.524 0v.363zM4.862 3.937v-.362H3.575v1.85h10.85v-1.85h-1.288v.362a.762.762 0 1 1-1.524 0v-.362H6.387v.362a.763.763 0 0 1-1.525 0zM3.575 14.425h10.85V6.95H3.575v7.475z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};
var CalendarIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded46);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "calendar icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5 3h-2.25v-.75a.75.75 0 1 0-1.5 0V3h-7.5v-.75a.75.75 0 0 0-1.5 0V3H4.5A1.5 1.5 0 0 0 3 4.5v15A1.5 1.5 0 0 0 4.5 21h15a1.5 1.5 0 0 0 1.5-1.5v-15A1.5 1.5 0 0 0 19.5 3zM6.75 4.5v.75a.75.75 0 0 0 1.5 0V4.5h7.5v.75a.75.75 0 1 0 1.5 0V4.5h2.25v3h-15v-3h2.25zm12.75 15h-15V9h15v10.5zm-6.375-7.125a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0zm4.125 0a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0zM9 16.125a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0zm4.125 0a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0zm4.125 0a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0z",
    "data-ppui": "true"
  })), props.children);
};
var CameraIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded47);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "camera icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5 5.25h-2.599l-1.278-1.916A.749.749 0 0 0 15 3H9a.75.75 0 0 0-.623.334L7.097 5.25H4.5A2.25 2.25 0 0 0 2.25 7.5V18a2.25 2.25 0 0 0 2.25 2.25h15A2.25 2.25 0 0 0 21.75 18V7.5a2.25 2.25 0 0 0-2.25-2.25zM20.25 18a.75.75 0 0 1-.75.75h-15a.75.75 0 0 1-.75-.75V7.5a.75.75 0 0 1 .75-.75h3a.75.75 0 0 0 .624-.334L9.401 4.5h5.197l1.278 1.916a.75.75 0 0 0 .624.334h3a.75.75 0 0 1 .75.75V18zM12 8.25a4.125 4.125 0 1 0 0 8.25 4.125 4.125 0 0 0 0-8.25zM12 15a2.625 2.625 0 1 1 0-5.25A2.625 2.625 0 0 1 12 15z",
    "data-ppui": "true"
  })), props.children);
};
var CardStackIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded48);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "card stack icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.25 6.75H3.75a1.5 1.5 0 0 0-1.5 1.5v10.5a1.5 1.5 0 0 0 1.5 1.5h13.5a1.5 1.5 0 0 0 1.5-1.5V8.25a1.5 1.5 0 0 0-1.5-1.5zm0 12H3.75V8.25h13.5v10.5zm4.5-13.5V16.5a.75.75 0 1 1-1.5 0V5.25H6a.75.75 0 0 1 0-1.5h14.25a1.5 1.5 0 0 1 1.5 1.5z",
    "data-ppui": "true"
  })), props.children);
};
var CardholderIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded49);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "cardholder icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25v10.5A2.25 2.25 0 0 0 4.5 19.5h15a2.25 2.25 0 0 0 2.25-2.25V6.75A2.25 2.25 0 0 0 19.5 4.5zM3.75 9h16.5v1.5H15a.75.75 0 0 0-.75.75 2.25 2.25 0 0 1-4.5 0A.75.75 0 0 0 9 10.5H3.75V9zm.75-3h15a.75.75 0 0 1 .75.75v.75H3.75v-.75A.75.75 0 0 1 4.5 6zm15 12h-15a.75.75 0 0 1-.75-.75V12h4.575a3.75 3.75 0 0 0 7.35 0h4.575v5.25a.75.75 0 0 1-.75.75z",
    "data-ppui": "true"
  })), props.children);
};
var CashBackSmIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded50);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "cash back sm icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 18 18",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.561 8.421C11.893 7.065 10.895 6.107 9.58 1.44c-.08-.24-.32-.439-.56-.439a.588.588 0 0 0-.558.439C7.105 6.107 6.107 7.105 1.44 8.42c-.24.08-.439.32-.439.56 0 .238.16.478.439.558 4.668 1.356 5.666 2.314 7.022 7.022.08.24.32.439.559.439.24 0 .479-.16.559-.439 1.356-4.668 2.314-5.666 6.982-7.022.24-.08.439-.32.439-.559 0-.24-.16-.479-.439-.559z",
    "data-ppui": "true"
  })), props.children);
};
var CashBackIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded51);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "cash back icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.952 21.932C5.454 21.932 1 17.462 1 11.99s4.454-9.942 9.952-9.942 9.953 4.45 9.953 9.942a.762.762 0 0 1-1.525 0c0-4.65-3.792-8.439-8.448-8.439-4.655 0-8.427 3.789-8.427 8.439s3.792 8.439 8.447 8.439c.743 0 1.485-.1 2.188-.28.4-.1.822.14.922.54.1.401-.14.822-.541.923-.843.22-1.706.34-2.589.34l.02-.02z",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.799 18.02c-2.14-.621-2.597-1.06-3.2-3.2-.037-.11-.147-.201-.256-.201a.27.27 0 0 0-.256.201c-.622 2.14-1.061 2.597-3.22 3.2-.109.037-.2.147-.2.256 0 .11.073.22.2.256 2.14.622 2.598 1.061 3.22 3.22.036.109.146.2.256.2a.27.27 0 0 0 .256-.2c.621-2.14 1.06-2.598 3.2-3.22.11-.036.201-.146.201-.256a.27.27 0 0 0-.201-.256zm-9.562-3.022a2.546 2.546 0 0 0 .605-1.67 2.55 2.55 0 0 0-.605-1.672c-.388-.443-.913-.692-1.461-.692h-1.377a.648.648 0 0 1-.487-.23.848.848 0 0 1-.202-.557c0-.21.073-.41.202-.558a.648.648 0 0 1 .487-.23h2.066a.648.648 0 0 0 .486-.23.848.848 0 0 0 .202-.558.848.848 0 0 0-.202-.557.648.648 0 0 0-.486-.23h-.689v-.788a.848.848 0 0 0-.202-.557.648.648 0 0 0-.486-.231.648.648 0 0 0-.487.23.849.849 0 0 0-.202.558v.787c-.548 0-1.073.25-1.46.693a2.546 2.546 0 0 0-.606 1.67c0 .627.218 1.228.605 1.671.388.444.913.693 1.46.693h1.378c.183 0 .358.083.487.23a.85.85 0 0 1 .202.557.85.85 0 0 1-.202.557.648.648 0 0 1-.487.23H9.71a.648.648 0 0 0-.487.232.849.849 0 0 0-.201.557c0 .208.072.409.201.556a.65.65 0 0 0 .487.231h.689v.788c0 .209.073.41.202.557.129.148.304.23.486.23a.648.648 0 0 0 .487-.23.848.848 0 0 0 .202-.557v-.788c.548 0 1.073-.249 1.46-.692z",
    "data-ppui": "true"
  })), props.children);
};
var CashPickupIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded52);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "cash pickup icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.72 5.458a.75.75 0 0 0 .53 1.28h15.5a.75.75 0 1 0 0-1.5H4.25a.75.75 0 0 0-.53.22zm1.5-3a.75.75 0 0 0 .53 1.28h12.5a.75.75 0 1 0 0-1.5H5.75a.75.75 0 0 0-.53.22z",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9.917 11.894a3.75 3.75 0 1 1 4.167 6.237 3.75 3.75 0 0 1-4.167-6.237zm.833 4.989a2.25 2.25 0 1 0 2.5-3.74 2.25 2.25 0 0 0-2.5 3.74z",
    clipRule: "evenodd",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M1.5 8.262h21a.75.75 0 0 1 .75.75v12a.75.75 0 0 1-.75.75h-21a.75.75 0 0 1-.75-.75v-12a.75.75 0 0 1 .75-.75zm4.345 12h12.31a5.324 5.324 0 0 1 3.595-3.596v-3.309a5.323 5.323 0 0 1-3.595-3.595H5.845a5.324 5.324 0 0 1-3.595 3.595v3.31a5.324 5.324 0 0 1 3.595 3.595zm13.902-10.5a3.826 3.826 0 0 0 2.003 2.003V9.762h-2.003zM2.25 11.765a3.826 3.826 0 0 0 2.003-2.003H2.25v2.003zm2.003 8.497a3.826 3.826 0 0 0-2.003-2.004v2.004h2.003zm17.497-2.004a3.826 3.826 0 0 0-2.003 2.004h2.003v-2.004z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};
var CashIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded53);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "cash icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 8.25a3.75 3.75 0 1 0 0 7.5 3.75 3.75 0 0 0 0-7.5zm0 6a2.25 2.25 0 1 1 0-4.5 2.25 2.25 0 0 1 0 4.5zm10.5-9h-21A.75.75 0 0 0 .75 6v12a.75.75 0 0 0 .75.75h21a.75.75 0 0 0 .75-.75V6a.75.75 0 0 0-.75-.75zm-4.345 12H5.845a5.324 5.324 0 0 0-3.595-3.595v-3.31A5.323 5.323 0 0 0 5.845 6.75h12.31a5.324 5.324 0 0 0 3.595 3.595v3.31a5.324 5.324 0 0 0-3.595 3.595zm3.595-8.497a3.826 3.826 0 0 1-2.003-2.003h2.003v2.003zM4.253 6.75A3.826 3.826 0 0 1 2.25 8.753V6.75h2.003zM2.25 15.247a3.826 3.826 0 0 1 2.003 2.003H2.25v-2.003zm17.497 2.003a3.826 3.826 0 0 1 2.003-2.003v2.003h-2.003z",
    "data-ppui": "true"
  })), props.children);
};
var CausesIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded54);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "causes icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.593 13.225a2.28 2.28 0 0 0-1.744-.448C21.609 11 22.5 9.233 22.5 7.5c0-2.481-1.996-4.5-4.45-4.5a4.46 4.46 0 0 0-3.425 1.57A4.461 4.461 0 0 0 11.199 3C8.746 3 6.75 5.02 6.75 7.5c0 1.031.304 2.034.943 3.094a2.989 2.989 0 0 0-1.383.787l-2.12 2.12H1.5A1.5 1.5 0 0 0 0 15v3.75a1.5 1.5 0 0 0 1.5 1.5h9.75a.744.744 0 0 0 .182-.023l6-1.5a.653.653 0 0 0 .111-.038l3.645-1.55.04-.02a2.306 2.306 0 0 0 .37-3.896h-.005zM11.2 4.5a2.92 2.92 0 0 1 2.732 1.781.75.75 0 0 0 1.388 0 2.92 2.92 0 0 1 2.732-1.78C19.649 4.5 21 5.873 21 7.5c0 1.828-1.48 3.897-4.28 5.99l-1.04.239a2.625 2.625 0 0 0-2.555-3.23H9.439C8.629 9.41 8.25 8.45 8.25 7.5c0-1.626 1.35-3 2.95-3zM1.5 15h2.25v3.75H1.5V15zm19.072.77l-3.563 1.517-5.853 1.463H5.25v-4.19l2.122-2.12a1.487 1.487 0 0 1 1.06-.44h4.693a1.125 1.125 0 1 1 0 2.25H10.5a.75.75 0 1 0 0 1.5h3a.782.782 0 0 0 .168-.019l6.281-1.444.03-.008a.806.806 0 0 1 .59 1.49h.003z",
    "data-ppui": "true"
  })), props.children);
};
var CenterAlignIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded55);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "center align icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 6a.75.75 0 0 1 .75-.75h16.5a.75.75 0 1 1 0 1.5H3.75A.75.75 0 0 1 3 6zm3 3a.75.75 0 0 0 0 1.5h12A.75.75 0 1 0 18 9H6zm14.25 3.75H3.75a.75.75 0 1 0 0 1.5h16.5a.75.75 0 1 0 0-1.5zM18 16.5H6A.75.75 0 1 0 6 18h12a.75.75 0 1 0 0-1.5z",
    "data-ppui": "true"
  })), props.children);
};
var ChangePlanIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded56);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "change plan icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.28 16.72a.75.75 0 0 1 0 1.06l-2.25 2.25a.75.75 0 0 1-1.06-1.06l.97-.97h-1.102a6.761 6.761 0 0 1-5.493-2.827l-3.91-5.475A5.26 5.26 0 0 0 5.161 7.5H3A.75.75 0 0 1 3 6h2.162a6.761 6.761 0 0 1 5.493 2.826l3.91 5.476a5.26 5.26 0 0 0 4.273 2.198h1.102l-.97-.97a.75.75 0 1 1 1.06-1.06l2.25 2.25zm-8.874-6.689a.753.753 0 0 0 1.046-.174l.113-.157a5.26 5.26 0 0 1 4.273-2.2h1.102l-.97.97a.75.75 0 1 0 1.06 1.06l2.25-2.25a.748.748 0 0 0 0-1.06l-2.25-2.25a.75.75 0 1 0-1.06 1.06l.97.97h-1.102a6.762 6.762 0 0 0-5.493 2.826l-.112.157a.749.749 0 0 0 .173 1.048zm-2.812 3.938a.75.75 0 0 0-1.046.174l-.113.157a5.259 5.259 0 0 1-4.273 2.2H3A.75.75 0 1 0 3 18h2.162a6.76 6.76 0 0 0 5.493-2.827l.112-.156a.748.748 0 0 0-.173-1.048z",
    "data-ppui": "true"
  })), props.children);
};
var CharitiesIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded57);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "charities icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16.27 11.396a3.005 3.005 0 0 0-2.121-.88c-.838 0-1.6.307-2.149.851-.549-.544-1.31-.852-2.149-.852a3.005 3.005 0 0 0-3.001 3.002c0 1.662 1.22 3.11 2.368 4.116a14.552 14.552 0 0 0 2.46 1.726.681.681 0 0 0 .643 0 14.543 14.543 0 0 0 2.46-1.726c1.15-1.006 2.37-2.454 2.37-4.116a3.006 3.006 0 0 0-.88-2.121zm-2.143 4.99c.924-.858 1.66-1.869 1.66-2.868a1.641 1.641 0 0 0-1.639-1.64c-.713 0-1.282.375-1.518.951a.681.681 0 0 1-1.26 0c-.236-.576-.805-.95-1.518-.95a1.641 1.641 0 0 0-1.64 1.639c0 1.001.737 2.012 1.66 2.87A13.653 13.653 0 0 0 12 17.971c.461-.28 1.332-.848 2.127-1.586z",
    clipRule: "evenodd",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M17.192 4.425h1.558a.75.75 0 0 1 .671.414l1.5 3c.052.104.079.22.079.336v12.75a1.5 1.5 0 0 1-1.5 1.5h-15a1.5 1.5 0 0 1-1.5-1.5V8.175c0-.117.027-.232.079-.336l1.5-3a.75.75 0 0 1 .671-.414h1.558V2.273a.75.75 0 0 1 .75-.75h8.884a.75.75 0 0 1 .75.75v2.152zm-8.884 3V3.023h7.384v4.402H8.308zm-1.5 0v-1.5H5.713l-.75 1.5h1.845zm10.384 0h1.845l-.75-1.5h-1.095v1.5zm2.308 13.5v-12h-15v12h15z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};
var ChartPieSliceIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded58);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "chart pie slice icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.375 10.915a.75.75 0 0 0 .375-.65v-6.75a.75.75 0 0 0-1-.703 9.756 9.756 0 0 0-6.338 10.97.75.75 0 0 0 1.113.513l5.85-3.38zM8.25 4.652v5.18l-4.489 2.59c-.011-.14-.011-.283-.011-.422a8.261 8.261 0 0 1 4.5-7.348zM12 2.25a.75.75 0 0 0-.75.75v8.608l-7.388 4.304a.75.75 0 0 0-.27 1.031A9.75 9.75 0 1 0 12 2.25zm0 18a8.294 8.294 0 0 1-6.702-3.439l7.08-4.125a.752.752 0 0 0 .375-.649V3.784A8.25 8.25 0 0 1 12 20.25z",
    "data-ppui": "true"
  })), props.children);
};
var ChatCurrencyIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded59);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "chat currency icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M14.946 10.69a.655.655 0 0 0 .191-.463 2.43 2.43 0 0 0-2.428-2.428h-.054v-.41a.655.655 0 0 0-1.31 0v.41h-.054a2.428 2.428 0 0 0 0 4.856h.054v2.237h-.409a1.119 1.119 0 0 1-1.119-1.119.655.655 0 1 0-1.309 0 2.43 2.43 0 0 0 2.428 2.428h.41v.41a.654.654 0 1 0 1.309 0v-.41h.409a2.428 2.428 0 0 0 0-4.856h-.41V9.108h.055a1.118 1.118 0 0 1 1.119 1.119.655.655 0 0 0 1.118.463zm-3.655.655a1.119 1.119 0 0 1 0-2.237h.054v2.237h-.054zm1.773 3.547h-.41v-2.237h.41a1.119 1.119 0 1 1 0 2.237z",
    clipRule: "evenodd",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M20.25 4.5H3.75A1.5 1.5 0 0 0 2.25 6v15a1.485 1.485 0 0 0 .867 1.36 1.49 1.49 0 0 0 1.594-.214l.008-.007L7.781 19.5H20.25a1.5 1.5 0 0 0 1.5-1.5V6a1.5 1.5 0 0 0-1.5-1.5zm0 13.5H7.5a.75.75 0 0 0-.49.183L3.75 21V6h16.5v12z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};
var ChatIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded60);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "chat icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.25 4.5H3.75A1.5 1.5 0 0 0 2.25 6v15a1.485 1.485 0 0 0 .867 1.36 1.49 1.49 0 0 0 1.594-.214l.008-.007L7.781 19.5H20.25a1.5 1.5 0 0 0 1.5-1.5V6a1.5 1.5 0 0 0-1.5-1.5zm0 13.5H7.5a.75.75 0 0 0-.49.183L3.75 21V6h16.5v12z",
    "data-ppui": "true"
  })), props.children);
};
var CheckCaptureIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded61);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "check capture icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.986 4.688v2.25a.563.563 0 0 1-1.125 0V5.25h-1.687a.563.563 0 1 1 0-1.125h2.25a.562.562 0 0 1 .562.563zM3.812 19.078H2.125V17.39a.563.563 0 0 0-1.125 0v2.25a.562.562 0 0 0 .562.563h2.25a.562.562 0 0 0 0-1.125zm19.174-1.688v2.25a.562.562 0 0 1-.562.563h-2.25a.563.563 0 0 1 0-1.125h1.687V17.39a.563.563 0 1 1 1.125 0zM3.812 5.25H2.125v1.688a.563.563 0 0 1-1.125 0v-2.25a.563.563 0 0 1 .562-.563h2.25a.562.562 0 1 1 0 1.125zm14.341 9.194a.549.549 0 0 1-.549.55H9.919a.549.549 0 1 1 0-1.098h7.685a.549.549 0 0 1 .549.548zm-9.881 0a.549.549 0 0 1-.55.55H6.626a.549.549 0 1 1 0-1.098h1.098a.549.549 0 0 1 .549.548z",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M19.136 6.785H4.864a1.098 1.098 0 0 0-1.098 1.098v8.234a1.098 1.098 0 0 0 1.098 1.098h14.272a1.098 1.098 0 0 0 1.098-1.098V7.883a1.098 1.098 0 0 0-1.098-1.098zm0 9.332H4.864V7.883h14.272v8.234z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};
var CheckIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded62);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "check icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.187 15.87a.75.75 0 0 0-.53-1.28h-10.5a.75.75 0 1 0 0 1.5h10.5a.75.75 0 0 0 .53-.22zm-13.5 0a.75.75 0 0 0-.53-1.28h-1.5a.75.75 0 1 0 0 1.5h1.5a.75.75 0 0 0 .53-.22z",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2.25 4.875h19.5a1.5 1.5 0 0 1 1.5 1.5v11.25a1.5 1.5 0 0 1-1.5 1.5H2.25a1.5 1.5 0 0 1-1.5-1.5V6.375a1.5 1.5 0 0 1 1.5-1.5zm0 12.75h19.5V6.375H2.25v11.25z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};
var CheckmarkBackgroundSmIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded63);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "checkmark background sm icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 18 18",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.802 10.248L6.579 9.025a.812.812 0 0 0-1.148 1.148l.677.678.04.043 1.14 1.14a.734.734 0 0 0 1.04 0l4.081-4.08a.733.733 0 0 0 .083-.099l.077-.078A.812.812 0 1 0 11.42 6.63l-3.618 3.619z",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M14.654 3.346A8.008 8.008 0 0 0 9 1a8 8 0 1 0 8 8 8.008 8.008 0 0 0-2.346-5.654zm-.352 2.112A6.376 6.376 0 0 1 15.376 9 6.383 6.383 0 0 1 9 15.376a6.376 6.376 0 1 1 5.302-9.918z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};
var CheckmarkBackgroundIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded64);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "checkmark background icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.28 9.22a.748.748 0 0 1 0 1.06l-5.25 5.25a.747.747 0 0 1-1.06 0l-2.25-2.25a.75.75 0 1 1 1.06-1.06l1.72 1.72 4.72-4.72a.75.75 0 0 1 1.06 0zM21.75 12A9.75 9.75 0 1 1 12 2.25 9.76 9.76 0 0 1 21.75 12zm-1.5 0A8.25 8.25 0 1 0 12 20.25 8.26 8.26 0 0 0 20.25 12z",
    "data-ppui": "true"
  })), props.children);
};
var CheckmarkSelectedSmIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded65);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "checkmark selected sm icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 18 18",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9 1a8 8 0 1 0 8 8 8.008 8.008 0 0 0-8-8zM6.513 8.696L7.77 9.953l3.718-3.718a.835.835 0 1 1 1.18 1.18l-.08.08a.75.75 0 0 1-.085.101L8.31 11.788a.756.756 0 0 1-1.069 0L6.07 10.617a.755.755 0 0 1-.041-.045l-.696-.695a.834.834 0 1 1 1.18-1.18z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};
var CheckmarkSelectedIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded66);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "checkmark selected icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 2.25A9.75 9.75 0 1 0 21.75 12 9.76 9.76 0 0 0 12 2.25zm4.28 8.03l-5.25 5.25a.747.747 0 0 1-1.06 0l-2.25-2.25a.75.75 0 1 1 1.06-1.06l1.72 1.72 4.72-4.72a.751.751 0 0 1 1.06 1.06z",
    "data-ppui": "true"
  })), props.children);
};
var CheckmarkSmIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded67);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "checkmark sm icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 18 18",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3.352 9.586l3.398 3.399 8.46-8.462a.763.763 0 0 1 1.08 1.079l-9 9a.761.761 0 0 1-1.08 0l-3.937-3.938a.763.763 0 1 1 1.079-1.078z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};
var CheckmarkIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded68);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "checkmark icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.53 7.28l-12 12a.75.75 0 0 1-1.06 0l-5.25-5.25a.75.75 0 0 1 1.06-1.06L9 17.69 20.47 6.22a.75.75 0 1 1 1.06 1.06z",
    "data-ppui": "true"
  })), props.children);
};
var ChevronDownSmIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded69);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "chevron down sm icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 18 18",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.192 6.977a.773.773 0 0 1 0 1.095l-4.644 4.645a.773.773 0 0 1-1.096 0L3.807 8.072a.775.775 0 1 1 1.096-1.095L9 11.075l4.097-4.098a.775.775 0 0 1 1.095 0z",
    "data-ppui": "true"
  })), props.children);
};
var ChevronDownIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded70);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "chevron down icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.03 9.53l-7.5 7.5a.75.75 0 0 1-1.06 0l-7.5-7.5a.75.75 0 1 1 1.06-1.06L12 15.44l6.97-6.97a.75.75 0 0 1 1.06 1.06z",
    "data-ppui": "true"
  })), props.children);
};
var ChevronLeftIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded71);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "chevron left icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.53 18.97a.75.75 0 1 1-1.06 1.06l-7.5-7.5a.75.75 0 0 1 0-1.06l7.5-7.5a.75.75 0 1 1 1.06 1.06L8.56 12l6.97 6.97z",
    "data-ppui": "true"
  })), props.children);
};
var ChevronRightIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded72);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "chevron right icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.03 12.53l-7.5 7.5a.751.751 0 0 1-1.06-1.06L15.44 12 8.47 5.03a.75.75 0 1 1 1.06-1.06l7.5 7.5a.752.752 0 0 1 0 1.06z",
    "data-ppui": "true"
  })), props.children);
};
var ChevronUpSmIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded73);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "chevron up sm icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 18 18",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.192 12.717a.773.773 0 0 0 0-1.096L9.548 6.977a.774.774 0 0 0-1.096 0L3.807 11.62a.775.775 0 0 0 1.096 1.096L9 8.619l4.097 4.098a.773.773 0 0 0 1.095 0z",
    "data-ppui": "true"
  })), props.children);
};
var ChevronUpIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded74);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "chevron up icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.03 15.53a.75.75 0 0 1-1.06 0L12 8.56l-6.97 6.97a.75.75 0 1 1-1.06-1.06l7.5-7.5a.75.75 0 0 1 1.06 0l7.5 7.5a.75.75 0 0 1 0 1.06z",
    "data-ppui": "true"
  })), props.children);
};
var ChildrenIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded75);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "children icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.625 13.125a1.125 1.125 0 1 1 0-2.25 1.125 1.125 0 0 1 0 2.25zm6.75-2.25a1.125 1.125 0 1 0 0 2.25 1.125 1.125 0 0 0 0-2.25zm-1.15 4.24a4.219 4.219 0 0 1-4.45 0 .75.75 0 0 0-.8 1.27 5.719 5.719 0 0 0 6.05 0 .75.75 0 0 0-.8-1.27zM21.75 12A9.75 9.75 0 1 1 12 2.25 9.76 9.76 0 0 1 21.75 12zm-1.5 0a8.26 8.26 0 0 0-7.883-8.242C11.28 5.286 11.25 6.738 11.25 6.75a.75.75 0 1 0 1.5 0 .75.75 0 1 1 1.5 0 2.25 2.25 0 1 1-4.5 0c0-.068.012-1.34.793-2.872A8.25 8.25 0 1 0 20.25 12z",
    "data-ppui": "true"
  })), props.children);
};
var CircleIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded76);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "circle icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 2.25A9.75 9.75 0 1 0 21.75 12 9.76 9.76 0 0 0 12 2.25zm0 18A8.25 8.25 0 1 1 20.25 12 8.26 8.26 0 0 1 12 20.25z",
    "data-ppui": "true"
  })), props.children);
};
var ClockSmIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded77);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "clock sm icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 18 18",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M13.477 9.539a.763.763 0 0 0-.54-1.302H9.764V5.062a.762.762 0 1 0-1.525 0V9A.763.763 0 0 0 9 9.762h3.938c.202 0 .396-.08.539-.223z",
    clipRule: "evenodd",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M14.31 3.69A7.52 7.52 0 0 0 9 1.487 7.513 7.513 0 1 0 16.513 9a7.52 7.52 0 0 0-2.203-5.31zM9 14.987A5.987 5.987 0 1 1 14.988 9 5.995 5.995 0 0 1 9 14.987z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};
var ClockIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded78);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "clock icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 2.25A9.75 9.75 0 1 0 21.75 12 9.76 9.76 0 0 0 12 2.25zm0 18A8.25 8.25 0 1 1 20.25 12 8.26 8.26 0 0 1 12 20.25zM18 12a.75.75 0 0 1-.75.75H12a.75.75 0 0 1-.75-.75V6.75a.75.75 0 1 1 1.5 0v4.5h4.5A.75.75 0 0 1 18 12z",
    "data-ppui": "true"
  })), props.children);
};
var CloseSmIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded79);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "close sm icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 18 18",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M14.767 13.77a.766.766 0 0 0-.165-.247L10.078 9l4.524-4.523a.763.763 0 1 0-1.079-1.079L9 7.922 4.477 3.398a.763.763 0 1 0-1.079 1.079L7.922 9l-4.524 4.523a.763.763 0 0 0 1.079 1.079L9 10.078l4.523 4.524a.766.766 0 0 0 1.079 0 .764.764 0 0 0 .165-.831z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};
var CloseIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded80);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "close icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.28 18.22a.751.751 0 0 1-1.06 1.06L12 13.06l-6.22 6.22a.75.75 0 0 1-1.06-1.06L10.94 12 4.72 5.78a.75.75 0 1 1 1.06-1.06L12 10.94l6.22-6.22a.75.75 0 1 1 1.06 1.06L13.06 12l6.22 6.22z",
    "data-ppui": "true"
  })), props.children);
};
var ClothingIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded81);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "clothing icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.212 5.74l-4.853-2.646a.75.75 0 0 0-.36-.094h-3a.75.75 0 0 0-.75.75 2.25 2.25 0 1 1-4.5 0A.75.75 0 0 0 9 3H6a.75.75 0 0 0-.36.094L.79 5.739a1.477 1.477 0 0 0-.62 1.994l1.806 3.45A1.534 1.534 0 0 0 3.344 12H5.25v7.5a1.5 1.5 0 0 0 1.5 1.5h10.5a1.5 1.5 0 0 0 1.5-1.5V12h1.907a1.535 1.535 0 0 0 1.367-.817l1.806-3.45a1.478 1.478 0 0 0-.618-1.994zM3.344 10.5a.058.058 0 0 1-.038-.012L1.508 7.056 5.25 5.014V10.5H3.344zm13.906 9H6.75v-15h1.575a3.75 3.75 0 0 0 7.348 0h1.577v15zm3.445-9.013a.052.052 0 0 1-.038.013H18.75V5.014l3.742 2.042-1.797 3.43z",
    "data-ppui": "true"
  })), props.children);
};
var CloudStorageIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded82);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "cloud storage icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.03 7.72l-5.25-5.25a.75.75 0 0 0-.53-.22h-9a1.5 1.5 0 0 0-1.5 1.5V12a.75.75 0 1 0 1.5 0V3.75h8.25v4.5a.75.75 0 0 0 .75.75h4.5v11.25H16.5a.75.75 0 1 0 0 1.5h2.25a1.5 1.5 0 0 0 1.5-1.5v-12a.75.75 0 0 0-.22-.53zM15 4.81l2.69 2.69H15V4.81zM10.125 12a4.875 4.875 0 0 0-4.5 3 3.375 3.375 0 0 0 0 6.75h4.5a4.875 4.875 0 1 0 0-9.75zm0 8.25h-4.5a1.875 1.875 0 0 1-.357-3.716.75.75 0 1 0 1.5.034 3.562 3.562 0 0 1 .125-.665 3.375 3.375 0 1 1 3.232 4.347z",
    "data-ppui": "true"
  })), props.children);
};
var CodeIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded83);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "code icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.48 8.827L2.672 12l3.808 3.174a.75.75 0 1 1-.96 1.152l-4.5-3.75a.749.749 0 0 1 0-1.152l4.5-3.75a.75.75 0 1 1 .96 1.153zm16.5 2.597l-4.5-3.75a.75.75 0 1 0-.96 1.153L21.328 12l-3.808 3.174a.75.75 0 1 0 .96 1.152l4.5-3.75a.748.748 0 0 0 0-1.152zm-7.724-8.379a.75.75 0 0 0-.961.45l-6 16.5a.75.75 0 1 0 1.41.511l6-16.5a.75.75 0 0 0-.449-.961z",
    "data-ppui": "true"
  })), props.children);
};
var CommunityIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded84);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "community icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.55 11.85a.749.749 0 0 0 1.05-.15 4.874 4.874 0 0 1 7.8 0 .75.75 0 0 0 1.2 0 4.874 4.874 0 0 1 7.8 0 .75.75 0 1 0 1.2-.901 6.361 6.361 0 0 0-2.569-2.033 3.75 3.75 0 1 0-5.057 0 6.308 6.308 0 0 0-1.968 1.342 6.306 6.306 0 0 0-1.97-1.342 3.75 3.75 0 1 0-5.056 0A6.364 6.364 0 0 0 2.4 10.8a.75.75 0 0 0 .15 1.05zm13.95-8.1a2.25 2.25 0 1 1 0 4.5 2.25 2.25 0 0 1 0-4.5zm-9 0a2.25 2.25 0 1 1 0 4.5 2.25 2.25 0 0 1 0-4.5zm11.531 14.767a3.75 3.75 0 1 0-5.057 0 6.307 6.307 0 0 0-1.968 1.341 6.305 6.305 0 0 0-1.97-1.341 3.75 3.75 0 1 0-5.056 0A6.364 6.364 0 0 0 2.4 20.55a.75.75 0 1 0 1.2.9 4.874 4.874 0 0 1 7.8 0 .75.75 0 0 0 1.2 0 4.874 4.874 0 0 1 7.8 0 .75.75 0 1 0 1.2-.901 6.36 6.36 0 0 0-2.569-2.032zM7.5 13.5a2.25 2.25 0 1 1 0 4.5 2.25 2.25 0 0 1 0-4.5zm9 0a2.25 2.25 0 1 1 0 4.5 2.25 2.25 0 0 1 0-4.5z",
    "data-ppui": "true"
  })), props.children);
};
var ConfettiIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded85);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "confetti icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.452 4.934a1.481 1.481 0 0 0-2.437.541L3.094 19.011A1.484 1.484 0 0 0 4.478 21c.174-.001.348-.033.511-.094l13.535-4.922a1.481 1.481 0 0 0 .542-2.437l-8.614-8.613zm-.78 12.676L6.39 14.329l1.234-3.395 5.442 5.442L9.67 17.61zm-5.157 1.875l1.313-3.6 2.292 2.291-3.605 1.309zm10.11-3.675L8.19 9.375l1.219-3.363 8.571 8.572-3.355 1.226zM15 6.75a3.545 3.545 0 0 1 .36-1.46c.497-.993 1.434-1.54 2.64-1.54.628 0 1.031-.215 1.28-.676.13-.258.206-.54.22-.83a.75.75 0 0 1 1.5.006c0 1.206-.799 3-3 3-.628 0-1.031.215-1.28.676-.13.258-.206.54-.22.83A.75.75 0 1 1 15 6.75zm-2.25-3V1.5a.75.75 0 1 1 1.5 0v2.25a.75.75 0 1 1-1.5 0zm9.53 7.72a.748.748 0 0 1-.243 1.223.748.748 0 0 1-.818-.163l-1.5-1.5a.75.75 0 0 1 1.062-1.062l1.5 1.501zm.457-4.008l-2.25.75a.75.75 0 1 1-.474-1.424l2.25-.75a.75.75 0 1 1 .474 1.424z",
    "data-ppui": "true"
  })), props.children);
};
var ConnectionIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded86);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "connection icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.671 7.914a.75.75 0 0 0-1.342 0l-6.75 13.5a.75.75 0 1 0 1.341.672l1.3-2.586h9.572l1.293 2.586a.75.75 0 0 0 1.031.319.75.75 0 0 0 .305-.99l-6.749-13.5zM12 9.927L14.537 15H9.463L12 9.927zM7.969 18l.75-1.5h6.572l.75 1.5H7.969zm6.988-9.212a2.999 2.999 0 0 0-4.223-3.246 3 3 0 0 0-1.683 3.246.75.75 0 1 1-1.476.267 4.5 4.5 0 1 1 8.856 0 .75.75 0 1 1-1.479-.267h.005zM6.014 12.77a7.5 7.5 0 1 1 11.972 0 .75.75 0 0 1-1.196-.905 6 6 0 1 0-9.58 0 .75.75 0 0 1-1.196.905z",
    "data-ppui": "true"
  })), props.children);
};
var ContactUsIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded87);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "contact us icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.927 5.124a9.697 9.697 0 0 0-6.853-2.874H12A9.75 9.75 0 0 0 2.25 12v5.25A2.25 2.25 0 0 0 4.5 19.5H6a2.25 2.25 0 0 0 2.25-2.25V13.5A2.25 2.25 0 0 0 6 11.25H3.784a8.261 8.261 0 0 1 14.08-5.07 8.193 8.193 0 0 1 2.353 5.07H18a2.25 2.25 0 0 0-2.25 2.25v3.75A2.25 2.25 0 0 0 18 19.5h2.25A2.25 2.25 0 0 1 18 21.75h-5.25a.75.75 0 1 0 0 1.5H18a3.75 3.75 0 0 0 3.75-3.75V12a9.694 9.694 0 0 0-2.823-6.876zM6 12.75a.75.75 0 0 1 .75.75v3.75A.75.75 0 0 1 6 18H4.5a.75.75 0 0 1-.75-.75v-4.5H6zM18 18a.75.75 0 0 1-.75-.75V13.5a.75.75 0 0 1 .75-.75h2.25V18H18z",
    "data-ppui": "true"
  })), props.children);
};
var ContactlessPaymentSelectedIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded88);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "contactless payment selected icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 2.25A9.75 9.75 0 1 0 21.75 12 9.76 9.76 0 0 0 12 2.25zM9.1 14.6a.75.75 0 1 1-1.325-.7 4.012 4.012 0 0 0 0-3.8.75.75 0 0 1 1.325-.7 5.562 5.562 0 0 1 0 5.2zm2.625 1.5a.75.75 0 1 1-1.323-.704 7.225 7.225 0 0 0 0-6.795.75.75 0 1 1 1.323-.705 8.718 8.718 0 0 1 0 8.206v-.001zm2.625 1.5a.75.75 0 0 1-1.319-.703 10.372 10.372 0 0 0 0-9.794.75.75 0 1 1 1.324-.706 11.875 11.875 0 0 1-.005 11.206v-.002z",
    "data-ppui": "true"
  })), props.children);
};
var ContactlessPaymentIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded89);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "contactless payment icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 2.25A9.75 9.75 0 1 0 21.75 12 9.76 9.76 0 0 0 12 2.25zm0 18A8.25 8.25 0 1 1 20.25 12 8.26 8.26 0 0 1 12 20.25zM9.1 9.4a5.562 5.562 0 0 1 0 5.2.75.75 0 1 1-1.325-.7 4.012 4.012 0 0 0 0-3.8.75.75 0 0 1 1.325-.7zm5.25-3a11.875 11.875 0 0 1 0 11.206.75.75 0 0 1-1.319-.71 10.37 10.37 0 0 0 0-9.793.75.75 0 0 1 1.324-.706l-.005.002zm-2.625 1.5a8.719 8.719 0 0 1 0 8.204.75.75 0 1 1-1.323-.705 7.22 7.22 0 0 0 0-6.795.75.75 0 1 1 1.323-.705z",
    "data-ppui": "true"
  })), props.children);
};
var ContactsIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded90);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "contacts icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.8 16.35a.75.75 0 0 0 1.05-.15 4.874 4.874 0 0 1 7.8 0 .75.75 0 1 0 1.2-.9 6.363 6.363 0 0 0-2.569-2.033 3.75 3.75 0 1 0-5.057 0A6.362 6.362 0 0 0 7.65 15.3a.75.75 0 0 0 .15 1.05zm2.7-5.85a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0zm9-8.25H6a1.5 1.5 0 0 0-1.5 1.5V6H3a.75.75 0 0 0 0 1.5h1.5v3.75H3a.75.75 0 1 0 0 1.5h1.5v3.75H3A.75.75 0 1 0 3 18h1.5v2.25a1.5 1.5 0 0 0 1.5 1.5h13.5a1.5 1.5 0 0 0 1.5-1.5V3.75a1.5 1.5 0 0 0-1.5-1.5zm0 18H6V3.75h13.5v16.5z",
    "data-ppui": "true"
  })), props.children);
};
var CopyToClipboardIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded91);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "copy to clipboard icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.25 3h-12a.75.75 0 0 0-.75.75V7.5H3.75a.75.75 0 0 0-.75.75v12a.75.75 0 0 0 .75.75h12a.75.75 0 0 0 .75-.75V16.5h3.75a.75.75 0 0 0 .75-.75v-12a.75.75 0 0 0-.75-.75zM15 19.5H4.5V9H15v10.5zm4.5-4.5h-3V8.25a.75.75 0 0 0-.75-.75H9v-3h10.5V15z",
    "data-ppui": "true"
  })), props.children);
};
var CreditCardIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded92);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "credit card icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 4.5H3A1.5 1.5 0 0 0 1.5 6v12A1.5 1.5 0 0 0 3 19.5h18a1.5 1.5 0 0 0 1.5-1.5V6A1.5 1.5 0 0 0 21 4.5zM21 6v2.25H3V6h18zm0 12H3V9.75h18V18zm-1.5-2.25a.75.75 0 0 1-.75.75h-3a.75.75 0 1 1 0-1.5h3a.75.75 0 0 1 .75.75zm-6 0a.75.75 0 0 1-.75.75h-1.5a.75.75 0 1 1 0-1.5h1.5a.75.75 0 0 1 .75.75z",
    "data-ppui": "true"
  })), props.children);
};
var CreditMastercardIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded93);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "credit mastercard icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.187 7.16h-1.5a1.5 1.5 0 0 0-1.5 1.5v1.5a1.5 1.5 0 0 0 1.5 1.5h1.5a1.5 1.5 0 0 0 1.5-1.5v-1.5a1.5 1.5 0 0 0-1.5-1.5zm-1.875 1.5c0-.207.168-.375.375-.375h1.5c.207 0 .375.168.375.375v1.5a.375.375 0 0 1-.375.375h-1.5a.375.375 0 0 1-.375-.375v-1.5zm9.823 2.305a3.13 3.13 0 1 0 0 5.475 3.13 3.13 0 1 0 0-5.475zm0 1.429a1.998 1.998 0 0 0-.486 1.31 2 2 0 0 0 .486 1.308 1.998 1.998 0 0 0 0-2.618zm-.95-.614a3.117 3.117 0 0 0-.66 1.923c0 .725.246 1.393.66 1.924a2.005 2.005 0 0 1-2.574-1.924 2.005 2.005 0 0 1 2.574-1.923zm1.901 0c.414.53.66 1.198.66 1.923 0 .725-.246 1.393-.66 1.924a2.006 2.006 0 1 0 0-3.848z",
    clipRule: "evenodd",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M21 4.5H3A1.5 1.5 0 0 0 1.5 6v12A1.5 1.5 0 0 0 3 19.5h18a1.5 1.5 0 0 0 1.5-1.5V6A1.5 1.5 0 0 0 21 4.5zM3 5.999h18V18H3V6z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};
var CriticalSmIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded94);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "critical sm icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 18 18",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8.314 7.723v2.53a.686.686 0 0 0 1.372 0v-2.53a.686.686 0 0 0-1.372 0zm1.466 5.331a.94.94 0 1 0-1.56-1.044.94.94 0 0 0 1.562 1.044z",
    clipRule: "evenodd",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M1.732 13.794c0-.295.078-.585.227-.84l5.534-9.61v-.002a1.747 1.747 0 0 1 3.013 0v.002l5.535 9.61a1.667 1.667 0 0 1-.002 1.681 1.721 1.721 0 0 1-1.506.861H3.467a1.721 1.721 0 0 1-1.508-.86 1.668 1.668 0 0 1-.227-.842zm13.12.152v.001a.357.357 0 0 1-.315.177H3.463a.358.358 0 0 1-.315-.178.3.3 0 0 1 0-.305l5.534-9.61a.374.374 0 0 1 .639 0l5.533 9.608v.001a.3.3 0 0 1-.001.306z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};
var CriticalIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded95);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "critical icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.2 17.634L14.002 3.396a2.322 2.322 0 0 0-4.004 0L1.8 17.634a2.204 2.204 0 0 0 0 2.223A2.282 2.282 0 0 0 3.802 21h16.396a2.284 2.284 0 0 0 2-1.143 2.204 2.204 0 0 0 .002-2.223zm-1.3 1.472a.797.797 0 0 1-.701.394H3.802a.797.797 0 0 1-.702-.394.712.712 0 0 1 0-.723l8.2-14.238a.82.82 0 0 1 1.406 0l8.199 14.238a.712.712 0 0 1-.004.723zM11.25 13.5V9.75a.75.75 0 1 1 1.5 0v3.75a.75.75 0 0 1-1.5 0zm1.875 3.375a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0z",
    "data-ppui": "true"
  })), props.children);
};
var CrowdfundIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded96);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "crowdfund icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.95 14.1a.749.749 0 0 1-1.05-.15A4.836 4.836 0 0 0 18 12a.75.75 0 1 1 0-1.5 2.25 2.25 0 1 0-2.179-2.812.75.75 0 1 1-1.453-.375 3.75 3.75 0 1 1 6.163 3.704 6.37 6.37 0 0 1 2.572 2.032.752.752 0 0 1-.153 1.051zm-5.051 5.775a.749.749 0 0 1-.842 1.123.75.75 0 0 1-.456-.373 5.344 5.344 0 0 0-9.202 0 .751.751 0 1 1-1.298-.75 6.755 6.755 0 0 1 3.163-2.805 4.5 4.5 0 1 1 5.472 0 6.755 6.755 0 0 1 3.163 2.805zM12 16.5a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-5.25-5.25A.75.75 0 0 0 6 10.5a2.25 2.25 0 1 1 2.179-2.812.75.75 0 0 0 1.453-.375 3.75 3.75 0 1 0-6.163 3.704A6.37 6.37 0 0 0 .9 13.049a.75.75 0 0 0 1.2.901A4.837 4.837 0 0 1 6 12a.75.75 0 0 0 .75-.75z",
    "data-ppui": "true"
  })), props.children);
};
var CryptoIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded97);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "crypto icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 2.25a.75.75 0 0 1 .75.75v3.25h4.5V3a.75.75 0 0 1 1.5 0v3.25H19a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-1.5 0V7.75H5.75v8.5h12.5V13.5a.75.75 0 0 1 1.5 0V17a.75.75 0 0 1-.75.75h-3.25V21a.75.75 0 0 1-1.5 0v-3.25h-4.5V21a.75.75 0 0 1-1.5 0v-3.25H5a.75.75 0 0 1-.75-.75V7A.75.75 0 0 1 5 6.25h3.25V3A.75.75 0 0 1 9 2.25z",
    "data-ppui": "true"
  })), props.children);
};
var CultureIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded98);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "culture icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M21.53 12.53a.75.75 0 0 0 .22-.53A9.75 9.75 0 1 0 12 21.75a.75.75 0 0 0 .47-1.334c-.134-.11-3.165-2.629-3.447-7.666H21a.75.75 0 0 0 .53-.22zm-5.05-1.28c-.168-3.423-1.486-5.843-2.567-7.275a8.268 8.268 0 0 1 6.302 7.275H16.48zm-7.458 0C9.238 7.352 11.106 4.961 12 4.031c.895.928 2.762 3.319 2.978 7.219H9.022zm-1.502 0H3.785a8.268 8.268 0 0 1 6.302-7.275c-1.081 1.432-2.4 3.852-2.567 7.275zm-3.735 1.5H7.52c.168 3.423 1.486 5.843 2.567 7.275a8.268 8.268 0 0 1-6.302-7.275z",
    clipRule: "evenodd",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M20.767 17.071a3 3 0 0 1-.822 1.536 3.75 3.75 0 0 1 1.605 2.186.75.75 0 1 1-1.45.386c-.265-.997-1.2-1.693-2.275-1.693-1.074 0-2.01.696-2.275 1.692a.75.75 0 1 1-1.45-.385 3.75 3.75 0 0 1 1.604-2.186 3 3 0 1 1 5.063-1.536zm-2.109-1.832a1.5 1.5 0 1 0-1.666 2.494 1.5 1.5 0 0 0 1.666-2.494z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};
var CurrencyChfIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded99);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "currency chf icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.556 12.007c0-1.298.993-2.287 2.141-2.287.793 0 1.504.464 1.877 1.185a.75.75 0 0 0 1.332-.689C8.3 9.042 7.1 8.22 5.697 8.22c-2.045 0-3.64 1.73-3.64 3.787 0 2.056 1.595 3.787 3.64 3.787 1.404 0 2.603-.823 3.21-1.997a.75.75 0 0 0-1.333-.688c-.373.72-1.083 1.184-1.877 1.184-1.148 0-2.14-.988-2.14-2.286zm7.258-3.787a.75.75 0 0 1 .75.75v1.993h2.745V8.97a.75.75 0 0 1 1.5 0v6.073a.75.75 0 0 1-1.5 0v-2.58h-2.745v2.58a.75.75 0 0 1-1.5 0V8.97a.75.75 0 0 1 .75-.75zm7.366 0l.044.001a.756.756 0 0 1 .043 0h2.795a.75.75 0 0 1 0 1.5h-2.131v1.529h2.131a.75.75 0 0 1 0 1.5h-2.131v2.293a.75.75 0 0 1-1.5 0V8.97a.75.75 0 0 1 .75-.75z",
    "data-ppui": "true"
  })), props.children);
};
var CurrencyDollarIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded100);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "currency dollar icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.25 11.25h-1.5v-6h.75a3 3 0 0 1 3 3 .75.75 0 1 0 1.5 0 4.504 4.504 0 0 0-4.5-4.5h-.75v-1.5a.75.75 0 1 0-1.5 0v1.5h-.75a4.5 4.5 0 0 0 0 9h.75v6h-1.5a3 3 0 0 1-3-3 .75.75 0 1 0-1.5 0 4.505 4.505 0 0 0 4.5 4.5h1.5v1.5a.75.75 0 1 0 1.5 0v-1.5h1.5a4.5 4.5 0 1 0 0-9zm-3.75 0a3 3 0 0 1 0-6h.75v6h-.75zm3.75 7.5h-1.5v-6h1.5a3 3 0 0 1 0 6z",
    "data-ppui": "true"
  })), props.children);
};
var CurrencyEuroIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded101);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "currency euro icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.813 18.031a.75.75 0 0 1-.06 1.06 7.499 7.499 0 0 1-12.466-4.84H3.75a.75.75 0 1 1 0-1.5h1.5v-1.5h-1.5a.75.75 0 1 1 0-1.5h1.537A7.5 7.5 0 0 1 17.752 4.91a.75.75 0 0 1-1.002 1.118A6 6 0 0 0 6.8 9.75h5.951a.75.75 0 1 1 0 1.5h-6v1.5h4.5a.75.75 0 0 1 0 1.5H6.799a6 6 0 0 0 9.95 3.723.75.75 0 0 1 1.064.058z",
    "data-ppui": "true"
  })), props.children);
};
var CurrencyPoundIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded102);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "currency pound icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 19.5a.75.75 0 0 1-.75.75h-12a.75.75 0 1 1 0-1.5h.375a2.625 2.625 0 0 0 2.625-2.625V12.75h-3a.75.75 0 1 1 0-1.5h3V7.875a4.875 4.875 0 0 1 7.976-3.761.75.75 0 1 1-.954 1.157A3.375 3.375 0 0 0 9.75 7.875v3.375h3a.75.75 0 1 1 0 1.5h-3v3.375c0 .958-.333 1.887-.945 2.625h8.445a.75.75 0 0 1 .75.75z",
    "data-ppui": "true"
  })), props.children);
};
var CurrencyRupeeIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded103);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "currency rupee icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5 7.5a.75.75 0 0 1-.75.75h-3.014a5.632 5.632 0 0 1-5.61 6H8.689l6.814 6.195a.75.75 0 1 1-1.008 1.11l-8.25-7.5a.75.75 0 0 1 .504-1.305h3.375a4.13 4.13 0 0 0 4.107-4.5H6.75a.75.75 0 0 1 0-1.5h7.047a4.125 4.125 0 0 0-3.672-2.25H6.75a.75.75 0 0 1 0-1.5h12a.75.75 0 1 1 0 1.5h-4.806a5.637 5.637 0 0 1 1.483 2.25h3.323a.75.75 0 0 1 .75.75z",
    "data-ppui": "true"
  })), props.children);
};
var CurrencyYenIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded104);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "currency yen icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.33 4.975L13.583 12H16.5a.75.75 0 1 1 0 1.5h-3.75V15h3.75a.75.75 0 1 1 0 1.5h-3.75v3.75a.75.75 0 0 1-1.5 0V16.5H7.5a.75.75 0 1 1 0-1.5h3.75v-1.5H7.5a.75.75 0 1 1 0-1.5h2.918L4.67 4.975a.75.75 0 1 1 1.16-.95L12 11.566l6.17-7.541a.75.75 0 0 1 1.16.95z",
    "data-ppui": "true"
  })), props.children);
};
var CustomersIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded105);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "customers icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.992 14.805a5.625 5.625 0 1 0-6.234 0A8.984 8.984 0 0 0 .33 18.34a.75.75 0 1 0 1.256.82 7.5 7.5 0 0 1 12.576 0 .75.75 0 0 0 1.256-.82 8.984 8.984 0 0 0-4.427-3.535zm-7.242-4.68a4.125 4.125 0 1 1 8.25 0 4.125 4.125 0 0 1-8.25 0zm19.7 9.253a.75.75 0 0 1-1.037-.218 7.484 7.484 0 0 0-6.288-3.41.75.75 0 1 1 0-1.5 4.125 4.125 0 1 0-1.532-7.957.75.75 0 1 1-.557-1.392 5.625 5.625 0 0 1 5.206 9.904 8.984 8.984 0 0 1 4.427 3.535.75.75 0 0 1-.218 1.038z",
    "data-ppui": "true"
  })), props.children);
};
var DailyDealIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded106);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "daily deal icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5 3h-2.25v-.75a.75.75 0 1 0-1.5 0V3h-7.5v-.75a.75.75 0 0 0-1.5 0V3H4.5A1.5 1.5 0 0 0 3 4.5v15A1.5 1.5 0 0 0 4.5 21h15a1.5 1.5 0 0 0 1.5-1.5v-15A1.5 1.5 0 0 0 19.5 3zm0 16.5h-15v-15h2.25v.75a.75.75 0 0 0 1.5 0V4.5h7.5v.75a.75.75 0 1 0 1.5 0V4.5h2.25v15zm-2.942-8.846l-2.797-.217-1.072-2.484a.75.75 0 0 0-1.378 0l-1.072 2.484-2.797.217a.75.75 0 0 0-.42 1.325l2.112 1.743-.643 2.598a.75.75 0 0 0 1.108.826L12 15.733l2.4 1.413a.75.75 0 0 0 1.11-.826l-.644-2.598 2.111-1.743a.75.75 0 0 0-.419-1.325zm-3.01 2.212a.749.749 0 0 0-.251.759l.328 1.323-1.244-.732a.75.75 0 0 0-.762 0l-1.244.732.328-1.323a.75.75 0 0 0-.25-.759l-1.042-.86 1.396-.108a.75.75 0 0 0 .63-.45L12 10.143l.563 1.305a.75.75 0 0 0 .63.45l1.396.108-1.041.86z",
    "data-ppui": "true"
  })), props.children);
};
var DashboardIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded107);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "dashboard icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.75 3.75h-4.5a1.5 1.5 0 0 0-1.5 1.5v4.5a1.5 1.5 0 0 0 1.5 1.5h4.5a1.5 1.5 0 0 0 1.5-1.5v-4.5a1.5 1.5 0 0 0-1.5-1.5zm0 6h-4.5v-4.5h4.5v4.5zm9-6h-4.5a1.5 1.5 0 0 0-1.5 1.5v4.5a1.5 1.5 0 0 0 1.5 1.5h4.5a1.5 1.5 0 0 0 1.5-1.5v-4.5a1.5 1.5 0 0 0-1.5-1.5zm0 6h-4.5v-4.5h4.5v4.5zm-9 3h-4.5a1.5 1.5 0 0 0-1.5 1.5v4.5a1.5 1.5 0 0 0 1.5 1.5h4.5a1.5 1.5 0 0 0 1.5-1.5v-4.5a1.5 1.5 0 0 0-1.5-1.5zm0 6h-4.5v-4.5h4.5v4.5zm9-6h-4.5a1.5 1.5 0 0 0-1.5 1.5v4.5a1.5 1.5 0 0 0 1.5 1.5h4.5a1.5 1.5 0 0 0 1.5-1.5v-4.5a1.5 1.5 0 0 0-1.5-1.5zm0 6h-4.5v-4.5h4.5v4.5z",
    "data-ppui": "true"
  })), props.children);
};
var DayIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded108);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "day icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.25 3.75V1.5a.75.75 0 1 1 1.5 0v2.25a.75.75 0 1 1-1.5 0zM18 12a6 6 0 1 1-6-6 6.006 6.006 0 0 1 6 6zm-1.5 0a4.5 4.5 0 1 0-9 0 4.5 4.5 0 0 0 9 0zM5.47 6.53a.75.75 0 1 0 1.06-1.06l-1.5-1.5a.75.75 0 1 0-1.06 1.06l1.5 1.5zm0 10.94l-1.5 1.5a.75.75 0 1 0 1.06 1.06l1.5-1.5a.751.751 0 0 0-1.06-1.06zM18 6.75a.75.75 0 0 0 .53-.22l1.5-1.5a.75.75 0 1 0-1.06-1.06l-1.5 1.5A.75.75 0 0 0 18 6.75zm.53 10.72a.75.75 0 1 0-1.06 1.06l1.5 1.5a.75.75 0 1 0 1.06-1.06l-1.5-1.5zM4.5 12a.75.75 0 0 0-.75-.75H1.5a.75.75 0 1 0 0 1.5h2.25A.75.75 0 0 0 4.5 12zm7.5 7.5a.75.75 0 0 0-.75.75v2.25a.75.75 0 1 0 1.5 0v-2.25a.75.75 0 0 0-.75-.75zm10.5-8.25h-2.25a.75.75 0 1 0 0 1.5h2.25a.75.75 0 1 0 0-1.5z",
    "data-ppui": "true"
  })), /*#__PURE__*/React.createElement("defs", {
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "a",
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    "data-ppui": "true"
  })))), props.children);
};
var DealsIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded109);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "deals icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.81 12.75L13.5 3.44A1.487 1.487 0 0 0 12.44 3H3.75a.75.75 0 0 0-.75.75v8.69a1.486 1.486 0 0 0 .44 1.06l9.31 9.31a1.5 1.5 0 0 0 2.122 0l7.938-7.938a1.5 1.5 0 0 0 0-2.122zm-9 9L4.5 12.44V4.5h7.94l9.31 9.31-7.94 7.94zM9 7.875a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0z",
    "data-ppui": "true"
  })), props.children);
};
var DeclineIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded110);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "decline icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.53 9.53L13.06 12l2.47 2.47a.75.75 0 1 1-1.06 1.06L12 13.06l-2.47 2.47a.75.75 0 1 1-1.06-1.06L10.94 12 8.47 9.53a.75.75 0 0 1 1.06-1.06L12 10.94l2.47-2.47a.751.751 0 0 1 1.06 1.06zM21.75 12A9.75 9.75 0 1 1 12 2.25 9.76 9.76 0 0 1 21.75 12zm-1.5 0A8.25 8.25 0 1 0 12 20.25 8.26 8.26 0 0 0 20.25 12z",
    "data-ppui": "true"
  })), props.children);
};
var DeleteIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded111);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "delete icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.25 4.5H16.5v-.75a2.25 2.25 0 0 0-2.25-2.25h-4.5A2.25 2.25 0 0 0 7.5 3.75v.75H3.75a.75.75 0 0 0 0 1.5h.75v13.5A1.5 1.5 0 0 0 6 21h12a1.5 1.5 0 0 0 1.5-1.5V6h.75a.75.75 0 1 0 0-1.5zM9 3.75A.75.75 0 0 1 9.75 3h4.5a.75.75 0 0 1 .75.75v.75H9v-.75zm9 15.75H6V6h12v13.5zm-7.5-9.75v6a.75.75 0 1 1-1.5 0v-6a.75.75 0 0 1 1.5 0zm4.5 0v6a.75.75 0 1 1-1.5 0v-6a.75.75 0 1 1 1.5 0z",
    "data-ppui": "true"
  })), props.children);
};
var DesktopIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded112);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "desktop icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5 3.75h-15A2.25 2.25 0 0 0 2.25 6v10.5a2.25 2.25 0 0 0 2.25 2.25h6.75v1.5H9a.75.75 0 1 0 0 1.5h6a.75.75 0 1 0 0-1.5h-2.25v-1.5h6.75a2.25 2.25 0 0 0 2.25-2.25V6a2.25 2.25 0 0 0-2.25-2.25zm-15 1.5h15a.75.75 0 0 1 .75.75v7.5H3.75V6a.75.75 0 0 1 .75-.75zm15 12h-15a.75.75 0 0 1-.75-.75V15h16.5v1.5a.75.75 0 0 1-.75.75z",
    "data-ppui": "true"
  })), props.children);
};
var DetailedListIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded113);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "detailed list icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.25 6A.75.75 0 0 1 9 5.25h11.25a.75.75 0 1 1 0 1.5H9A.75.75 0 0 1 8.25 6zm12 5.25H9a.75.75 0 1 0 0 1.5h11.25a.75.75 0 1 0 0-1.5zm0 6H9a.75.75 0 1 0 0 1.5h11.25a.75.75 0 1 0 0-1.5zm-15-12h-1.5a.75.75 0 0 0 0 1.5h1.5a.75.75 0 0 0 0-1.5zm0 6h-1.5a.75.75 0 1 0 0 1.5h1.5a.75.75 0 1 0 0-1.5zm0 6h-1.5a.75.75 0 1 0 0 1.5h1.5a.75.75 0 1 0 0-1.5z",
    "data-ppui": "true"
  })), props.children);
};
var DirectDepositIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded114);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "direct deposit icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 3.31V12a.75.75 0 1 1-1.5 0V3.31L8.78 5.03a.75.75 0 0 1-1.06-1.06l3-3a.749.749 0 0 1 1.06 0l3 3a.75.75 0 1 1-1.06 1.06L12 3.31zm6 8.28V9a1.5 1.5 0 0 0-1.5-1.5H15A.75.75 0 1 0 15 9h1.5v7.538a2.625 2.625 0 0 0-4.148 3.15l.022.035 2.087 3.188a.75.75 0 1 0 1.255-.822l-2.074-3.167a1.125 1.125 0 1 1 1.958-1.11.449.449 0 0 0 .022.036l1 1.53A.75.75 0 0 0 18 18.966V13.5a7.017 7.017 0 0 1 2.25 5.127V22.5a.75.75 0 1 0 1.5 0v-3.877A8.52 8.52 0 0 0 18 11.59zM7.5 7.5H6A1.5 1.5 0 0 0 4.5 9v9.75a.75.75 0 1 0 1.5 0V9h1.5a.75.75 0 0 0 0-1.5z",
    "data-ppui": "true"
  })), props.children);
};
var DisasterReliefIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded115);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "disaster relief icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.888 5.324a.75.75 0 1 0-.276-1.475C14.102 4.133 12.844 4.892 12 6c-1.056-1.406-2.752-2.25-4.688-2.25A5.82 5.82 0 0 0 1.5 9.563c0 6.562 9.73 11.875 10.145 12.093a.743.743 0 0 0 .71 0 31.177 31.177 0 0 0 3.852-2.552.749.749 0 1 0-.915-1.187 32.165 32.165 0 0 1-2.542 1.764V7.659c.547-1.214 1.682-2.062 3.138-2.335zM11.25 19.688C8.773 18.131 3 14.035 3 9.563A4.318 4.318 0 0 1 7.313 5.25c1.772 0 3.268.917 3.937 2.404v12.034zM21.802 9.75a.83.83 0 0 1-.084 0 .75.75 0 0 1-.744-.668 4.302 4.302 0 0 0-1.891-3.106.75.75 0 1 1 .834-1.246 5.797 5.797 0 0 1 2.547 4.188.75.75 0 0 1-.662.832zm-.196 3.34c-.532 1.065-1.307 2.156-2.306 3.233a.751.751 0 1 1-1.1-1.018c.9-.975 1.593-1.946 2.062-2.885a.75.75 0 1 1 1.342.67h.002z",
    "data-ppui": "true"
  })), props.children);
};
var DisasterIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded116);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "disaster icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.442 1.673a.75.75 0 0 0-1.184.32l-2.063 5.663L7.93 5.462a.75.75 0 0 0-1.118.083C4.782 8.205 3.75 10.882 3.75 13.5a8.25 8.25 0 1 0 16.5 0c0-5.574-4.762-10.125-6.808-11.827zM12 20.25a6.757 6.757 0 0 1-6.75-6.75c0-2.063.758-4.2 2.256-6.36l2.472 2.398a.75.75 0 0 0 1.227-.281l2.088-5.726C15.395 5.445 18.75 9.18 18.75 13.5A6.758 6.758 0 0 1 12 20.25z",
    "data-ppui": "true"
  })), props.children);
};
var DislikeSelectedIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded117);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "dislike selected icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.483 14.719l-1.125-9a2.25 2.25 0 0 0-2.233-1.969H3a1.5 1.5 0 0 0-1.5 1.5v8.25A1.5 1.5 0 0 0 3 15h4.037l3.542 7.086a.75.75 0 0 0 .671.414A3.75 3.75 0 0 0 15 18.75v-1.5h5.25a2.25 2.25 0 0 0 2.233-2.531zM6.75 13.5H3V5.25h3.75v8.25z",
    "data-ppui": "true"
  })), props.children);
};
var DislikeIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded118);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "dislike icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.483 14.719l-1.125-9a2.25 2.25 0 0 0-2.233-1.969H3a1.5 1.5 0 0 0-1.5 1.5v8.25A1.5 1.5 0 0 0 3 15h4.037l3.542 7.086a.75.75 0 0 0 .671.414A3.75 3.75 0 0 0 15 18.75v-1.5h5.25a2.25 2.25 0 0 0 2.233-2.531zM6.75 13.5H3V5.25h3.75v8.25zm14.063 1.996a.739.739 0 0 1-.563.254h-6a.75.75 0 0 0-.75.75v2.25a2.25 2.25 0 0 1-1.808 2.207L8.25 14.073V5.25h10.875a.75.75 0 0 1 .744.656l1.125 9a.739.739 0 0 1-.181.59z",
    "data-ppui": "true"
  })), props.children);
};
var DisputesIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded119);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "disputes icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5 3h-15A1.5 1.5 0 0 0 3 4.5v15A1.5 1.5 0 0 0 4.5 21h15a1.5 1.5 0 0 0 1.5-1.5v-15A1.5 1.5 0 0 0 19.5 3zm0 1.5v9.75h-2.69a1.486 1.486 0 0 0-1.06.44l-1.81 1.81h-3.88l-1.81-1.81a1.487 1.487 0 0 0-1.06-.44H4.5V4.5h15zm0 15h-15v-3.75h2.69L9 17.56a1.487 1.487 0 0 0 1.06.44h3.88a1.487 1.487 0 0 0 1.06-.44l1.81-1.81h2.69v3.75z",
    "data-ppui": "true"
  })), props.children);
};
var DocumentIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded120);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "document icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.03 7.72l-5.25-5.25a.75.75 0 0 0-.53-.22h-9a1.5 1.5 0 0 0-1.5 1.5v16.5a1.5 1.5 0 0 0 1.5 1.5h13.5a1.5 1.5 0 0 0 1.5-1.5v-12a.75.75 0 0 0-.22-.53zM15 4.81l2.69 2.69H15V4.81zm3.75 15.44H5.25V3.75h8.25v4.5a.75.75 0 0 0 .75.75h4.5v11.25z",
    "data-ppui": "true"
  })), props.children);
};
var DonateIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded121);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "donate icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16.688 3.75c-1.936 0-3.631.832-4.688 2.24-1.057-1.408-2.752-2.24-4.688-2.24A5.82 5.82 0 0 0 1.5 9.563c0 6.562 9.73 11.874 10.145 12.093a.75.75 0 0 0 .71 0c.133-.07 1.215-.66 2.628-1.643.984.733 1.805 1.18 1.902 1.232a.74.74 0 0 0 .7 0 17.024 17.024 0 0 0 2.878-2.018c1.347-1.18 2.761-2.865 2.761-4.789a3.47 3.47 0 0 0-1.12-2.55c.253-.752.396-1.53.396-2.325a5.819 5.819 0 0 0-5.813-5.813zm4.086 7.376A5.714 5.714 0 0 0 21 9.563a4.318 4.318 0 0 0-4.313-4.313c-1.823 0-3.354.968-3.993 2.531a.75.75 0 0 1-1.388 0c-.64-1.56-2.17-2.531-3.993-2.531A4.318 4.318 0 0 0 3 9.563c0 5.033 7.288 9.577 9 10.574a31.235 31.235 0 0 0 1.772-1.121c-1.27-1.166-2.525-2.766-2.525-4.578a3.47 3.47 0 0 1 3.465-3.466c.991 0 1.888.372 2.523 1.025.636-.653 1.533-1.025 2.524-1.025.347 0 .689.053 1.015.154zm-4.224 2.482c-.287-.7-.979-1.153-1.837-1.153a1.986 1.986 0 0 0-1.984 1.983c0 1.203.882 2.405 1.969 3.414.954.885 2.002 1.563 2.537 1.886.536-.323 1.584-1.002 2.538-1.888 1.087-1.009 1.969-2.21 1.97-3.411a1.987 1.987 0 0 0-1.985-1.984c-.859 0-1.55.451-1.837 1.152a.742.742 0 0 1-1.371 0z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};
var DownloadIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded122);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "download icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 13.5v6a.75.75 0 0 1-.75.75H3.75A.75.75 0 0 1 3 19.5v-6a.75.75 0 1 1 1.5 0v5.25h15V13.5a.75.75 0 1 1 1.5 0zm-9.53.53a.747.747 0 0 0 1.06 0l3.75-3.75a.75.75 0 1 0-1.06-1.06l-2.47 2.47V3a.75.75 0 1 0-1.5 0v8.69L8.78 9.22a.75.75 0 0 0-1.06 1.06l3.75 3.75z",
    "data-ppui": "true"
  })), props.children);
};
var DressIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded123);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "dress icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.128 19.66a.17.17 0 0 0-.01-.024l-4.264-9.08 1.922-3.018a1.5 1.5 0 0 0 .01-1.56c-.008-.015-.019-.03-.028-.044L15.75 3.066V.75a.75.75 0 1 0-1.5 0v2.29l-.493.616a2.25 2.25 0 0 1-3.514 0L9.75 3.04V.75a.75.75 0 0 0-1.5 0v2.316L6.242 5.934l-.028.044a1.5 1.5 0 0 0 .01 1.56l1.922 3.017-4.264 9.08A1.5 1.5 0 0 0 5.25 21.75h13.5a1.5 1.5 0 0 0 1.38-2.09h-.002zM7.5 6.75l1.54-2.197.031.04a3.75 3.75 0 0 0 5.858 0l.03-.04L16.5 6.75l-1.91 3H9.411l-1.912-3zm-2.25 13.5l4.225-9h5.048l4.227 9H5.25z",
    "data-ppui": "true"
  })), props.children);
};
var EditIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded124);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "edit icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.31 6.879l-4.188-4.19a1.5 1.5 0 0 0-2.122 0L3.44 14.25A1.487 1.487 0 0 0 3 15.31v4.19A1.5 1.5 0 0 0 4.5 21h4.19a1.485 1.485 0 0 0 1.06-.44L21.31 9a1.5 1.5 0 0 0 0-2.121zM8.69 19.5H4.5v-4.19l8.25-8.25 4.19 4.19-8.25 8.25zM18 10.19L13.81 6l2.25-2.25 4.19 4.189-2.25 2.25z",
    "data-ppui": "true"
  })), props.children);
};
var EducationIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded125);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "education icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.602 8.338l-11.25-6a.75.75 0 0 0-.704 0l-11.25 6a.75.75 0 0 0 0 1.324L3 11.05v4.54c0 .368.135.724.38.998C4.61 17.956 7.36 20.25 12 20.25a12.188 12.188 0 0 0 4.5-.821v3.07a.75.75 0 1 0 1.5 0v-3.795a10.84 10.84 0 0 0 2.62-2.116c.245-.274.38-.63.38-.998v-4.54l2.602-1.388a.75.75 0 0 0 0-1.324zM12 18.75c-4.057 0-6.442-1.982-7.5-3.16v-3.74l7.148 3.812a.751.751 0 0 0 .704 0L16.5 13.45v4.345c-1.181.55-2.67.955-4.5.955zm7.5-3.164c-.45.499-.953.947-1.5 1.336V12.65l1.5-.8v3.736zm-1.875-4.436l-.02-.012-5.25-2.8a.75.75 0 0 0-.706 1.324L16.031 12 12 14.15 2.344 9 12 3.85 21.656 9l-4.031 2.15z",
    "data-ppui": "true"
  })), props.children);
};
var ElectricityIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded126);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "electricity icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.03 12.97a.75.75 0 0 0-1.06 0l-1.72 1.72-1.94-1.94 1.72-1.72a.75.75 0 1 0-1.06-1.06l-1.72 1.72-1.72-1.72a.75.75 0 0 0-1.06 1.06l.595.595-2.187 2.185a3 3 0 0 0 0 4.243l.505.504-2.664 2.663a.75.75 0 1 0 1.062 1.06l2.662-2.663.504.505a3 3 0 0 0 4.243 0l2.185-2.187.594.596a.75.75 0 1 0 1.062-1.061l-1.72-1.72 1.72-1.72a.75.75 0 0 0 0-1.06zm-4.902 6.093a1.5 1.5 0 0 1-2.12 0l-2.068-2.07a1.5 1.5 0 0 1 0-2.121l2.185-2.187 4.19 4.19-2.187 2.188zM22.281 1.72a.75.75 0 0 0-1.062 0l-2.662 2.664-.503-.504a3.005 3.005 0 0 0-4.244 0l-2.185 2.186-.594-.596a.75.75 0 0 0-1.062 1.062l7.5 7.5a.75.75 0 1 0 1.062-1.062l-.596-.594 2.187-2.185a3 3 0 0 0 0-4.243l-.505-.504 2.664-2.662a.751.751 0 0 0 0-1.062zm-3.22 7.407l-2.186 2.189-4.19-4.19 2.187-2.185a1.5 1.5 0 0 1 2.12 0l2.068 2.062a1.5 1.5 0 0 1 0 2.127v-.003z",
    "data-ppui": "true"
  })), props.children);
};
var EmailIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded127);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "email icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 4.5H3a.75.75 0 0 0-.75.75V18a1.5 1.5 0 0 0 1.5 1.5h16.5a1.5 1.5 0 0 0 1.5-1.5V5.25A.75.75 0 0 0 21 4.5zm-9 7.983L4.928 6h14.144L12 12.483zM9.254 12L3.75 17.045V6.955L9.254 12zm1.11 1.017l1.125 1.036a.75.75 0 0 0 1.014 0l1.125-1.036L19.066 18H4.928l5.436-4.983zM14.746 12l5.504-5.046v10.092L14.746 12z",
    "data-ppui": "true"
  })), props.children);
};
var EmojiIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded128);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "emoji icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 2.25A9.75 9.75 0 1 0 21.75 12 9.76 9.76 0 0 0 12 2.25zm0 18A8.25 8.25 0 1 1 20.25 12 8.26 8.26 0 0 1 12 20.25zM7.5 10.125a1.125 1.125 0 1 1 2.25 0 1.125 1.125 0 0 1-2.25 0zm9 0a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0zm-.1 4.5c-.965 1.668-2.57 2.625-4.4 2.625-1.83 0-3.434-.956-4.399-2.625a.75.75 0 1 1 1.298-.75c.7 1.21 1.8 1.875 3.101 1.875 1.3 0 2.4-.666 3.1-1.875a.75.75 0 0 1 1.3.75z",
    "data-ppui": "true"
  })), props.children);
};
var EnvironmentIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded129);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "environment icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.215 4.49a.75.75 0 0 0-.705-.706c-4.852-.28-8.748 1.195-10.423 3.959-1.106 1.827-1.104 4.046-.015 6.163a6.688 6.688 0 0 0-1.328 2.531l-1.526-1.53c.734-1.532.705-3.127-.093-4.453-1.238-2.043-4.094-3.138-7.64-2.93a.75.75 0 0 0-.706.705c-.209 3.547.887 6.403 2.93 7.64.674.413 1.449.63 2.239.63a5.117 5.117 0 0 0 2.208-.53l2.344 2.343V21a.75.75 0 1 0 1.5 0v-2.765a5.214 5.214 0 0 1 1.15-3.281 6.93 6.93 0 0 0 3.123.787 5.71 5.71 0 0 0 2.984-.83c2.764-1.673 4.243-5.569 3.958-10.421zM4.482 14.586C3.044 13.717 2.23 11.655 2.25 9c2.655-.023 4.717.794 5.588 2.232.454.75.528 1.625.23 2.526L5.78 11.469a.75.75 0 0 0-1.06 1.06l2.288 2.289c-.901.298-1.775.224-2.526-.23zm13.998-.958c-1.256.76-2.733.819-4.233.188l5.034-5.035a.75.75 0 0 0-1.06-1.06l-5.035 5.028c-.634-1.5-.577-2.978.188-4.233 1.306-2.156 4.406-3.358 8.374-3.265.09 3.967-1.11 7.07-3.268 8.377z",
    "data-ppui": "true"
  })), props.children);
};
var EthereumIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded130);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "ethereum icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.84 11.537l-8.25-10.5a.75.75 0 0 0-1.18 0l-8.25 10.5a.75.75 0 0 0 0 .926l8.25 10.5a.749.749 0 0 0 1.18 0l8.25-10.5a.75.75 0 0 0 0-.926zm-8.09-7.869l6.32 8.044-6.32 2.874V3.668zm-1.5 10.918l-6.32-2.874 6.32-8.044v10.918zm0 1.647v4.098l-5.01-6.374 5.01 2.276zm1.5 0l5.009-2.277-5.01 6.375v-4.098z",
    "data-ppui": "true"
  })), props.children);
};
var FaceIdIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded131);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "face id icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.275 5.428a.736.736 0 0 0-.735.736v1.6a.736.736 0 0 1-1.472 0v-1.6c0-1.22.988-2.207 2.207-2.207h1.71a.736.736 0 1 1 0 1.471h-1.71zm11.518 0c.406 0 .736.33.736.736v1.6a.736.736 0 1 0 1.471 0v-1.6c0-1.22-.988-2.207-2.207-2.207h-1.71a.736.736 0 0 0 0 1.471h1.71zm-5.072 4.719a.687.687 0 1 0-1.374 0v2.07h-.232a.687.687 0 0 0 0 1.373h.91a.696.696 0 0 0 .696-.696v-2.747zm3.318 4.85a.736.736 0 1 0-1.04-1.04l-.144.144a3.99 3.99 0 0 1-5.643 0l-.142-.142a.736.736 0 1 0-1.041 1.04l.142.143a5.462 5.462 0 0 0 7.724 0l.144-.144zm2.49 2.77c0 .406-.33.735-.736.735h-1.71a.736.736 0 0 0 0 1.472h1.71A2.207 2.207 0 0 0 20 17.766v-1.6a.736.736 0 0 0-1.471 0v1.6zm-12.99 0c0 .406.33.735.736.735h1.71a.736.736 0 0 1 0 1.472h-1.71a2.207 2.207 0 0 1-2.207-2.208v-1.6a.736.736 0 0 1 1.472 0v1.6zm3.548-9.683c.406 0 .736.33.736.736v1.867a.736.736 0 1 1-1.472 0V8.82c0-.407.33-.736.736-.736zm6.63.736a.736.736 0 0 0-1.472 0v1.867a.736.736 0 1 0 1.472 0V8.82z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};
var FamilySupportIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded132);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "family support icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 10.587c.52-.492 1.227-.77 2.002-.77a2.86 2.86 0 0 1 2.857 2.858c0 1.577-1.156 2.941-2.228 3.88a13.603 13.603 0 0 1-2.304 1.616.695.695 0 0 1-.655 0 13.618 13.618 0 0 1-2.303-1.616c-1.072-.938-2.228-2.304-2.228-3.88a2.86 2.86 0 0 1 2.857-2.857c.775 0 1.482.277 2.002.77zm3.469 2.088a1.469 1.469 0 0 0-1.467-1.467c-.643 0-1.15.337-1.359.849a.695.695 0 0 1-1.286 0c-.21-.512-.716-.849-1.359-.849a1.47 1.47 0 0 0-1.467 1.467c0 .906.67 1.832 1.528 2.63a12.625 12.625 0 0 0 1.94 1.45 12.664 12.664 0 0 0 1.941-1.452c.86-.798 1.529-1.724 1.529-2.628z",
    clipRule: "evenodd",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M13.06 2.688l7.5 7.5A1.487 1.487 0 0 1 21 11.25v9a.75.75 0 0 1-.75.75H3.75a.75.75 0 0 1-.75-.75v-9a1.488 1.488 0 0 1 .44-1.062l7.5-7.5a1.5 1.5 0 0 1 2.12 0zM4.5 11.25v8.25h15v-8.25L12 3.75l-7.5 7.5z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};
var FaqIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded133);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "faq icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.174 9.64c-.353-.37-.719-.75-.857-1.085-.127-.307-.134-.815-.142-1.307-.014-.915-.03-1.952-.75-2.673-.72-.72-1.758-.736-2.673-.75-.492-.008-1-.015-1.307-.143-.333-.137-.715-.503-1.084-.856C13.714 2.204 12.979 1.5 12 1.5c-.979 0-1.713.704-2.36 1.326-.37.353-.75.719-1.085.857-.305.127-.815.135-1.307.142-.915.014-1.952.03-2.673.75-.72.72-.731 1.758-.75 2.673-.008.492-.015 1-.143 1.307-.137.333-.503.715-.856 1.084C2.204 10.286 1.5 11.021 1.5 12c0 .979.704 1.713 1.326 2.36.353.37.719.75.857 1.085.127.307.135.815.142 1.307.014.915.03 1.952.75 2.673.72.72 1.758.736 2.673.75.492.008 1 .015 1.307.142.333.138.715.504 1.084.857.647.622 1.382 1.326 2.361 1.326.979 0 1.713-.704 2.36-1.326.37-.353.75-.719 1.085-.857.307-.127.815-.134 1.307-.142.915-.014 1.952-.03 2.673-.75.72-.72.736-1.758.75-2.673.008-.492.015-1 .142-1.307.138-.333.504-.715.857-1.084.622-.647 1.326-1.382 1.326-2.361 0-.979-.704-1.713-1.326-2.36zm-1.082 3.683c-.45.469-.915.953-1.161 1.549-.236.571-.247 1.225-.256 1.858-.01.656-.02 1.343-.311 1.634-.292.29-.974.302-1.634.311-.633.01-1.287.02-1.858.256-.596.246-1.08.711-1.55 1.16-.468.45-.947.909-1.322.909-.375 0-.858-.461-1.323-.908-.465-.448-.953-.915-1.549-1.161-.571-.236-1.225-.247-1.858-.256-.656-.01-1.343-.02-1.634-.311-.29-.292-.302-.974-.311-1.634-.01-.633-.02-1.287-.256-1.858-.247-.596-.712-1.08-1.16-1.55C3.458 12.855 3 12.376 3 12c0-.375.461-.858.908-1.323.448-.465.914-.953 1.161-1.549.236-.571.247-1.225.256-1.858.01-.656.02-1.343.311-1.634.292-.29.974-.302 1.634-.311.633-.01 1.287-.02 1.858-.256.596-.247 1.08-.712 1.55-1.16C11.145 3.458 11.624 3 12 3c.375 0 .858.461 1.323.908.465.448.953.914 1.549 1.161.571.236 1.225.247 1.858.256.656.01 1.343.02 1.634.311.29.292.302.974.311 1.634.01.633.02 1.287.256 1.858.246.596.711 1.08 1.16 1.55.45.468.909.947.909 1.322 0 .375-.461.858-.908 1.323zm-6.967 3.552a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0zm2.625-6.75c0 1.63-1.29 2.993-3 3.307v.068a.75.75 0 1 1-1.5 0v-.75A.75.75 0 0 1 12 12c1.24 0 2.25-.844 2.25-1.875 0-1.031-1.01-1.875-2.25-1.875s-2.25.844-2.25 1.875v.375a.75.75 0 1 1-1.5 0v-.375c0-1.86 1.682-3.375 3.75-3.375s3.75 1.514 3.75 3.375z",
    "data-ppui": "true"
  })), props.children);
};
var FavoriteSelectedIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded134);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "favorite selected icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5 9.563c0 6.562-9.73 11.874-10.145 12.093a.75.75 0 0 1-.71 0C11.23 21.436 1.5 16.125 1.5 9.563A5.82 5.82 0 0 1 7.313 3.75c1.935 0 3.63.832 4.687 2.24 1.057-1.408 2.752-2.24 4.688-2.24A5.819 5.819 0 0 1 22.5 9.563z",
    "data-ppui": "true"
  })), props.children);
};
var FavoriteIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded135);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "favorite icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.688 3.75c-1.936 0-3.631.832-4.688 2.24-1.057-1.408-2.752-2.24-4.688-2.24A5.82 5.82 0 0 0 1.5 9.563c0 6.562 9.73 11.874 10.145 12.093a.75.75 0 0 0 .71 0c.415-.22 10.145-5.531 10.145-12.093a5.819 5.819 0 0 0-5.813-5.813zM12 20.137c-1.712-.997-9-5.541-9-10.575A4.318 4.318 0 0 1 7.313 5.25c1.823 0 3.354.971 3.993 2.531a.75.75 0 0 0 1.388 0c.64-1.563 2.17-2.531 3.993-2.531A4.318 4.318 0 0 1 21 9.563c0 5.025-7.29 9.576-9 10.574z",
    "data-ppui": "true"
  })), props.children);
};
var FilterIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded136);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "filter icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.75 8.25h3.094a3 3 0 0 0 5.812 0h7.594a.75.75 0 1 0 0-1.5h-7.594a3 3 0 0 0-5.812 0H3.75a.75.75 0 0 0 0 1.5zm6-2.25a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3zm10.5 9.75h-1.594a3 3 0 0 0-5.812 0H3.75a.75.75 0 1 0 0 1.5h9.094a3 3 0 0 0 5.812 0h1.594a.75.75 0 1 0 0-1.5zM15.75 18a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z",
    "data-ppui": "true"
  })), props.children);
};
var FingerprintIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded137);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "fingerprint icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.75 12a12.622 12.622 0 0 1-1.328 5.67.75.75 0 1 1-1.342-.668A11.138 11.138 0 0 0 5.25 12a6.725 6.725 0 0 1 2.531-5.269.75.75 0 1 1 .938 1.171A5.227 5.227 0 0 0 6.75 12zm5.25-.75a.75.75 0 0 0-.75.75 17.26 17.26 0 0 1-2.156 8.353.75.75 0 0 0 1.312.728A18.768 18.768 0 0 0 12.75 12a.75.75 0 0 0-.75-.75zm0-3A3.75 3.75 0 0 0 8.25 12a.75.75 0 1 0 1.5 0 2.25 2.25 0 0 1 4.5 0 20.071 20.071 0 0 1-1.923 8.625.751.751 0 1 0 1.36.64A21.563 21.563 0 0 0 15.75 12 3.75 3.75 0 0 0 12 8.25zm0-6A9.76 9.76 0 0 0 2.25 12a8.227 8.227 0 0 1-.469 2.75.75.75 0 1 0 1.415.5A9.741 9.741 0 0 0 3.75 12a8.25 8.25 0 0 1 16.5 0 26.51 26.51 0 0 1-.496 5.105.75.75 0 0 0 1.471.29c.35-1.777.525-3.584.525-5.395A9.761 9.761 0 0 0 12 2.25zM8.85 14.266a.75.75 0 0 0-.881.586 14.156 14.156 0 0 1-1.614 4.26.75.75 0 1 0 1.3.75 15.626 15.626 0 0 0 1.78-4.711.75.75 0 0 0-.585-.885zM12 5.25a6.83 6.83 0 0 0-.844.053.75.75 0 0 0 .188 1.487A5.257 5.257 0 0 1 17.25 12c0 .972-.06 1.942-.18 2.906a.75.75 0 0 0 1.238.662.75.75 0 0 0 .247-.469 24.8 24.8 0 0 0 .188-3.093A6.757 6.757 0 0 0 12 5.25zm5.43 12.023a.75.75 0 0 0-.913.54 24.593 24.593 0 0 1-.469 1.593.75.75 0 0 0 1.146.848.75.75 0 0 0 .273-.37 24.12 24.12 0 0 0 .501-1.693.752.752 0 0 0-.536-.917h-.001z",
    "data-ppui": "true"
  })), props.children);
};
var FlagIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded138);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "flag icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.747 9.041l-17.25-6a.75.75 0 0 0-.997.709v16.5a.75.75 0 0 0 1.5 0v-3.967l16.747-5.824a.75.75 0 0 0 0-1.418zM6 14.695v-9.89L20.217 9.75 6 14.695z",
    "data-ppui": "true"
  })), props.children);
};
var FlashOffIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded139);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "flash off icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.055 3.246a.75.75 0 1 0-1.11 1.008l3.68 4.048-3.673 3.938a.75.75 0 0 0 .28 1.219l5.404 2.026-1.371 6.868a.75.75 0 0 0 1.283.656l5.8-6.214 3.597 3.957a.753.753 0 0 0 .813.208.75.75 0 0 0 .297-1.217l-15-16.497zm5.198 16.817l.982-4.911a.75.75 0 0 0-.469-.85l-4.954-1.86 2.824-3.026 5.698 6.268-4.08 4.379zm-.066-13.407a.752.752 0 0 1-.037-1.06L14.451.987a.75.75 0 0 1 1.284.656L14.36 8.522l5.402 2.026a.75.75 0 0 1 .282 1.214l-2.091 2.24a.75.75 0 0 1-1.097-1.023l1.33-1.42-4.95-1.857a.75.75 0 0 1-.468-.85l.981-4.91-2.5 2.679a.75.75 0 0 1-1.063.035z",
    "data-ppui": "true"
  })), props.children);
};
var FlashSelectedIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded140);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "flash selected icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.048 11.762l-10.5 11.25a.75.75 0 0 1-1.283-.657l1.374-6.874-5.402-2.029a.75.75 0 0 1-.282-1.219l10.5-11.25a.75.75 0 0 1 1.284.657L14.36 8.522l5.402 2.026a.75.75 0 0 1 .282 1.214h.003z",
    "data-ppui": "true"
  })), props.children);
};
var FlashIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded141);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "flash icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.23 11.079a.75.75 0 0 0-.468-.531L14.36 8.522l1.374-6.875a.75.75 0 0 0-1.283-.656l-10.5 11.25a.75.75 0 0 0 .28 1.219l5.404 2.026-1.371 6.867a.75.75 0 0 0 1.283.656l10.5-11.25a.75.75 0 0 0 .182-.68zm-9.976 8.984l.981-4.911a.75.75 0 0 0-.469-.85l-4.953-1.86 7.933-8.5-.981 4.911a.75.75 0 0 0 .469.85l4.95 1.856-7.93 8.504z",
    "data-ppui": "true"
  })), props.children);
};
var FlowersIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded142);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "flowers icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5 4.5a8.201 8.201 0 0 0-3.315.697c-1.416-2.379-3.742-3.563-3.85-3.618a.75.75 0 0 0-.67 0c-.107.054-2.438 1.24-3.85 3.618A8.201 8.201 0 0 0 4.5 4.5a.75.75 0 0 0-.75.75V9a8.26 8.26 0 0 0 7.5 8.215v3.322l-3.414-1.708a.748.748 0 0 0-1.007.335.75.75 0 0 0 .335 1.007l4.5 2.25a.75.75 0 0 0 .672 0l4.5-2.25a.75.75 0 1 0-.672-1.342l-3.414 1.708v-3.322A8.26 8.26 0 0 0 20.25 9V5.25a.75.75 0 0 0-.75-.75zm-8.25 11.209A6.76 6.76 0 0 1 5.25 9V6.041a6.76 6.76 0 0 1 6 6.709v2.959zM12 9.315a8.287 8.287 0 0 0-2.873-3.39c.898-1.481 2.25-2.429 2.873-2.813.623.382 1.976 1.33 2.873 2.812A8.293 8.293 0 0 0 12 9.315zM18.75 9a6.76 6.76 0 0 1-6 6.709V12.75a6.76 6.76 0 0 1 6-6.709V9z",
    "data-ppui": "true"
  })), props.children);
};
var FolderStarFillIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded143);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "folder star fill icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.227 15.73l-2.11 1.742.642 2.598a.75.75 0 0 1-1.108.826l-2.401-1.413-2.4 1.413a.75.75 0 0 1-1.11-.826l.643-2.598-2.11-1.743a.75.75 0 0 1 .419-1.325l2.797-.217 1.072-2.484a.75.75 0 0 1 1.378 0l1.072 2.484 2.797.217a.75.75 0 0 1 .42 1.325zM12.052 19.5a.75.75 0 0 1-.75.75h-7.61a1.444 1.444 0 0 1-1.442-1.442V5.25a1.5 1.5 0 0 1 1.5-1.5h4.94a1.487 1.487 0 0 1 1.06.44l2.56 2.56h7.94a1.5 1.5 0 0 1 1.5 1.5v3a.75.75 0 1 1-1.5 0v-3H3.75v10.5h7.553a.75.75 0 0 1 .75.75zM3.75 6.75h6.44l-1.5-1.5H3.75v1.5z",
    "data-ppui": "true"
  })), props.children);
};
var FoodIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded144);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "food icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5 7.5a3.75 3.75 0 0 0-3.75-3.75H4.5A3.75 3.75 0 0 0 3 10.936v7.814a1.5 1.5 0 0 0 1.5 1.5h14.25a1.5 1.5 0 0 0 1.5-1.5v-7.814A3.755 3.755 0 0 0 22.5 7.5zm-18 3.75a.75.75 0 1 0 0-1.5 2.25 2.25 0 1 1 0-4.5h9a2.25 2.25 0 1 1 0 4.5.75.75 0 0 0 0 1.5v7.5h-9v-7.5zm14.25-1.5a.75.75 0 0 0 0 1.5v7.5H15v-7.814a3.749 3.749 0 0 0 1.5-5.686h2.25a2.25 2.25 0 1 1 0 4.5z",
    "data-ppui": "true"
  })), props.children);
};
var FundraiserIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded145);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "fundraiser icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8.452 1.505a.75.75 0 0 0-.664.4l-1.35 2.566a.75.75 0 0 0-.087.35v8.726a2.889 2.889 0 0 0-.04.04L4.19 15.71H1.5a1.5 1.5 0 0 0-1.5 1.5v3.75a1.5 1.5 0 0 0 1.5 1.5h9.75a.74.74 0 0 0 .182-.022l6-1.5a.688.688 0 0 0 .112-.038l3.643-1.55.042-.02a2.306 2.306 0 0 0 .368-3.895h-.004a2.309 2.309 0 0 0-.064-.048V4.82a.75.75 0 0 0-.081-.339l-1.3-2.565a.75.75 0 0 0-.668-.41H8.452zm11.577 13.46v-9.45H7.85v7.25c.191-.038.386-.056.58-.056h4.694a2.625 2.625 0 0 1 2.555 3.23l3.922-.902c.14-.038.283-.062.427-.072zM8.373 4.015l.532-1.01h10.114l.51 1.01H8.374zM1.5 20.958h2.25v-3.75H1.5v3.75zm15.51-1.463l3.562-1.517h-.003a.807.807 0 0 0-.59-1.49l-.03.007-6.281 1.445a.776.776 0 0 1-.168.018h-3a.75.75 0 1 1 0-1.5h2.625a1.125 1.125 0 1 0 0-2.25H8.432a1.489 1.489 0 0 0-1.06.44l-2.122 2.12v4.19h5.906l5.853-1.463z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};
var FurnitureIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded146);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "furniture icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.25 8.325V6.75A3.75 3.75 0 0 0 16.5 3h-9a3.75 3.75 0 0 0-3.75 3.75v1.575a3.75 3.75 0 0 0 0 7.35v3.075a1.5 1.5 0 0 0 1.5 1.5h13.5a1.5 1.5 0 0 0 1.5-1.5v-3.075a3.75 3.75 0 0 0 0-7.35zM7.5 4.5h9a2.25 2.25 0 0 1 2.25 2.25v1.575a3.756 3.756 0 0 0-3 3.675h-7.5a3.757 3.757 0 0 0-3-3.675V6.75A2.25 2.25 0 0 1 7.5 4.5zm12.037 9.75H19.5a.75.75 0 0 0-.75.75v3.75H5.25V15a.75.75 0 0 0-.75-.75h-.037A2.25 2.25 0 1 1 6.75 12v3.75a.75.75 0 1 0 1.5 0V13.5h7.5v2.25a.75.75 0 1 0 1.5 0V12a2.249 2.249 0 1 1 2.287 2.25z",
    "data-ppui": "true"
  })), props.children);
};
var GasPumpIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded147);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "gas pump icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.594 6.53L20.78 4.72a.75.75 0 1 0-1.062 1.06l1.812 1.814c.14.14.218.33.219.528v7.628a.75.75 0 1 1-1.5 0V12A2.25 2.25 0 0 0 18 9.75h-1.5v-4.5A2.25 2.25 0 0 0 14.25 3h-7.5A2.25 2.25 0 0 0 4.5 5.25V19.5H3A.75.75 0 1 0 3 21h15a.75.75 0 1 0 0-1.5h-1.5v-8.25H18a.75.75 0 0 1 .75.75v3.75a2.25 2.25 0 0 0 4.5 0V8.122a2.237 2.237 0 0 0-.656-1.591zM6 19.5V5.25a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 .75.75V19.5H6zm7.5-9a.75.75 0 0 1-.75.75h-4.5a.75.75 0 1 1 0-1.5h4.5a.75.75 0 0 1 .75.75z",
    "data-ppui": "true"
  })), props.children);
};
var GeneralSupportIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded148);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "general support icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M14.15 9.09a3.005 3.005 0 0 1 3 3.002c0 1.662-1.22 3.11-2.368 4.117a14.54 14.54 0 0 1-2.461 1.726.681.681 0 0 1-.643-.001 14.554 14.554 0 0 1-2.46-1.725C8.07 15.203 6.85 13.755 6.85 12.093a3.006 3.006 0 0 1 3-3.003c.838 0 1.6.307 2.149.852.549-.545 1.31-.852 2.15-.852zm1.638 3.003c0 1-.737 2.01-1.661 2.868A13.69 13.69 0 0 1 12 16.547a13.64 13.64 0 0 1-2.127-1.584c-.924-.858-1.66-1.869-1.66-2.87a1.642 1.642 0 0 1 1.639-1.64c.713 0 1.282.376 1.518.951a.684.684 0 0 0 1.01.307.681.681 0 0 0 .25-.307c.236-.576.805-.95 1.518-.95a1.642 1.642 0 0 1 1.64 1.64z",
    clipRule: "evenodd",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M19.421 3.414l1.5 3c.052.105.079.22.079.336V19.5a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 3 19.5V6.75c0-.116.027-.231.079-.336l1.5-3A.75.75 0 0 1 5.25 3h13.5a.75.75 0 0 1 .671.414zM18.287 4.5H5.713L4.963 6h14.074l-.75-1.5zM4.5 19.5h15v-12h-15v12z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};
var GetDirectionsIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded149);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "get directions icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.72 11.47a.75.75 0 0 0 .53 1.28h5.69l-1.72 1.72a.75.75 0 0 0 1.06 1.06l3-3a.75.75 0 0 0 0-1.06l-3-3a.75.75 0 0 0-1.06 1.06l1.72 1.72H8.25a.75.75 0 0 0-.53.22z",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M22.387 12.572c.075-.181.114-.376.113-.572a1.486 1.486 0 0 0-.433-1.058l-9.005-9.005a1.5 1.5 0 0 0-2.115 0l-9.004 9.005a1.5 1.5 0 0 0 0 2.115l9 9.006a1.5 1.5 0 0 0 2.114 0l9.005-9.006c.14-.138.25-.303.325-.485zM12 3l9 9-9 9-9-9 9-9z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};
var GiftCardIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded150);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "gift card icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.53 13.594a.75.75 0 0 0-.53-1.28H6a.75.75 0 1 0 0 1.5h12a.75.75 0 0 0 .53-.22zM6 15.313h9.75a.75.75 0 1 1 0 1.5H6a.75.75 0 1 1 0-1.5z",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M20.25 8.243h-3.289l.031-.026.079-.067A2.768 2.768 0 0 0 18 6.14a3.057 3.057 0 0 0-3.146-3.146 2.768 2.768 0 0 0-2.01.929c-.35.405-.635.863-.844 1.357a5.15 5.15 0 0 0-.844-1.357 2.768 2.768 0 0 0-2.01-.93A3.058 3.058 0 0 0 6 6.142a2.768 2.768 0 0 0 1.039 2.102H3.75a1.5 1.5 0 0 0-1.448 1.11h.004a1.5 1.5 0 0 0-.056.405v9.75a1.5 1.5 0 0 0 1.5 1.5h16.5a1.5 1.5 0 0 0 1.5-1.5v-9.75c0-.138-.02-.274-.056-.405h.004a1.5 1.5 0 0 0-1.448-1.11zm-6.281-3.327a1.284 1.284 0 0 1 .937-.422h.046a1.559 1.559 0 0 1 1.548 1.6 1.283 1.283 0 0 1-.422.938c-.89.788-2.366 1.065-3.281 1.163.112-.993.422-2.436 1.172-3.279zM7.96 4.95a1.56 1.56 0 0 1 1.095-.457h.046a1.283 1.283 0 0 1 .938.422c.786.89 1.064 2.363 1.161 3.274-.91-.094-2.385-.375-3.273-1.161a1.284 1.284 0 0 1-.422-.938 1.556 1.556 0 0 1 .452-1.14h.003zm12.29 4.808v9.75H3.75v-9.75h16.5z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};
var GoalsIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded151);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "goals icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.8 7.796a9.76 9.76 0 1 1-2.456-3.202l2.125-2.127a.75.75 0 1 1 1.062 1.062l-9 9a.75.75 0 1 1-1.062-1.062l2.6-2.598a3.75 3.75 0 1 0 1.674 2.914.751.751 0 0 1 1.5-.084 5.25 5.25 0 1 1-2.098-3.905l2.133-2.133a8.239 8.239 0 1 0 2.169 2.782.75.75 0 0 1 1.353-.647z",
    "data-ppui": "true"
  })), props.children);
};
var GoldIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded152);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "gold icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.08 2.671a.75.75 0 0 1 .75.75v1.652c1.945.243 3.625 1.358 4.682 2.943a.75.75 0 1 1-1.247.832c-.945-1.416-2.496-2.324-4.234-2.324-2.826 0-5.179 2.419-5.179 5.482s2.353 5.482 5.179 5.482c2.296 0 4.278-1.595 4.942-3.839h-3.232a.75.75 0 1 1 0-1.5H17.9a.75.75 0 0 1 .743.852c-.421 3.088-2.792 5.563-5.812 5.938v1.64a.75.75 0 0 1-1.5 0V18.95c-3.387-.367-5.978-3.367-5.978-6.944s2.591-6.577 5.978-6.944v-1.64a.75.75 0 0 1 .75-.75z",
    "data-ppui": "true"
  })), props.children);
};
var GourmetFoodIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded153);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "gourmet food icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.75 8.25v-4.5a.75.75 0 1 1 1.5 0v4.5a.75.75 0 0 1-1.5 0zm13.5-4.5V21a.75.75 0 0 1-1.5 0v-4.5h-4.5a.75.75 0 0 1-.75-.75c.035-1.797.262-3.584.677-5.332.917-3.796 2.655-6.34 5.028-7.357a.75.75 0 0 1 1.045.689zm-1.5 1.303c-3.016 2.304-3.607 7.914-3.722 9.947h3.722V5.053zm-7.51-1.426a.749.749 0 1 0-1.48.247l.74 4.435a3 3 0 0 1-6 0l.739-4.435a.75.75 0 1 0-1.48-.247l-.75 4.5A.766.766 0 0 0 3 8.25a4.507 4.507 0 0 0 3.75 4.436V21a.75.75 0 0 0 1.5 0v-8.314A4.506 4.506 0 0 0 12 8.25a.766.766 0 0 0-.01-.123l-.75-4.5z",
    "data-ppui": "true"
  })), props.children);
};
var GrantsIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded154);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "grants icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.25 9a8.25 8.25 0 1 0-13.5 6.36v7.14a.75.75 0 0 0 1.086.671L12 21.094l4.165 2.082c.105.05.22.075.335.074a.75.75 0 0 0 .75-.75v-7.14a8.237 8.237 0 0 0 3-6.36zm-15 0A6.75 6.75 0 1 1 12 15.75 6.758 6.758 0 0 1 5.25 9zm10.5 12.287l-3.415-1.707a.75.75 0 0 0-.672 0L8.25 21.287v-4.94a8.24 8.24 0 0 0 7.5 0v4.94zM12 14.25a5.25 5.25 0 1 0 0-10.499 5.25 5.25 0 0 0 0 10.499zm0-9a3.75 3.75 0 1 1 0 7.5 3.75 3.75 0 0 1 0-7.5z",
    "data-ppui": "true"
  })), props.children);
};
var HandSwipeRightIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded155);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "hand swipe right icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.25 13.125V16.5c0 2.4-.796 4.017-.83 4.086a.75.75 0 1 1-1.34-.671c.005-.012.671-1.389.671-3.415v-3.375a1.125 1.125 0 0 0-2.25 0v.375a.75.75 0 0 1-1.5 0v-1.875a1.125 1.125 0 0 0-2.25 0v1.125a.75.75 0 0 1-1.5 0V6.375a1.125 1.125 0 0 0-2.25 0V16.5a.75.75 0 0 1-1.387.397l-1.75-2.813-.014-.021a1.125 1.125 0 1 0-1.95 1.125l2.746 4.687a.75.75 0 1 1-1.295.75l-2.748-4.687a2.626 2.626 0 0 1 4.538-2.641l.359.578v-7.5a2.625 2.625 0 1 1 5.25 0v2.878a2.625 2.625 0 0 1 3.623 1.565 2.625 2.625 0 0 1 3.877 2.307zm3.53-8.406l-3-3a.75.75 0 1 0-1.06 1.062L21.44 4.5H16.5a.75.75 0 1 0 0 1.5h4.94l-1.72 1.718a.75.75 0 1 0 1.06 1.062l3-3a.75.75 0 0 0 0-1.062z",
    "data-ppui": "true"
  })), /*#__PURE__*/React.createElement("defs", {
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "a",
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    "data-ppui": "true"
  })))), props.children);
};
var HandbagsIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded156);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "handbags icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.49 18.574l-1.337-11.25A1.5 1.5 0 0 0 19.653 6H16.5a4.5 4.5 0 1 0-9 0H4.343a1.5 1.5 0 0 0-1.5 1.324l-1.336 11.25A1.5 1.5 0 0 0 3 20.25h17.992a1.512 1.512 0 0 0 1.133-.506 1.502 1.502 0 0 0 .365-1.17zM12 3a3 3 0 0 1 3 3H9a3 3 0 0 1 3-3zM3 18.75L4.343 7.5H7.5v2.25a.75.75 0 1 0 1.5 0V7.5h6v2.25a.75.75 0 1 0 1.5 0V7.5h3.164l1.328 11.25H3z",
    "data-ppui": "true"
  })), props.children);
};
var HealthIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded157);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "health icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.625 15a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0zm-.427 3.683A4.507 4.507 0 0 1 15.75 22.5H13.5A4.504 4.504 0 0 1 9 18v-3.798A6 6 0 0 1 3.75 8.25v-4.5A.75.75 0 0 1 4.5 3h2.25a.75.75 0 0 1 0 1.5h-1.5v3.75a4.5 4.5 0 0 0 4.56 4.5c2.448-.032 4.44-2.086 4.44-4.578V4.5h-1.5a.75.75 0 1 1 0-1.5H15a.75.75 0 0 1 .75.75v4.422c0 3.079-2.3 5.652-5.25 6.03V18a3 3 0 0 0 3 3h2.25a3.006 3.006 0 0 0 2.927-2.344 3.75 3.75 0 1 1 1.521.026v.001zM21.75 15a2.25 2.25 0 1 0-4.5 0 2.25 2.25 0 0 0 4.5 0z",
    "data-ppui": "true"
  })), props.children);
};
var HelpIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded158);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "help icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 2.25A9.75 9.75 0 1 0 21.75 12 9.76 9.76 0 0 0 12 2.25zm3.666 12.355a4.485 4.485 0 0 0 0-5.21l2.671-2.671a8.234 8.234 0 0 1 0 10.552l-2.671-2.67zM9 12a3 3 0 1 1 6 0 3 3 0 0 1-6 0zm8.276-6.338l-2.67 2.672a4.485 4.485 0 0 0-5.211 0L6.724 5.663a8.234 8.234 0 0 1 10.552 0zM5.662 6.724l2.672 2.67a4.485 4.485 0 0 0 0 5.211l-2.671 2.671a8.234 8.234 0 0 1 0-10.552zm1.062 11.613l2.67-2.671a4.485 4.485 0 0 0 5.211 0l2.671 2.671a8.234 8.234 0 0 1-10.552 0z",
    "data-ppui": "true"
  })), props.children);
};
var HideIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded159);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "hide icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.055 3.245a.75.75 0 1 0-1.11 1.01l1.804 1.984c-3.405 2.09-4.87 5.31-4.934 5.457a.75.75 0 0 0 0 .61c.032.074.827 1.834 2.592 3.6C5.759 18.255 8.73 19.5 12 19.5a11.93 11.93 0 0 0 4.882-1.015l2.062 2.27a.75.75 0 1 0 1.11-1.01L5.055 3.245zm4.437 7.11l3.907 4.299a3 3 0 0 1-3.907-4.299zM12 18c-2.886 0-5.407-1.05-7.493-3.117A12.482 12.482 0 0 1 2.344 12c.44-.824 1.843-3.13 4.439-4.63L8.47 9.222a4.5 4.5 0 0 0 5.968 6.563l1.381 1.518A10.501 10.501 0 0 1 12 18zm.563-8.947a.75.75 0 0 1 .28-1.473 4.515 4.515 0 0 1 3.635 3.997.75.75 0 0 1-.676.817.636.636 0 0 1-.07 0 .75.75 0 0 1-.75-.681 3.008 3.008 0 0 0-2.42-2.66zm10.62 3.252c-.04.089-.99 2.191-3.128 4.107a.752.752 0 0 1-1.068-.05.75.75 0 0 1 .068-1.068A12.447 12.447 0 0 0 21.66 12a12.485 12.485 0 0 0-2.168-2.885C17.407 7.05 14.886 6 12 6c-.608 0-1.215.048-1.815.147a.75.75 0 1 1-.248-1.48A12.562 12.562 0 0 1 12 4.5c3.27 0 6.24 1.243 8.593 3.595 1.765 1.765 2.56 3.527 2.592 3.601a.75.75 0 0 1 0 .61h-.002z",
    "data-ppui": "true"
  })), props.children);
};
var HighHeelIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded160);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "high heel icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.656 14.643l-4.781-1.077L6.531 3.219a.75.75 0 0 0-1.084.025C3.385 5.497 2.25 8.344 2.25 11.25V18a1.5 1.5 0 0 0 1.5 1.5h3a1.5 1.5 0 0 0 1.5-1.5v-4.588a10.542 10.542 0 0 1 4.49 5.16 1.49 1.49 0 0 0 1.39.928h8.37A1.5 1.5 0 0 0 24 18v-.444a2.974 2.974 0 0 0-2.344-2.913zM6.75 18h-3v-5.973a10.4 10.4 0 0 1 3 .668V18zm15.75 0h-8.374a12.032 12.032 0 0 0-4.338-5.387 11.896 11.896 0 0 0-6.01-2.087 10.37 10.37 0 0 1 2.265-5.672l9.926 9.927c.1.1.228.17.366.2l4.991 1.125A1.482 1.482 0 0 1 22.5 17.56V18z",
    "data-ppui": "true"
  })), /*#__PURE__*/React.createElement("defs", {
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "a",
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    "data-ppui": "true"
  })))), props.children);
};
var HomeIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded161);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "home icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5 19.5H21v-6.75l.22.22a.751.751 0 0 0 1.06-1.064L13.06 2.69a1.5 1.5 0 0 0-2.12 0l-9.22 9.217a.75.75 0 1 0 1.06 1.06L3 12.75v6.75H1.5a.75.75 0 0 0 0 1.5h21a.75.75 0 1 0 0-1.5zm-18-8.25l7.5-7.5 7.5 7.5v8.25H15v-5.25a.75.75 0 0 0-.75-.75h-4.5a.75.75 0 0 0-.75.75v5.25H4.5v-8.25zm9 8.25h-3V15h3v4.5z",
    "data-ppui": "true"
  })), props.children);
};
var HomeownerIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded162);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "homeowner icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.303 3.696a7.5 7.5 0 0 0-12.436 7.627L2.69 16.5a1.487 1.487 0 0 0-.44 1.06v2.69a1.5 1.5 0 0 0 1.5 1.5h3A.75.75 0 0 0 7.5 21v-1.5H9a.75.75 0 0 0 .75-.75v-1.5h1.5a.748.748 0 0 0 .53-.22l.897-.897c.75.244 1.534.368 2.323.367h.01a7.5 7.5 0 0 0 5.293-12.804zm.697 5.5c-.102 3.197-2.79 5.8-5.99 5.804H15a5.972 5.972 0 0 1-2.217-.423.75.75 0 0 0-.829.158L10.94 15.75H9a.75.75 0 0 0-.75.75V18h-1.5a.75.75 0 0 0-.75.75v1.5H3.75v-2.69l5.515-5.514a.75.75 0 0 0 .158-.829A5.974 5.974 0 0 1 9 8.992c0-3.2 2.607-5.887 5.803-5.99A6 6 0 0 1 21 9.198zm-3-2.071a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0z",
    "data-ppui": "true"
  })), props.children);
};
var HoneyIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded163);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "honey icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10.806 3.292c.973-.304 2.132-.203 2.893.53.597.575.962 1.224 1.084 1.918.121.692-.012 1.363-.303 1.965-.571 1.18-1.769 2.146-3.113 2.722-.63.27-1.316.466-2.021.558l-.002.313c-.006 1.153.012 2.441.033 3.876l.001.08.017 1.162c.442-1.036.9-2.027 1.38-2.831.502-.842 1.106-1.617 1.862-2.017a2.32 2.32 0 0 1 1.312-.275c.469.043.918.229 1.346.525.713.493.934 1.333 1.01 2.057.075.706.03 1.518-.01 2.256l-.006.12c-.044.808-.075 1.52.004 2.093.08.583.248.81.411.904.308.176.542.202.845.068.378-.168.916-.616 1.664-1.627a.75.75 0 1 1 1.207.891c-.791 1.07-1.52 1.777-2.262 2.106-.817.363-1.556.232-2.198-.136-.78-.445-1.052-1.27-1.153-2.001-.102-.742-.058-1.604-.016-2.379l.004-.064c.042-.787.08-1.49.02-2.074-.066-.62-.224-.877-.374-.981-.266-.184-.472-.25-.628-.264a.826.826 0 0 0-.474.107c-.378.2-.807.673-1.277 1.46-.653 1.093-1.241 2.524-1.858 4.023-.273.664-.552 1.34-.844 2.008a.75.75 0 0 1-1.437-.3c0-1.743-.023-3.344-.044-4.809l-.002-.09c-.02-1.426-.04-2.728-.033-3.896 0-.093 0-.185.002-.276a5.804 5.804 0 0 1-.948-.171C5.37 10.43 4.031 9.362 3.291 7.47a.75.75 0 1 1 1.397-.546c.568 1.45 1.534 2.183 2.6 2.47.193.053.39.09.592.115.06-1.558.212-2.865.55-3.882a3.631 3.631 0 0 1 2.376-2.335zM9.383 9.463a6.21 6.21 0 0 0 1.392-.414c1.128-.484 1.988-1.24 2.355-1.997.178-.368.233-.721.175-1.053-.058-.33-.24-.705-.647-1.097-.247-.239-.777-.374-1.405-.178a2.131 2.131 0 0 0-1.4 1.377c-.27.812-.409 1.918-.47 3.362z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};
var HourglassIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded164);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "hourglass icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.75 7.091V3.75a1.5 1.5 0 0 0-1.5-1.5H6.75a1.5 1.5 0 0 0-1.5 1.5v3.375a1.507 1.507 0 0 0 .6 1.2L10.75 12l-4.9 3.675a1.507 1.507 0 0 0-.6 1.2v3.375a1.5 1.5 0 0 0 1.5 1.5h10.5a1.5 1.5 0 0 0 1.5-1.5v-3.341a1.507 1.507 0 0 0-.595-1.197L13.245 12l4.91-3.713a1.506 1.506 0 0 0 .595-1.196zm-12-3.341h10.5v3.341l-.54.409H7.25l-.5-.375V3.75zM12 11.063L9.25 9h5.475L12 11.063zm5.25 9.187H6.75v-3.375l4.5-3.375v2.25a.75.75 0 1 0 1.5 0v-2.242l4.5 3.4v3.342z",
    "data-ppui": "true"
  })), props.children);
};
var HouseholdSuppliesIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded165);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "household supplies icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.75 7.5a.75.75 0 0 0 .75-.75 5.256 5.256 0 0 0-5.25-5.25H7.5A1.5 1.5 0 0 0 6 3v4.5a2.25 2.25 0 0 1-2.25 2.25.75.75 0 0 0 0 1.5A3.75 3.75 0 0 0 7.5 7.5h3v2.308a2.236 2.236 0 0 1-.844 1.757l-1.5 1.2a3.73 3.73 0 0 0-1.406 2.927V21a1.5 1.5 0 0 0 1.5 1.5H18a1.5 1.5 0 0 0 1.5-1.5v-1.175A25.395 25.395 0 0 0 16.312 7.5h2.438zM7.5 3h6.75a3.758 3.758 0 0 1 3.675 3H7.5V3zM18 19.825V21H8.25v-5.308a2.238 2.238 0 0 1 .844-1.757l1.5-1.2A3.732 3.732 0 0 0 12 9.809V7.5h2.58A23.893 23.893 0 0 1 18 19.825z",
    "data-ppui": "true"
  })), props.children);
};
var HouseholdIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded166);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "household icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5 17.25h-.75V5.428l.907-.195a.749.749 0 1 0-.314-1.466l-21 4.5a.75.75 0 0 0 .315 1.466l.592-.126v7.643H1.5a.75.75 0 1 0 0 1.5h21a.75.75 0 1 0 0-1.5zM3.75 9.281l16.5-3.531v11.5H18V12a.75.75 0 0 0-.75-.75H6.75A.75.75 0 0 0 6 12v5.25H3.75V9.281zm12.75 4.97h-9v-1.5h9v1.5zm-9 1.5h9v1.5h-9v-1.5z",
    "data-ppui": "true"
  })), props.children);
};
var HumanServicesIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded167);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "human services icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 2.25A9.75 9.75 0 1 0 21.75 12 9.76 9.76 0 0 0 12 2.25zm0 18A8.25 8.25 0 1 1 20.25 12 8.26 8.26 0 0 1 12 20.25zM10.5 7.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0zm6.75 3a.75.75 0 0 1-.75.75h-3.75v1.273l2.874 4.313a.75.75 0 1 1-1.248.832L12 14.106l-2.376 3.562a.751.751 0 0 1-1.248-.832l2.874-4.313V11.25H7.5a.75.75 0 1 1 0-1.5h9a.75.75 0 0 1 .75.75z",
    "data-ppui": "true"
  })), props.children);
};
var HumanIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded168);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "human icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 3.75a3 3 0 1 0-6 0 3 3 0 0 0 6 0zm-3 1.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm8.47 7.317l-4.235-4.802a3 3 0 0 0-2.25-1.015h-3.97a3 3 0 0 0-2.25 1.015l-4.234 4.802a1.875 1.875 0 0 0 2.637 2.665l1.528-1.226-1.55 5.895a1.876 1.876 0 1 0 3.416 1.549L12 17.243l2.437 4.207a1.875 1.875 0 0 0 3.414-1.549l-1.547-5.895 1.528 1.226a1.875 1.875 0 0 0 2.637-2.665zm-1.08 1.572a.377.377 0 0 1-.53 0 .829.829 0 0 0-.061-.054l-3.33-2.67a.75.75 0 0 0-1.195.773l2.145 8.156a.73.73 0 0 0 .045.126.374.374 0 1 1-.68.317.592.592 0 0 0-.03-.059l-3.105-5.353a.75.75 0 0 0-1.298 0L8.25 20.723a.582.582 0 0 0-.031.06.375.375 0 0 1-.68-.317.723.723 0 0 0 .044-.127l2.143-8.151a.75.75 0 0 0-1.195-.773l-3.33 2.67a.836.836 0 0 0-.06.054.375.375 0 1 1-.531-.53.569.569 0 0 0 .031-.034l4.25-4.818a1.5 1.5 0 0 1 1.124-.507h3.97a1.5 1.5 0 0 1 1.125.507l4.248 4.818a.55.55 0 0 0 .032.035.375.375 0 0 1 0 .53z",
    "data-ppui": "true"
  })), props.children);
};
var HungerIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded169);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "hunger icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.25 1.5v3a.75.75 0 0 0 1.5 0v-3a.75.75 0 1 0-1.5 0zm4.28 3.53a.75.75 0 0 1-1.28-.53v-3a.75.75 0 1 1 1.5 0v3a.75.75 0 0 1-.22.53zm3 0a.75.75 0 0 1-1.28-.53v-3a.75.75 0 1 1 1.5 0v3a.75.75 0 0 1-.22.53z",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12.336 18.003c.2-.1 4.914-2.497 4.914-5.92A3 3 0 0 0 12 10.1a3 3 0 0 0-5.25 1.982c0 3.424 4.714 5.82 4.914 5.921a.75.75 0 0 0 .672 0zm2.975-6.981a1.5 1.5 0 0 1 .439 1.06c0 1.893-2.457 3.67-3.75 4.4-1.293-.73-3.75-2.508-3.75-4.4a1.5 1.5 0 0 1 3 0 .75.75 0 1 0 1.5 0 1.5 1.5 0 0 1 2.56-1.06z",
    clipRule: "evenodd",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M21 11.625L23.7 9.6a.75.75 0 0 0-.9-1.2L21 9.75V7.5a.75.75 0 0 0-.75-.75H3.75A.75.75 0 0 0 3 7.5v2.25L1.2 8.4a.75.75 0 1 0-.9 1.2L3 11.625v5.625a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3v-5.625zM4.5 8.25h15v9a1.5 1.5 0 0 1-1.5 1.5H6a1.5 1.5 0 0 1-1.5-1.5v-9z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), /*#__PURE__*/React.createElement("defs", {
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "a",
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    "data-ppui": "true"
  })))), props.children);
};
var InFlightIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded170);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "in flight icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 20.25a.75.75 0 0 1-.75.75H6.75a.75.75 0 1 1 0-1.5h13.5a.75.75 0 0 1 .75.75zm2.25-7.5V15a.75.75 0 0 1-.75.75H5.725a3.726 3.726 0 0 1-3.591-2.673L.814 8.681A1.5 1.5 0 0 1 2.25 6.75H3a.75.75 0 0 1 .53.22L5.56 9h2.11l-.844-2.526A1.5 1.5 0 0 1 8.25 4.5H9a.75.75 0 0 1 .53.22L13.812 9H19.5a3.75 3.75 0 0 1 3.75 3.75zm-1.5 0a2.25 2.25 0 0 0-2.25-2.25h-6a.75.75 0 0 1-.53-.22L8.69 6h-.44l1.17 3.513a.75.75 0 0 1-.71.987H5.25a.75.75 0 0 1-.53-.22L2.69 8.25h-.44l1.319 4.397a2.236 2.236 0 0 0 2.156 1.603H21.75v-1.5z",
    "data-ppui": "true"
  })), props.children);
};
var IndustrialIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded171);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "industrial icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 7.5a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9zm0 7.5a3 3 0 1 1 0-5.999 3 3 0 0 1 0 6zm8.97-8.798l-8.25-4.514a1.489 1.489 0 0 0-1.44 0L3.03 6.204a1.5 1.5 0 0 0-.78 1.312v8.966a1.5 1.5 0 0 0 .78 1.313l8.25 4.516a1.489 1.489 0 0 0 1.44 0l8.25-4.516a1.5 1.5 0 0 0 .78-1.313V7.517a1.5 1.5 0 0 0-.78-1.315zM12 21l-8.25-4.517V7.517L12 3l8.25 4.516v8.966L12 21z",
    "data-ppui": "true"
  })), props.children);
};
var InformationSmIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded172);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "information sm icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 18 18",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10.102 12.914a.763.763 0 0 0-.34-1.275v-2.64a1.325 1.325 0 0 0-1.324-1.324.762.762 0 0 0-.2 1.498v2.64a1.325 1.325 0 0 0 1.325 1.324c.202 0 .396-.08.539-.223zM7.851 5.326a1.044 1.044 0 1 0 1.736 1.16 1.044 1.044 0 0 0-1.736-1.16z",
    clipRule: "evenodd",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M14.31 3.69A7.52 7.52 0 0 0 9 1.487 7.513 7.513 0 1 0 16.513 9a7.52 7.52 0 0 0-2.203-5.31zM9 14.987A5.987 5.987 0 1 1 14.988 9 5.995 5.995 0 0 1 9 14.987z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};
var InformationIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded173);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "information icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 2.25A9.75 9.75 0 1 0 21.75 12 9.76 9.76 0 0 0 12 2.25zm0 18A8.25 8.25 0 1 1 20.25 12 8.26 8.26 0 0 1 12 20.25zm1.5-3.75a.75.75 0 0 1-.75.75 1.5 1.5 0 0 1-1.5-1.5V12a.75.75 0 1 1 0-1.5 1.5 1.5 0 0 1 1.5 1.5v3.75a.75.75 0 0 1 .75.75zm-3-8.625a1.125 1.125 0 1 1 2.25 0 1.125 1.125 0 0 1-2.25 0z",
    "data-ppui": "true"
  })), props.children);
};
var InsightsIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded174);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "insights icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.25 3.75h-7.5v-1.5a.75.75 0 1 0-1.5 0v1.5h-7.5a1.5 1.5 0 0 0-1.5 1.5V16.5a1.5 1.5 0 0 0 1.5 1.5h3.69l-2.026 2.531a.75.75 0 1 0 1.172.938L9.36 18h5.28l2.774 3.469a.75.75 0 1 0 1.172-.938L16.56 18h3.69a1.5 1.5 0 0 0 1.5-1.5V5.25a1.5 1.5 0 0 0-1.5-1.5zm0 12.75H3.75V5.25h16.5V16.5zm-10.5-5.25v2.25a.75.75 0 1 1-1.5 0v-2.25a.75.75 0 1 1 1.5 0zm3-1.5v3.75a.75.75 0 1 1-1.5 0V9.75a.75.75 0 1 1 1.5 0zm3-1.5v5.25a.75.75 0 1 1-1.5 0V8.25a.75.75 0 1 1 1.5 0z",
    "data-ppui": "true"
  })), props.children);
};
var InstallmentsIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded175);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "installments icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5 3h-2.25v-.75a.75.75 0 1 0-1.5 0V3h-7.5v-.75a.75.75 0 0 0-1.5 0V3H4.5A1.5 1.5 0 0 0 3 4.5v15A1.5 1.5 0 0 0 4.5 21h15a1.5 1.5 0 0 0 1.5-1.5v-15A1.5 1.5 0 0 0 19.5 3zM6.75 4.5v.75a.75.75 0 0 0 1.5 0V4.5h7.5v.75a.75.75 0 1 0 1.5 0V4.5h2.25v3h-15v-3h2.25zm12.75 15h-15V9h15v10.5zm-6-5.25a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z",
    "data-ppui": "true"
  })), props.children);
};
var InsuranceIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded176);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "insurance icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 2.25A9.75 9.75 0 1 0 21.75 12 9.76 9.76 0 0 0 12 2.25zm0 18A8.25 8.25 0 1 1 20.25 12 8.26 8.26 0 0 1 12 20.25zm3.75-9.75a3.75 3.75 0 1 0-6.182 2.854l-1.254 2.843A.75.75 0 0 0 9 17.25h6a.75.75 0 0 0 .686-1.053l-1.254-2.843A3.764 3.764 0 0 0 15.75 10.5zm-2.936 2.906l1.031 2.349H10.15l1.032-2.349a.75.75 0 0 0-.307-.957 2.25 2.25 0 1 1 2.25 0 .75.75 0 0 0-.311.957z",
    "data-ppui": "true"
  })), props.children);
};
var InsuredIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded177);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "insured icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M15.29 8.699a3.75 3.75 0 0 1-.858 4.655l1.254 2.843A.75.75 0 0 1 15 17.25H9a.75.75 0 0 1-.686-1.053l1.254-2.843a3.75 3.75 0 1 1 5.722-4.655zm-1.445 7.056l-1.031-2.349a.75.75 0 0 1 .311-.957 2.25 2.25 0 1 0-2.25 0 .75.75 0 0 1 .306.957l-1.03 2.348h3.694z",
    clipRule: "evenodd",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4.5 3.75h15a1.5 1.5 0 0 1 1.5 1.5v5.25c0 4.943-2.392 7.938-4.394 9.58-2.165 1.768-4.313 2.37-4.406 2.394a.752.752 0 0 1-.394 0c-.094-.025-2.244-.626-4.406-2.394C5.392 18.438 3 15.443 3 10.5V5.25a1.5 1.5 0 0 1 1.5-1.5zm11.194 15.133c2.525-2.087 3.806-4.908 3.806-8.383V5.25h-15v5.25c0 3.497 1.296 6.33 3.851 8.42A12.024 12.024 0 0 0 12 20.964a12.12 12.12 0 0 0 3.694-2.08z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};
var InternationalIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded178);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "international icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 2.25A9.75 9.75 0 1 0 21.75 12 9.76 9.76 0 0 0 12 2.25zm0 1.5a8.203 8.203 0 0 1 4.5 1.339v1.848l-2.078 2.414-2.95.399-.03-.02-1.844-1.206a1.5 1.5 0 0 0-2.11.392L5.525 11.85a1.5 1.5 0 0 0-.253.826l-.022 3.397-.307.201A8.25 8.25 0 0 1 12 3.75zM5.84 17.482l.236-.155a1.5 1.5 0 0 0 .674-1.246l.02-3.397L8.735 9.75l.03.02 1.844 1.207c.309.218.689.311 1.064.26l2.952-.4a1.5 1.5 0 0 0 .938-.508l2.078-2.415A1.5 1.5 0 0 0 18 6.938v-.594a8.238 8.238 0 0 1 1.853 8.187l-1.513-1.383a1.5 1.5 0 0 0-1.587-.282l-2.855 1.186a1.508 1.508 0 0 0-.908 1.167l-.224 1.518a1.5 1.5 0 0 0 1.103 1.67l2.012.53.221.223A8.239 8.239 0 0 1 5.84 17.482zm11.504.8l-.403-.405a1.5 1.5 0 0 0-.681-.392l-2.01-.53.224-1.518 2.855-1.187 1.89 1.732a8.291 8.291 0 0 1-1.875 2.3z",
    "data-ppui": "true"
  })), props.children);
};
var InternetIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded179);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "internet icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.125 19.125a1.126 1.126 0 1 1-2.251 0 1.126 1.126 0 0 1 2.251 0zm9.101-10.969a16.125 16.125 0 0 0-20.452 0 .75.75 0 1 0 .952 1.16 14.625 14.625 0 0 1 18.548 0 .75.75 0 0 0 .952-1.16zM19.22 11.51a11.625 11.625 0 0 0-14.432 0 .75.75 0 0 0 .932 1.176 10.125 10.125 0 0 1 12.568 0 .751.751 0 0 0 .932-1.176zm-3.025 3.352a7.13 7.13 0 0 0-8.383 0 .75.75 0 0 0 .883 1.214 5.624 5.624 0 0 1 6.617 0 .752.752 0 0 0 1.048-.165.75.75 0 0 0-.165-1.049z",
    "data-ppui": "true"
  })), props.children);
};
var InvestIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded180);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "invest icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 18.75h-.75v-15A.75.75 0 0 0 19.5 3h-5.25a.75.75 0 0 0-.75.75V7.5H9a.75.75 0 0 0-.75.75V12H4.5a.75.75 0 0 0-.75.75v6H3a.75.75 0 1 0 0 1.5h18a.75.75 0 1 0 0-1.5zM15 4.5h3.75v14.25H15V4.5zM9.75 9h3.75v9.75H9.75V9zm-4.5 4.5h3v5.25h-3V13.5z",
    "data-ppui": "true"
  })), props.children);
};
var InvoiceIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded181);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "invoice icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.625 12a.75.75 0 1 1 0-1.5H5.25a.75.75 0 1 0 0-1.5h-1.5a2.25 2.25 0 1 1 0-4.5.75.75 0 0 1 1.5 0H6A.75.75 0 0 1 6 6H3.75a.75.75 0 0 0 0 1.5h1.5a2.25 2.25 0 1 1 0 4.5.75.75 0 1 1-1.5 0H2.625zM21.75 5.25V18a1.5 1.5 0 0 1-1.5 1.5H3.75a1.5 1.5 0 0 1-1.5-1.5v-3.75a.75.75 0 1 1 1.5 0V18H15v-3H7.5a.75.75 0 1 1 0-1.5H15v-3H9.75a.75.75 0 1 1 0-1.5h10.5V6H9a.75.75 0 0 1 0-1.5h12a.75.75 0 0 1 .75.75zM16.5 13.5h3.75v-3H16.5v3zm3.75 4.5v-3H16.5v3h3.75z",
    "data-ppui": "true"
  })), props.children);
};
var JewelryIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded182);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "jewelry icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.984 5.095l2.273-2.598a.625.625 0 0 1 .469-.213h4.547a.628.628 0 0 1 .469.213l2.272 2.597a.624.624 0 0 1-.01.838L14.821 8.27A7.02 7.02 0 0 1 12 21.715 7.018 7.018 0 0 1 9.18 8.27L6.998 5.933a.625.625 0 0 1-.014-.838zm6.527 2.748a7.043 7.043 0 0 0-3.024 0l-.31-.339.004.01-1.29-1.383h.034-.001 6.19l-1.603 1.712zm1.658-2.961l-1.18-1.348h-.667l-.002-.002h-2.577l-.001.002h-.732L8.83 4.882h5.684-.001.656zm2.349 9.815a5.518 5.518 0 1 1-11.036 0 5.518 5.518 0 0 1 11.036 0z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};
var JusticeIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded183);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "justice icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.447 12.469l-3-7.5a.75.75 0 0 0-.86-.454L12.75 5.813V3.75a.75.75 0 1 0-1.5 0v2.398l-6.163 1.37a.75.75 0 0 0-.534.45v.006l-3 7.495a.742.742 0 0 0-.053.281c0 2.185 2.3 3 3.75 3 1.45 0 3.75-.815 3.75-3a.742.742 0 0 0-.053-.281L6.274 8.79l4.976-1.104V19.5h-1.5a.75.75 0 1 0 0 1.5h4.5a.75.75 0 1 0 0-1.5h-1.5V7.352l4.781-1.061-2.477 6.178a.742.742 0 0 0-.054.281c0 2.185 2.3 3 3.75 3 1.45 0 3.75-.815 3.75-3a.742.742 0 0 0-.053-.281zM5.25 17.25c-.706 0-2.134-.338-2.243-1.373L5.25 10.27l2.243 5.608c-.11 1.035-1.537 1.373-2.243 1.373zm13.5-3c-.706 0-2.134-.338-2.243-1.373L18.75 7.27l2.244 5.608c-.11 1.035-1.538 1.373-2.244 1.373z",
    "data-ppui": "true"
  })), props.children);
};
var LaptopIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded184);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "laptop icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.75 15.75H21v-9a2.25 2.25 0 0 0-2.25-2.25H5.25A2.25 2.25 0 0 0 3 6.75v9h-.75a.75.75 0 0 0-.75.75V18a2.25 2.25 0 0 0 2.25 2.25h16.5A2.25 2.25 0 0 0 22.5 18v-1.5a.75.75 0 0 0-.75-.75zm-17.25-9A.75.75 0 0 1 5.25 6h13.5a.75.75 0 0 1 .75.75v9h-15v-9zM21 18a.75.75 0 0 1-.75.75H3.75A.75.75 0 0 1 3 18v-.75h18V18zm-6.75-9.75a.75.75 0 0 1-.75.75h-3a.75.75 0 1 1 0-1.5h3a.75.75 0 0 1 .75.75z",
    "data-ppui": "true"
  })), props.children);
};
var LawnIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded185);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "lawn icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.03 5.47l-4.5-4.5a.75.75 0 0 0-1.06 1.06l1.72 1.72-6.657 6.656L9.31 7.19a1.5 1.5 0 0 0-2.12 0l-5.25 5.25a1.49 1.49 0 0 0-.44 1.06V21A1.5 1.5 0 0 0 3 22.5h7.5a1.485 1.485 0 0 0 1.06-.439l5.25-5.25a1.5 1.5 0 0 0 0-2.12l-3.216-3.22 6.656-6.657 1.72 1.72a.751.751 0 0 0 1.06-1.06V5.47zm-7.28 10.28L10.5 21H3v-7.5l5.25-5.25 3.22 3.22-3.75 3.75a.75.75 0 0 0 1.06 1.06l3.75-3.75 3.22 3.22z",
    "data-ppui": "true"
  })), props.children);
};
var LeftAlignIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded186);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "left align icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 6a.75.75 0 0 1 .75-.75h16.5a.75.75 0 1 1 0 1.5H3.75A.75.75 0 0 1 3 6zm.75 4.5h12a.75.75 0 1 0 0-1.5h-12a.75.75 0 0 0 0 1.5zm16.5 2.25H3.75a.75.75 0 1 0 0 1.5h16.5a.75.75 0 1 0 0-1.5zm-4.5 3.75h-12a.75.75 0 1 0 0 1.5h12a.75.75 0 1 0 0-1.5z",
    "data-ppui": "true"
  })), props.children);
};
var LetterCheckmarkIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded187);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "letter checkmark icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.78 16.28l3-3a.75.75 0 0 0-1.06-1.06l-2.47 2.47-.97-.97a.75.75 0 0 0-1.06 1.06l1.5 1.5a.75.75 0 0 0 1.06 0z",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M14.78 2.47l5.25 5.25a.748.748 0 0 1 .22.53v12a1.5 1.5 0 0 1-1.5 1.5H5.25a1.5 1.5 0 0 1-1.5-1.5V3.75a1.5 1.5 0 0 1 1.5-1.5h9a.75.75 0 0 1 .53.22zm2.91 5.03L15 4.81V7.5h2.69zM5.25 20.25h13.5V9h-4.5a.75.75 0 0 1-.75-.75v-4.5H5.25v16.5z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};
var LightBulbIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded188);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "light bulb icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5 21.75a.75.75 0 0 1-.75.75h-7.5a.75.75 0 0 1 0-1.5h7.5a.75.75 0 0 1 .75.75zm3.75-12a8.208 8.208 0 0 1-3.154 6.488 1.522 1.522 0 0 0-.596 1.2V18a1.5 1.5 0 0 1-1.5 1.5H9A1.5 1.5 0 0 1 7.5 18v-.563a1.5 1.5 0 0 0-.584-1.186A8.212 8.212 0 0 1 3.75 9.797c-.024-4.47 3.587-8.19 8.051-8.297a8.25 8.25 0 0 1 8.449 8.25zm-1.5 0A6.749 6.749 0 0 0 11.837 3C8.18 3.086 5.23 6.13 5.25 9.787a6.716 6.716 0 0 0 2.591 5.278A3 3 0 0 1 9 17.438V18h2.25v-4.19l-2.78-2.78a.75.75 0 0 1 1.06-1.06L12 12.44l2.47-2.47a.75.75 0 0 1 1.06 1.06l-2.78 2.78V18H15v-.563a3.011 3.011 0 0 1 1.17-2.376 6.717 6.717 0 0 0 2.58-5.311z",
    "data-ppui": "true"
  })), props.children);
};
var LikeSelectedIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded189);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "like selected icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.938 7.511a2.25 2.25 0 0 0-1.688-.761H15v-1.5a3.75 3.75 0 0 0-3.75-3.75.75.75 0 0 0-.671.414L7.037 9H3a1.5 1.5 0 0 0-1.5 1.5v8.25a1.5 1.5 0 0 0 1.5 1.5h16.125a2.25 2.25 0 0 0 2.233-1.969l1.125-9a2.25 2.25 0 0 0-.546-1.77zM3 10.5h3.75v8.25H3V10.5z",
    "data-ppui": "true"
  })), props.children);
};
var LikeIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded190);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "like icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.938 7.511a2.25 2.25 0 0 0-1.688-.761H15v-1.5a3.75 3.75 0 0 0-3.75-3.75.75.75 0 0 0-.671.414L7.037 9H3a1.5 1.5 0 0 0-1.5 1.5v8.25a1.5 1.5 0 0 0 1.5 1.5h16.125a2.25 2.25 0 0 0 2.233-1.969l1.125-9a2.25 2.25 0 0 0-.546-1.77zM3 10.5h3.75v8.25H3V10.5zm17.994-1.406l-1.125 9a.75.75 0 0 1-.744.656H8.25V9.927l3.442-6.884A2.25 2.25 0 0 1 13.5 5.25V7.5a.75.75 0 0 0 .75.75h6a.75.75 0 0 1 .744.844z",
    "data-ppui": "true"
  })), props.children);
};
var LinkIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded191);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "link icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5 8.271a5.102 5.102 0 0 1-1.5 3.47L17.742 15a5.086 5.086 0 0 1-3.621 1.5h-.005A5.12 5.12 0 0 1 9 11.235a.75.75 0 1 1 1.5.042 3.621 3.621 0 0 0 6.177 2.663l3.258-3.258a3.622 3.622 0 0 0-5.121-5.122l-1.032 1.031a.75.75 0 0 1-1.06-1.06L13.753 4.5a5.122 5.122 0 0 1 8.385 1.731 5.16 5.16 0 0 1 .362 2.04zm-12.281 9.134l-1.031 1.032a3.602 3.602 0 0 1-2.57 1.063 3.622 3.622 0 0 1-2.558-6.182l3.253-3.258a3.621 3.621 0 0 1 6.187 2.663.75.75 0 0 0 1.5.042A5.14 5.14 0 0 0 13.5 9a5.123 5.123 0 0 0-7.244 0L3 12.258a5.12 5.12 0 0 0 7.238 7.242l1.03-1.032a.75.75 0 0 0-1.05-1.063z",
    "data-ppui": "true"
  })), props.children);
};
var ListSimpleIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded192);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "list simple icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 6a.75.75 0 0 1 .75-.75h12a.75.75 0 1 1 0 1.5h-12A.75.75 0 0 1 7.5 6zm12.75 5.25h-12a.75.75 0 1 0 0 1.5h12a.75.75 0 1 0 0-1.5zm0 6h-12a.75.75 0 1 0 0 1.5h12a.75.75 0 1 0 0-1.5zM4.125 4.875a1.125 1.125 0 1 0 0 2.25 1.125 1.125 0 0 0 0-2.25zm0 6a1.125 1.125 0 1 0 0 2.25 1.125 1.125 0 0 0 0-2.25zm0 6a1.125 1.125 0 1 0 0 2.25 1.125 1.125 0 0 0 0-2.25z",
    "data-ppui": "true"
  })), props.children);
};
var LitecoinIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded193);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "litecoin icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.603 3.618a.75.75 0 1 0-1.442-.413L8.62 12.084l-3.904 1.279a.75.75 0 0 0 .467 1.425l2.938-.963-1.67 5.841a.75.75 0 0 0 .72.957h11.87a.75.75 0 1 0 0-1.5H8.167l1.677-5.862 4.405-1.443a.75.75 0 1 0-.467-1.426l-3.44 1.127 2.262-7.901z",
    "data-ppui": "true"
  })), props.children);
};
var LoansIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded194);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "loans icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.593 13.224a2.29 2.29 0 0 0-1.99-.396l-3.923.902a2.625 2.625 0 0 0-2.555-3.23H8.432a2.982 2.982 0 0 0-2.122.878L4.19 13.5H1.5A1.5 1.5 0 0 0 0 15v3.75a1.5 1.5 0 0 0 1.5 1.5h9.75a.744.744 0 0 0 .182-.023l6-1.5a.653.653 0 0 0 .111-.037l3.645-1.55.04-.02a2.306 2.306 0 0 0 .37-3.896h-.005zM1.5 15h2.25v3.75H1.5V15zm19.072.77l-3.563 1.517-5.853 1.463H5.25v-4.19l2.122-2.12a1.487 1.487 0 0 1 1.06-.44h4.693a1.125 1.125 0 1 1 0 2.25H10.5a.75.75 0 1 0 0 1.5h3a.782.782 0 0 0 .168-.019l6.281-1.444.03-.008a.806.806 0 0 1 .59 1.49h.003zM15.375 9c.185 0 .37-.015.553-.045a3.376 3.376 0 1 0 2.646-4.406A3.375 3.375 0 1 0 15.375 9zM21 7.875a1.875 1.875 0 1 1-3.75 0 1.875 1.875 0 0 1 3.75 0zM15.375 3.75a1.875 1.875 0 0 1 1.805 1.37 3.376 3.376 0 0 0-1.407 2.337 1.875 1.875 0 1 1-.398-3.707z",
    "data-ppui": "true"
  })), props.children);
};
var LocationIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded195);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "location icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 6a3.75 3.75 0 1 0 0 7.5A3.75 3.75 0 0 0 12 6zm0 6a2.25 2.25 0 1 1 0-4.5 2.25 2.25 0 0 1 0 4.5zm0-10.5a8.26 8.26 0 0 0-8.25 8.25c0 2.944 1.36 6.064 3.938 9.023a23.837 23.837 0 0 0 3.885 3.591.75.75 0 0 0 .861 0 23.835 23.835 0 0 0 3.879-3.59c2.573-2.96 3.937-6.08 3.937-9.024A8.26 8.26 0 0 0 12 1.5zm0 19.313c-1.55-1.22-6.75-5.696-6.75-11.063a6.75 6.75 0 0 1 13.5 0c0 5.365-5.2 9.844-6.75 11.063z",
    "data-ppui": "true"
  })), props.children);
};
var LockIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded196);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "lock icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 10.5a2.625 2.625 0 0 0-.75 5.14v1.61a.75.75 0 1 0 1.5 0v-1.61A2.625 2.625 0 0 0 12 10.5zm0 3.75A1.125 1.125 0 1 1 12 12a1.125 1.125 0 0 1 0 2.25zm7.5-6.75h-3V5.25a4.5 4.5 0 1 0-9 0V7.5h-3A1.5 1.5 0 0 0 3 9v10.5A1.5 1.5 0 0 0 4.5 21h15a1.5 1.5 0 0 0 1.5-1.5V9a1.5 1.5 0 0 0-1.5-1.5zM9 5.25a3 3 0 1 1 6 0V7.5H9V5.25zM19.5 19.5h-15V9h15v10.5z",
    "data-ppui": "true"
  })), props.children);
};
var LogoutIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded197);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "logout icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.25 20.25a.75.75 0 0 1-.75.75h-6a.75.75 0 0 1-.75-.75V3.75A.75.75 0 0 1 4.5 3h6a.75.75 0 1 1 0 1.5H5.25v15h5.25a.75.75 0 0 1 .75.75zm10.28-8.78l-3.75-3.75a.75.75 0 1 0-1.06 1.06l2.47 2.47H10.5a.75.75 0 1 0 0 1.5h8.69l-2.47 2.47a.75.75 0 1 0 1.06 1.06l3.75-3.75a.747.747 0 0 0 0-1.06z",
    "data-ppui": "true"
  })), props.children);
};
var LoyaltyCardIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded198);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "loyalty card icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.53 11.03A.75.75 0 0 0 18 9.75h-3.75a.75.75 0 1 0 0 1.5H18a.75.75 0 0 0 .53-.22zm-4.28 1.72H18a.75.75 0 1 1 0 1.5h-3.75a.75.75 0 1 1 0-1.5zm-6.863-.12l-1.855-.742a.788.788 0 1 1 .588-1.46l1.726.691V9.475a.786.786 0 0 1 1.572 0v1.644l1.725-.69a.79.79 0 0 1 1.025.434.788.788 0 0 1-.435 1.025h-.001l-1.854.742 1.066 1.424a.786.786 0 1 1-1.258.943l-1.054-1.406-1.055 1.406a.786.786 0 0 1-1.258-.943l1.068-1.424z",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M21.75 18.75V5.25a1.5 1.5 0 0 0-1.5-1.5H3.75a1.5 1.5 0 0 0-1.5 1.5v13.5a1.5 1.5 0 0 0 1.5 1.5h16.5a1.5 1.5 0 0 0 1.5-1.5zm-1.5-13.5v13.5H3.75V5.25h16.5z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};
var LuggageIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded199);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "luggage icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.75 8.25v9a.75.75 0 1 1-1.5 0v-9a.75.75 0 0 1 1.5 0zM12 7.5a.75.75 0 0 0-.75.75v9a.75.75 0 1 0 1.5 0v-9A.75.75 0 0 0 12 7.5zm3 0a.75.75 0 0 0-.75.75v9a.75.75 0 1 0 1.5 0v-9A.75.75 0 0 0 15 7.5zM19.5 6v13.5A1.5 1.5 0 0 1 18 21h-1.5v1.5a.75.75 0 1 1-1.5 0V21H9v1.5a.75.75 0 1 1-1.5 0V21H6a1.5 1.5 0 0 1-1.5-1.5V6A1.5 1.5 0 0 1 6 4.5h2.25V2.25A2.25 2.25 0 0 1 10.5 0h3a2.25 2.25 0 0 1 2.25 2.25V4.5H18A1.5 1.5 0 0 1 19.5 6zM9.75 4.5h4.5V2.25a.75.75 0 0 0-.75-.75h-3a.75.75 0 0 0-.75.75V4.5zm8.25 15V6H6v13.5h12z",
    "data-ppui": "true"
  })), props.children);
};
var MedicalIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded200);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "medical icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.25 5.25H16.5V4.5a2.25 2.25 0 0 0-2.25-2.25h-4.5A2.25 2.25 0 0 0 7.5 4.5v.75H3.75a1.5 1.5 0 0 0-1.5 1.5v12a1.5 1.5 0 0 0 1.5 1.5h16.5a1.5 1.5 0 0 0 1.5-1.5v-12a1.5 1.5 0 0 0-1.5-1.5zM9 4.5a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 .75.75v.75H9V4.5zm11.25 14.25H3.75v-12h16.5v12zm-5.25-6a.75.75 0 0 1-.75.75h-1.5V15a.75.75 0 1 1-1.5 0v-1.5h-1.5a.75.75 0 1 1 0-1.5h1.5v-1.5a.75.75 0 1 1 1.5 0V12h1.5a.75.75 0 0 1 .75.75z",
    "data-ppui": "true"
  })), props.children);
};
var MegaphoneIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded201);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "megaphone icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M.85 11.699a3.755 3.755 0 0 0 3.16 3.707l.857 3.23a1.353 1.353 0 0 0 1.458 1.006c.185-.021.364-.08.525-.173l.253-.166.646-.43a1.35 1.35 0 0 0 .598-1.033l.003-.168v-2.126c1.32.223 4.1.937 6.781 3.186A1.35 1.35 0 0 0 17.35 17.7v-12a1.35 1.35 0 0 0-2.218-1.033c-3.563 2.989-7.304 3.268-7.55 3.283H4.6A3.754 3.754 0 0 0 .85 11.7zm6 5.973l-.582.387-.693-2.61H6.85v2.223zm9-.296V6.016c-3.06 2.469-6.139 3.164-7.5 3.358v4.649c1.36.195 4.44.89 7.5 3.354zm-9-3.427H4.6a2.25 2.25 0 1 1 0-4.5h2.25v4.5z",
    clipRule: "evenodd",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.651 7.057a.7.7 0 1 0-.778-1.164l-2.346 1.568a.7.7 0 0 0 .778 1.164l2.346-1.568zm.193 9.476a.7.7 0 0 0-.193-.97l-2.346-1.569a.7.7 0 0 0-.778 1.164l2.346 1.568a.7.7 0 0 0 .971-.193zm-2.928-4.393a.7.7 0 1 1 0-1.4h2.503a.7.7 0 1 1 0 1.4h-2.503z",
    "data-ppui": "true"
  })), props.children);
};
var MembershipsIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded202);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "memberships icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 15h3a.75.75 0 1 1 0 1.5h-3a.75.75 0 1 1 0-1.5z",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12.645 16.131a.75.75 0 0 0 .08-.569h.002a3.728 3.728 0 0 0-1.613-2.188 3 3 0 1 0-4.23 0 3.735 3.735 0 0 0-1.612 2.188.75.75 0 0 0 1.454.376c.247-.962 1.224-1.688 2.273-1.688 1.05 0 2.027.726 2.274 1.688a.75.75 0 0 0 1.372.193zm-2.812-3.634a1.5 1.5 0 1 1-1.666-2.495 1.5 1.5 0 0 1 1.666 2.495z",
    clipRule: "evenodd",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.416 11.678l-.556.74a.61.61 0 1 1-.976-.732l.566-.754-1.002-.4a.613.613 0 0 1-.338-.796.609.609 0 0 1 .795-.338l.9.36v-.837a.61.61 0 0 1 1.221 0v.838l.9-.36a.613.613 0 0 1 .796.337.612.612 0 0 1-.338.795l-1 .4.564.755a.61.61 0 0 1-.977.732l-.555-.74z",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M21.75 18.75V5.25a1.5 1.5 0 0 0-1.5-1.5H3.75a1.5 1.5 0 0 0-1.5 1.5v13.5a1.5 1.5 0 0 0 1.5 1.5h16.5a1.5 1.5 0 0 0 1.5-1.5zm-1.5-13.5v13.5H3.75V5.25h16.5z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};
var MemorialsIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded203);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "memorials icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.25 3.75H3.75a1.5 1.5 0 0 0-1.5 1.5v13.5a1.5 1.5 0 0 0 1.5 1.5h16.5a1.5 1.5 0 0 0 1.5-1.5V5.25a1.5 1.5 0 0 0-1.5-1.5zm-16.5 4.5h7.5v7.5h-7.5v-7.5zm9-1.5v-1.5h3v1.5h-3zm-1.5 0h-3v-1.5h3v1.5zm0 10.5v1.5h-3v-1.5h3zm1.5 0h3v1.5h-3v-1.5zm0-1.5v-7.5h7.5v7.5h-7.5zm7.5-9h-3v-1.5h3v1.5zm-13.5-1.5v1.5h-3v-1.5h3zm-3 12h3v1.5h-3v-1.5zm16.5 1.5h-3v-1.5h3v1.5z",
    "data-ppui": "true"
  })), props.children);
};
var MenuIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded204);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "menu icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 12a.75.75 0 0 1-.75.75H3.75a.75.75 0 1 1 0-1.5h16.5A.75.75 0 0 1 21 12zM3.75 6.75h16.5a.75.75 0 1 0 0-1.5H3.75a.75.75 0 0 0 0 1.5zm16.5 10.5H3.75a.75.75 0 1 0 0 1.5h16.5a.75.75 0 1 0 0-1.5z",
    "data-ppui": "true"
  })), props.children);
};
var MerchantIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded205);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "merchant icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.75 9c0-.07-.01-.14-.028-.206l-1.345-4.707A1.507 1.507 0 0 0 18.937 3H5.063a1.507 1.507 0 0 0-1.439 1.088L2.28 8.794A.74.74 0 0 0 2.25 9v1.5a3.75 3.75 0 0 0 1.5 3v6.75a.75.75 0 0 0 .75.75h15a.75.75 0 0 0 .75-.75V13.5a3.75 3.75 0 0 0 1.5-3V9zM5.062 4.5h13.875l1.071 3.75H3.995L5.062 4.5zM9.75 9.75h4.5v.75a2.25 2.25 0 0 1-4.5 0v-.75zm-1.5 0v.75a2.25 2.25 0 0 1-3.293 1.993.741.741 0 0 0-.17-.1A2.25 2.25 0 0 1 3.75 10.5v-.75h4.5zm10.5 9.75H5.25v-5.325A3.75 3.75 0 0 0 9 12.75a3.751 3.751 0 0 0 6 0 3.75 3.75 0 0 0 3.75 1.425V19.5zm.462-7.106a.757.757 0 0 0-.169.098A2.25 2.25 0 0 1 15.75 10.5v-.75h4.5v.75a2.25 2.25 0 0 1-1.038 1.894z",
    "data-ppui": "true"
  })), props.children);
};
var MessageCenterIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded206);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "message center icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.25 7.5h-3v-3a1.5 1.5 0 0 0-1.5-1.5h-12a1.5 1.5 0 0 0-1.5 1.5v12a.75.75 0 0 0 1.219.583l3.281-2.645v2.812a1.5 1.5 0 0 0 1.5 1.5h8.774l3.507 2.833a.75.75 0 0 0 1-.053.75.75 0 0 0 .219-.53V9a1.5 1.5 0 0 0-1.5-1.5zM6.24 12.917L3.75 14.93V4.5h12v8.25H6.71a.75.75 0 0 0-.47.167zm14.01 6.513l-2.49-2.013a.75.75 0 0 0-.468-.167H8.25v-3h7.5a1.5 1.5 0 0 0 1.5-1.5V9h3v10.43z",
    "data-ppui": "true"
  })), props.children);
};
var MessageIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded207);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "message icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.25 4.5H3.75A1.5 1.5 0 0 0 2.25 6v15a1.486 1.486 0 0 0 .866 1.36 1.49 1.49 0 0 0 1.595-.214l.008-.007L7.781 19.5H20.25a1.5 1.5 0 0 0 1.5-1.5V6a1.5 1.5 0 0 0-1.5-1.5zm0 13.5H7.5a.75.75 0 0 0-.49.183L3.75 21V6h16.5v12zm-12-7.5A.75.75 0 0 1 9 9.75h6a.75.75 0 0 1 0 1.5H9a.75.75 0 0 1-.75-.75zm0 3a.75.75 0 0 1 .75-.75h6a.75.75 0 1 1 0 1.5H9a.75.75 0 0 1-.75-.75z",
    "data-ppui": "true"
  })), props.children);
};
var MgmIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded208);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "mgm icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.25 3.75H6.75A5.256 5.256 0 0 0 1.5 9v9A1.5 1.5 0 0 0 3 19.5h18a1.5 1.5 0 0 0 1.5-1.5V9a5.256 5.256 0 0 0-5.25-5.25zM21 9v.75h-3V5.325A3.756 3.756 0 0 1 21 9zm-8.25 3.75h-1.5v-3h1.5v3zm-2.25 1.5h3a.75.75 0 0 0 .75-.75v-2.25h2.25V18h-9v-6.75h2.25v2.25a.75.75 0 0 0 .75.75zm3.75-4.5V9a.75.75 0 0 0-.75-.75h-3a.75.75 0 0 0-.75.75v.75H7.5v-4.5h9v4.5h-2.25zM6 5.325V9.75H3V9a3.757 3.757 0 0 1 3-3.675zM3 11.25h3V18H3v-6.75zM21 18h-3v-6.75h3V18z",
    "data-ppui": "true"
  })), props.children);
};
var MicrophoneIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded209);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "microphone icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 16.5a4.504 4.504 0 0 0 4.5-4.5V6a4.5 4.5 0 1 0-9 0v6a4.505 4.505 0 0 0 4.5 4.5zM9 6a3 3 0 1 1 6 0v6a3 3 0 0 1-6 0V6zm3.75 13.462V22.5a.75.75 0 1 1-1.5 0v-3.038A7.51 7.51 0 0 1 4.5 12 .75.75 0 1 1 6 12a6 6 0 1 0 12 0 .75.75 0 1 1 1.5 0 7.51 7.51 0 0 1-6.75 7.462z",
    "data-ppui": "true"
  })), props.children);
};
var MilitaryIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded210);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "military icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.406 3.75H4.594A1.594 1.594 0 0 0 3 5.344v4.613a1.594 1.594 0 0 0 .938 1.45l5.868 2.668a4.5 4.5 0 1 0 4.395 0l5.861-2.667A1.594 1.594 0 0 0 21 9.958V5.343a1.594 1.594 0 0 0-1.594-1.594zM15 5.25v6.813l-3 1.363-3-1.363V5.25h6zM4.5 9.957V5.344a.094.094 0 0 1 .094-.094H7.5v6.13l-2.945-1.338a.094.094 0 0 1-.055-.085zM12 21a3 3 0 1 1 0-5.999A3 3 0 0 1 12 21zm7.5-11.043a.094.094 0 0 1-.055.085L16.5 11.38V5.25h2.906a.094.094 0 0 1 .094.094v4.613z",
    "data-ppui": "true"
  })), props.children);
};
var MoveIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded211);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "move icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.47 5.78a.75.75 0 0 1 0-1.06l3-3a.749.749 0 0 1 1.06 0l3 3a.75.75 0 0 1-1.06 1.06l-1.72-1.72V9a.75.75 0 1 1-1.5 0V4.06L9.53 5.78a.75.75 0 0 1-1.06 0zm6 12.44l-1.72 1.72V15a.75.75 0 1 0-1.5 0v4.94l-1.72-1.72a.75.75 0 1 0-1.06 1.06l3 3a.747.747 0 0 0 1.06 0l3-3a.75.75 0 0 0-1.06-1.06zm7.81-6.75l-3-3a.75.75 0 1 0-1.06 1.06l1.72 1.72H15a.75.75 0 1 0 0 1.5h4.94l-1.72 1.72a.75.75 0 1 0 1.06 1.06l3-3a.749.749 0 0 0 0-1.06zM4.06 12.75H9a.75.75 0 1 0 0-1.5H4.06l1.72-1.72a.75.75 0 1 0-1.06-1.06l-3 3a.749.749 0 0 0 0 1.06l3 3a.75.75 0 1 0 1.06-1.06l-1.72-1.72z",
    "data-ppui": "true"
  })), props.children);
};
var MovieIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded212);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "movie icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.25 9.75H9.571l10.117-2.67a.75.75 0 0 0 .532-.923l-.765-2.813a1.493 1.493 0 0 0-1.82-1.043L3.356 6.069a1.477 1.477 0 0 0-.91.694 1.454 1.454 0 0 0-.144 1.125L3 10.458v8.292a1.5 1.5 0 0 0 1.5 1.5h15a1.5 1.5 0 0 0 1.5-1.5V10.5a.75.75 0 0 0-.75-.75zm-2.235-6l.563 2.07-2.121.562-2.636-1.523 4.194-1.109zM11.763 5.4l2.636 1.522-3.463.915L8.3 6.316l3.463-.916zM4.319 9.583l-.562-2.07 2.484-.656L8.877 8.38 4.32 9.583zM19.5 18.75h-15v-7.5h15v7.5z",
    "data-ppui": "true"
  })), props.children);
};
var MusicIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded213);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "music icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.961 1.658a.75.75 0 0 0-.643-.136l-12 3a.75.75 0 0 0-.568.728v10.32a3.375 3.375 0 1 0 1.5 2.805v-8.04l10.5-2.624v4.859a3.375 3.375 0 1 0 1.5 2.805V2.25a.75.75 0 0 0-.289-.592zM4.875 20.25a1.875 1.875 0 1 1 0-3.75 1.875 1.875 0 0 1 0 3.75zM8.25 8.789V5.836l10.5-2.625v2.953L8.25 8.789zm8.625 8.461a1.875 1.875 0 1 1 0-3.751 1.875 1.875 0 0 1 0 3.751z",
    "data-ppui": "true"
  })), props.children);
};
var MusicalInstrumentsIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded214);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "musical instruments icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5 3h-15A1.5 1.5 0 0 0 3 4.5v15A1.5 1.5 0 0 0 4.5 21h15a1.5 1.5 0 0 0 1.5-1.5v-15A1.5 1.5 0 0 0 19.5 3zm-12 1.5h2.25v8.25H7.5V4.5zm3 9.75a.75.75 0 0 0 .75-.75v-9h1.5v9a.75.75 0 0 0 .75.75h.75v5.25h-4.5v-5.25h.75zm3.75-1.5V4.5h2.25v8.25h-2.25zM4.5 4.5H6v9a.75.75 0 0 0 .75.75h1.5v5.25H4.5v-15zm15 15h-3.75v-5.25h1.5a.75.75 0 0 0 .75-.75v-9h1.5v15z",
    "data-ppui": "true"
  })), props.children);
};
var MuteIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded215);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "mute icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.055 3.246a.75.75 0 1 0-1.11 1.009L6.895 7.5H3A1.5 1.5 0 0 0 1.5 9v6A1.5 1.5 0 0 0 3 16.5h4.242l6.548 5.092A.75.75 0 0 0 15 21v-4.585l3.945 4.34a.75.75 0 1 0 1.11-1.01l-15-16.5zM3 9h3.75v6H3V9zm10.5 10.466l-5.25-4.082V8.99l5.25 5.775v4.701zm3.938-5.978a2.25 2.25 0 0 0 0-2.974.75.75 0 1 1 1.125-.99 3.75 3.75 0 0 1 0 4.957.751.751 0 0 1-1.125-.993zM9.922 6.363a.75.75 0 0 1 .13-1.053l3.737-2.906A.75.75 0 0 1 15 3v7.015a.75.75 0 1 1-1.5 0V4.534l-2.526 1.969a.75.75 0 0 1-1.052-.136v-.004zM23.25 12a7.49 7.49 0 0 1-1.91 5 .75.75 0 0 1-1.117-1 6 6 0 0 0 0-8 .751.751 0 1 1 1.117-1 7.484 7.484 0 0 1 1.91 5z",
    "data-ppui": "true"
  })), props.children);
};
var NavigateIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded216);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "navigate icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.25 9.957L5.757 3.844l-.015-.005A1.5 1.5 0 0 0 3.84 5.757L9.957 22.25a1.479 1.479 0 0 0 1.413 1h.028a1.478 1.478 0 0 0 1.406-1.058l.006-.02 2.047-7.312 7.313-2.047.019-.006a1.5 1.5 0 0 0 .058-2.848l.003-.002zm-8.203 3.571a.75.75 0 0 0-.519.52l-2.156 7.702-.006-.016L5.25 5.25l16.483 6.114.015.006-7.7 2.158z",
    "data-ppui": "true"
  })), props.children);
};
var NfcIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded217);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "nfc icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.316 1.816a.837.837 0 0 1 1.185.166c2.154 2.886 3.292 6.344 3.292 9.997 0 3.652-1.138 7.11-3.292 9.996a.84.84 0 0 1-1.185.165.866.866 0 0 1-.163-1.198c1.93-2.587 2.95-5.684 2.95-8.964 0-3.279-1.02-6.379-2.95-8.963a.867.867 0 0 1 .163-1.199zM6.717 7.662a.837.837 0 0 0-1.196 0 .865.865 0 0 0 0 1.208 4.4 4.4 0 0 1 1.264 3.107 4.4 4.4 0 0 1-1.264 3.106.864.864 0 0 0 0 1.207.834.834 0 0 0 1.197 0 6.116 6.116 0 0 0 1.757-4.313 6.116 6.116 0 0 0-1.758-4.315zm4.577 11.27c.064-.084.127-.17.19-.256a11.354 11.354 0 0 0 2.148-6.7 11.35 11.35 0 0 0-2.446-7.093.835.835 0 0 0-1.19-.132.864.864 0 0 0-.128 1.201 9.627 9.627 0 0 1 2.076 6.025A9.633 9.633 0 0 1 9.868 18a.864.864 0 0 0 .13 1.201.836.836 0 0 0 1.191-.132l.105-.138z",
    "data-ppui": "true"
  })), props.children);
};
var NightIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded218);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "night icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.894 13.334a.75.75 0 0 0-.75-.187A8.258 8.258 0 0 1 10.851 2.853a.75.75 0 0 0-.938-.937 9.829 9.829 0 0 0-4.96 3.468A9.75 9.75 0 0 0 12.75 21a9.665 9.665 0 0 0 5.861-1.957 9.828 9.828 0 0 0 3.469-4.96.75.75 0 0 0-.186-.749zm-4.185 4.51A8.25 8.25 0 0 1 6.156 6.293a8.344 8.344 0 0 1 2.943-2.438 9.76 9.76 0 0 0 11.05 11.047 8.344 8.344 0 0 1-2.44 2.944z",
    "data-ppui": "true"
  })), props.children);
};
var NoIconIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded219);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "no icon icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.495 10.364a.715.715 0 0 0 1.01 0l3.572-3.572a.715.715 0 0 0 0-1.01L12.505 2.21a.714.714 0 0 0-1.01 0L7.923 5.78a.714.714 0 0 0 0 1.011l3.572 3.572zM12 3.724l2.562 2.563L12 8.848 9.439 6.287 12 3.725zm.505 9.912a.715.715 0 0 0-1.01 0l-3.572 3.572a.714.714 0 0 0 0 1.01l3.572 3.573a.713.713 0 0 0 1.01 0l3.572-3.572a.715.715 0 0 0 0-1.011l-3.572-3.572zM12 20.278l-2.561-2.562L12 15.154l2.562 2.562L12 20.278zm9.79-8.782l-3.57-3.572a.714.714 0 0 0-1.011 0l-3.572 3.572a.715.715 0 0 0 0 1.01l3.572 3.572a.714.714 0 0 0 1.01 0l3.572-3.571a.715.715 0 0 0 0-1.011zm-4.076 3.067l-2.561-2.562 2.561-2.561L20.275 12l-2.561 2.562zm-7.351-3.067L6.79 7.924a.714.714 0 0 0-1.01 0l-3.572 3.572a.715.715 0 0 0 0 1.01l3.572 3.572a.714.714 0 0 0 1.01 0l3.572-3.571a.713.713 0 0 0 0-1.011zm-4.077 3.067l-2.561-2.562L6.286 9.44 8.848 12l-2.562 2.562z",
    "data-ppui": "true"
  })), props.children);
};
var NotificationPreferencesIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded220);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "notification preferences icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M14.211 12.41l.437.252a.75.75 0 1 1-.75 1.3l-.438-.253c-.21.18-.45.319-.71.411v.505a.75.75 0 1 1-1.5 0v-.505a2.243 2.243 0 0 1-.711-.411l-.438.253a.75.75 0 0 1-.75-1.3l.437-.252a2.212 2.212 0 0 1 0-.821l-.437-.252a.749.749 0 0 1 .473-1.394.75.75 0 0 1 .277.094l.438.253c.21-.18.45-.319.71-.411v-.504a.75.75 0 1 1 1.5 0v.504c.26.092.502.232.711.411l.438-.253a.75.75 0 0 1 .75 1.3l-.437.252c.051.271.051.55 0 .821zm-2.835-.827a.75.75 0 1 0 1.248.833.75.75 0 0 0-1.248-.833z",
    clipRule: "evenodd",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M19.5 9.75c0 3.312.773 5.848 1.294 6.744A1.5 1.5 0 0 1 19.5 18.75h-3.826a3.75 3.75 0 0 1-7.348 0H4.5a1.5 1.5 0 0 1-1.295-2.256c.52-.896 1.295-3.43 1.295-6.744a7.5 7.5 0 0 1 15 0zm-8.799 10.087a2.25 2.25 0 0 0 3.42-1.087H9.879c.155.439.443.818.822 1.087zM6 9.75c0 3.383-.778 6.259-1.5 7.5h15c-.724-1.244-1.5-4.12-1.5-7.5a6 6 0 1 0-12 0z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};
var NotificationIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded221);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "notification icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.794 16.491c-.52-.896-1.294-3.432-1.294-6.744a7.5 7.5 0 0 0-15 0c0 3.313-.774 5.848-1.295 6.744A1.5 1.5 0 0 0 4.5 18.747h3.826a3.75 3.75 0 0 0 7.348 0H19.5a1.5 1.5 0 0 0 1.294-2.256zM12 20.247a2.25 2.25 0 0 1-2.12-1.5h4.24a2.25 2.25 0 0 1-2.12 1.5zm-7.5-3c.722-1.241 1.5-4.117 1.5-7.5a6 6 0 1 1 12 0c0 3.38.776 6.256 1.5 7.5h-15z",
    "data-ppui": "true"
  })), props.children);
};
var NumberPadIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded222);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "number pad icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 4.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zM12 3a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zm6 3a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zM6 8.25a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zm6 0a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zm6 0a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zM6 13.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zm6 0a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zm0 5.25a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zm6-5.25a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3z",
    "data-ppui": "true"
  })), props.children);
};
var NumberedListIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded223);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "numbered list icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 12a.75.75 0 0 1-.75.75H9.75a.75.75 0 1 1 0-1.5h10.5A.75.75 0 0 1 21 12zM9.75 6.75h10.5a.75.75 0 1 0 0-1.5H9.75a.75.75 0 0 0 0 1.5zm10.5 10.5H9.75a.75.75 0 0 0 0 1.5h10.5a.75.75 0 1 0 0-1.5zM4.086 5.171l.414-.208V9.75a.75.75 0 0 0 1.5 0v-6a.75.75 0 0 0-1.086-.671l-1.5.75a.75.75 0 1 0 .672 1.342zm3.392 9.521a2.224 2.224 0 0 0-.9-1.495 2.33 2.33 0 0 0-3.197.44 2.214 2.214 0 0 0-.335.606.75.75 0 1 0 1.406.513.735.735 0 0 1 .11-.2.822.822 0 0 1 1.33.07.717.717 0 0 1-.053.833l-2.69 3.592a.75.75 0 0 0 .601 1.199h3a.75.75 0 1 0 0-1.5h-1.5l1.789-2.393a2.2 2.2 0 0 0 .44-1.664z",
    "data-ppui": "true"
  })), props.children);
};
var OccasionIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded224);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "occasion icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5 2.997h-2.25v-.75a.75.75 0 1 0-1.5 0v.75h-7.5v-.75a.75.75 0 0 0-1.5 0v.75H4.5a1.5 1.5 0 0 0-1.5 1.5v15a1.5 1.5 0 0 0 1.5 1.5h15a1.5 1.5 0 0 0 1.5-1.5v-15a1.5 1.5 0 0 0-1.5-1.5zm0 16.5h-15v-15h2.25v.75a.75.75 0 0 0 1.5 0v-.75h7.5v.75a.75.75 0 1 0 1.5 0v-.75h2.25v15zm-5.25-11.25A2.992 2.992 0 0 0 12 9.265a3 3 0 0 0-5.25 1.982c0 3.424 4.714 5.82 4.914 5.921a.75.75 0 0 0 .672 0c.2-.1 4.914-2.497 4.914-5.92a3 3 0 0 0-3-3zm-2.25 7.4c-1.293-.73-3.75-2.508-3.75-4.4a1.5 1.5 0 1 1 3 0 .75.75 0 0 0 1.5 0 1.5 1.5 0 1 1 3 0c0 1.893-2.457 3.67-3.75 4.4z",
    "data-ppui": "true"
  })), props.children);
};
var OffersIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded225);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "offers icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.174 9.64c-.353-.37-.719-.75-.857-1.085-.127-.307-.134-.815-.142-1.307-.014-.915-.03-1.952-.75-2.673-.72-.72-1.758-.736-2.673-.75-.492-.008-1-.015-1.307-.143-.333-.137-.715-.503-1.084-.856C13.714 2.204 12.979 1.5 12 1.5c-.979 0-1.713.704-2.36 1.326-.37.353-.75.719-1.085.857-.305.127-.815.135-1.307.142-.915.014-1.952.03-2.673.75-.72.72-.731 1.758-.75 2.673-.008.492-.015 1-.143 1.307-.137.333-.503.715-.856 1.084C2.204 10.287 1.5 11.021 1.5 12c0 .979.704 1.713 1.326 2.36.353.37.719.75.857 1.085.127.307.135.815.142 1.307.014.915.03 1.952.75 2.673.72.72 1.758.736 2.673.75.492.008 1 .015 1.307.142.333.138.715.504 1.084.857.647.622 1.382 1.326 2.361 1.326.979 0 1.713-.704 2.36-1.326.37-.353.75-.719 1.085-.857.307-.127.815-.134 1.307-.142.915-.014 1.952-.03 2.673-.75.72-.72.736-1.758.75-2.673.008-.492.015-1 .142-1.307.138-.333.504-.715.857-1.084.622-.648 1.326-1.382 1.326-2.361 0-.979-.704-1.713-1.326-2.36zm-1.082 3.683c-.45.469-.915.953-1.161 1.549-.236.571-.247 1.225-.256 1.858-.01.656-.02 1.343-.311 1.634-.292.29-.974.302-1.634.311-.633.01-1.287.02-1.858.256-.596.246-1.08.711-1.55 1.16-.468.45-.947.909-1.322.909-.375 0-.858-.461-1.323-.908-.465-.448-.953-.915-1.549-1.161-.571-.236-1.225-.247-1.858-.256-.656-.01-1.343-.02-1.634-.311-.29-.292-.302-.974-.311-1.634-.01-.633-.02-1.287-.256-1.858-.247-.596-.712-1.08-1.16-1.55C3.458 12.855 3 12.376 3 12c0-.375.461-.857.908-1.323.448-.466.914-.953 1.161-1.549.236-.571.247-1.225.256-1.858.01-.656.02-1.343.311-1.634.292-.29.974-.302 1.634-.311.633-.01 1.287-.02 1.858-.256.596-.247 1.08-.712 1.55-1.16C11.145 3.458 11.624 3 12 3c.375 0 .858.461 1.323.908.465.448.953.914 1.549 1.161.571.236 1.225.247 1.858.256.656.01 1.343.02 1.634.311.29.292.302.974.311 1.634.01.633.02 1.287.256 1.858.246.596.711 1.08 1.16 1.55.45.468.909.947.909 1.322 0 .375-.461.857-.908 1.323zM11.25 9a2.25 2.25 0 1 0-4.5 0 2.25 2.25 0 0 0 4.5 0zm-3 0a.75.75 0 1 1 1.5 0 .75.75 0 0 1-1.5 0zM15 12.75a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5zm0 3a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5zm1.28-6.97l-7.5 7.5a.75.75 0 1 1-1.06-1.06l7.5-7.5a.751.751 0 0 1 1.06 1.06z",
    "data-ppui": "true"
  })), props.children);
};
var OfficeSuppliesIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded226);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "office supplies icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5 2.997H15a1.5 1.5 0 0 0-1.5 1.5v15a1.5 1.5 0 0 0 1.5 1.5h4.5a1.5 1.5 0 0 0 1.5-1.5v-15a1.5 1.5 0 0 0-1.5-1.5zm0 16.5H15v-3h2.25a.75.75 0 1 0 0-1.5H15v-2.25h2.25a.75.75 0 1 0 0-1.5H15v-2.25h2.25a.75.75 0 1 0 0-1.5H15v-3h4.5v15zM7.28 2.467a.75.75 0 0 0-1.06 0l-3 3a.75.75 0 0 0-.22.53v13.5a1.5 1.5 0 0 0 1.5 1.5H9a1.5 1.5 0 0 0 1.5-1.5v-13.5a.75.75 0 0 0-.22-.53l-3-3zM4.5 16.497v-9H6v9H4.5zm3-9H9v9H7.5v-9zm-.75-3.44l1.94 1.94H4.81l1.94-1.94zM4.5 19.497v-1.5H9v1.5H4.5z",
    "data-ppui": "true"
  })), props.children);
};
var OfflineIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded227);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "offline icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.055 3.243a.75.75 0 1 0-1.11 1.008l3.679 4.047-.006.012a6 6 0 1 0-.868 11.937H15a8.19 8.19 0 0 0 2.981-.556l.964 1.06a.752.752 0 0 0 1.066.058.75.75 0 0 0 .044-1.067l-15-16.5zM15 18.747H6.75a4.5 4.5 0 1 1 0-9c.103 0 .206 0 .31.011a8.287 8.287 0 0 0-.31 2.239.75.75 0 1 0 1.5 0c0-.852.161-1.696.474-2.488l8.157 8.972a6.715 6.715 0 0 1-1.881.266zm8.25-6.75a8.24 8.24 0 0 1-2.095 5.495.75.75 0 0 1-1.12-.995 6.75 6.75 0 0 0-9.032-9.938.75.75 0 1 1-.888-1.208 8.25 8.25 0 0 1 13.135 6.646z",
    "data-ppui": "true"
  })), props.children);
};
var OnlineShoppingIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded228);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "online shopping icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5 1.5h-9a2.25 2.25 0 0 0-2.25 2.25v16.5A2.25 2.25 0 0 0 7.5 22.5h3.484a.75.75 0 1 0 0-1.5H7.5a.75.75 0 0 1-.75-.75V3.75A.75.75 0 0 1 7.5 3h9a.75.75 0 0 1 .75.75v2.33a.75.75 0 0 0 1.5 0V3.75A2.25 2.25 0 0 0 16.5 1.5z",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.125 5.625a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0z",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M20.625 12.021h.75a.75.75 0 0 1 .75.75v6.75a.75.75 0 0 1-.75.75h-6.75a.75.75 0 0 1-.75-.75v-6.75a.75.75 0 0 1 .75-.75h.75v-.375a2.625 2.625 0 0 1 5.25 0v.375zm-3.42-1.17c-.211.21-.33.497-.33.795v.375h2.25v-.375a1.125 1.125 0 0 0-1.92-.795zm-1.83 2.67v5.25h5.25v-5.25h-5.25z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};
var OnlineIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded229);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "online icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 3.747A8.259 8.259 0 0 0 7.62 8.31a6 6 0 1 0-.87 11.937H15a8.25 8.25 0 0 0 0-16.5zm0 15H6.75a4.5 4.5 0 1 1 .308-8.99 8.25 8.25 0 0 0-.308 2.24.75.75 0 0 0 1.5 0 6.75 6.75 0 1 1 6.75 6.75z",
    "data-ppui": "true"
  })), props.children);
};
var OpenBrowserIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded230);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "open browser icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 12.747v6a.75.75 0 0 1-1.5 0v-4.189l-6.22 6.22a.75.75 0 1 1-1.06-1.062l6.219-6.219H5.25a.75.75 0 1 1 0-1.5h6a.75.75 0 0 1 .75.75zm7.5-9.75h-12a1.5 1.5 0 0 0-1.5 1.5v4.5a.75.75 0 0 0 1.5 0v-4.5h12v12H15a.75.75 0 1 0 0 1.5h4.5a1.5 1.5 0 0 0 1.5-1.5v-12a1.5 1.5 0 0 0-1.5-1.5z",
    "data-ppui": "true"
  })), props.children);
};
var OrderAheadIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded231);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "order ahead icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 10.5H3a.75.75 0 0 0-.75.75 9.783 9.783 0 0 0 5.25 8.651v.349a1.5 1.5 0 0 0 1.5 1.5h6a1.5 1.5 0 0 0 1.5-1.5v-.349a9.783 9.783 0 0 0 5.25-8.651.75.75 0 0 0-.75-.75zm-5.563 8.25a.75.75 0 0 0-.437.682v.818H9v-.817a.75.75 0 0 0-.437-.683A8.277 8.277 0 0 1 3.782 12h16.433a8.278 8.278 0 0 1-4.778 6.75zM7.666 5.156c.501-.624.625-1.046.574-1.232-.04-.14-.226-.211-.228-.211a.75.75 0 0 1 .461-1.43c.094.03.93.313 1.2 1.197.23.757-.053 1.636-.84 2.615-.5.624-.624 1.046-.573 1.232.04.14.222.21.224.21a.75.75 0 0 1-.457 1.43c-.094-.03-.93-.313-1.2-1.197-.23-.757.052-1.636.839-2.614zm3.75 0c.501-.624.625-1.046.574-1.232-.04-.14-.226-.211-.228-.211a.75.75 0 0 1 .461-1.43c.094.03.93.313 1.2 1.197.23.757-.053 1.636-.84 2.615-.5.624-.624 1.046-.573 1.232.04.14.222.21.224.21a.75.75 0 0 1-.457 1.43c-.094-.03-.93-.313-1.2-1.197-.23-.757.052-1.636.839-2.614zm3.75 0c.501-.624.625-1.046.574-1.232-.04-.14-.226-.211-.228-.211a.75.75 0 0 1 .461-1.43c.094.03.93.313 1.2 1.197.23.757-.052 1.636-.84 2.615-.5.624-.624 1.046-.573 1.232.04.14.222.21.224.21a.75.75 0 0 1-.457 1.43c-.094-.03-.93-.313-1.2-1.197-.23-.757.052-1.636.839-2.614z",
    "data-ppui": "true"
  })), props.children);
};
var OthersIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded232);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "others icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.648 16.122a.75.75 0 0 1-.273 1.023l-9 5.25a.75.75 0 0 1-.756 0l-9-5.25a.75.75 0 0 1 .756-1.296L12 20.88l8.625-5.03a.75.75 0 0 1 1.023.273zm-1.023-4.773L12 16.38l-8.625-5.03a.75.75 0 0 0-.75 1.296l9 5.25a.75.75 0 0 0 .756 0l9-5.25a.749.749 0 1 0-.756-1.296zM2.25 7.497a.75.75 0 0 1 .375-.648l9-5.25a.75.75 0 0 1 .756 0l9 5.25a.75.75 0 0 1 0 1.296l-9 5.25a.75.75 0 0 1-.756 0l-9-5.25a.75.75 0 0 1-.375-.648zm2.239 0L12 11.879l7.511-4.382L12 3.115 4.489 7.497z",
    "data-ppui": "true"
  })), props.children);
};
var OverflowIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded233);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "overflow icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.125 11.997a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0zM12 6.747a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25zm0 10.5a1.125 1.125 0 1 0 0 2.25 1.125 1.125 0 0 0 0-2.25z",
    "data-ppui": "true"
  })), props.children);
};
var PackageSizeIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded234);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "package size icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.876 4.816v-3a.75.75 0 0 0-.75-.75h-3a.75.75 0 0 0 0 1.5h2.25v2.25a.75.75 0 0 0 1.5 0zM2.579 21.453h2.25a.75.75 0 0 1 0 1.5h-3a.75.75 0 0 1-.75-.75v-3a.75.75 0 0 1 1.5 0v2.25z",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3.568 16.628c.127.213.309.389.527.508l7.216 3.95a1.378 1.378 0 0 0 1.332 0l7.217-3.95a1.387 1.387 0 0 0 .721-1.214V8.079a1.387 1.387 0 0 0-.721-1.216l-7.217-3.949a1.378 1.378 0 0 0-1.332 0l-7.216 3.95a1.387 1.387 0 0 0-.721 1.215v7.843c0 .248.067.492.194.706zM9.691 5.465l2.286-1.251 6.433 3.523-2.285 1.25L9.69 5.466zM5.545 7.737l6.432 3.522 2.624-1.436L8.17 6.3 5.545 7.737zm-.71 8.141V9.011l6.411 3.509v6.864l-6.41-3.506zM19.12 9.011v6.864l-6.41 3.509v-6.861l2.474-1.354v2.8a.731.731 0 0 0 1.462 0v-3.6l2.474-1.358z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};
var PartySuppliesIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded235);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "party supplies icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 1.497a8.26 8.26 0 0 0-8.25 8.25c0 2.197.881 4.633 2.356 6.516 1.132 1.444 2.484 2.437 3.929 2.914l-.974 2.275a.75.75 0 0 0 .689 1.045h4.5a.75.75 0 0 0 .69-1.045l-.971-2.275c1.444-.475 2.796-1.47 3.929-2.914 1.47-1.883 2.352-4.32 2.352-6.516A8.26 8.26 0 0 0 12 1.497zm1.113 19.5h-2.226l.65-1.518a6.355 6.355 0 0 0 .925 0l.65 1.518zm3.6-5.66c-1.344 1.716-3.017 2.66-4.713 2.66-1.696 0-3.37-.944-4.713-2.66-1.276-1.627-2.037-3.715-2.037-5.59a6.75 6.75 0 0 1 13.5 0c0 1.875-.761 3.963-2.037 5.59zm-.094-5.6a.75.75 0 0 1-.858-.616 3.87 3.87 0 0 0-3.134-3.134.75.75 0 1 1 .248-1.48 5.391 5.391 0 0 1 4.366 4.366.75.75 0 0 1-.617.864h-.005z",
    "data-ppui": "true"
  })), props.children);
};
var PasskeyFilledIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded236);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "passkey filled icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8.285 8.795s.028 0 .045.006h.987c.045-.012.09-.018.141-.03.045-.011.096-.017.141-.029 1.117-.23 2.003-.815 2.511-1.907.49-1.046.536-2.15.214-3.254-.321-1.093-1.015-1.843-2.048-2.227-.688-.26-1.4-.29-2.11-.16-1.196.22-2.105.857-2.612 2.032-.356.827-.43 1.707-.277 2.593.22 1.293.909 2.214 2.088 2.71.299.13.61.19.925.249l-.005.017zm13.084 1.76c0 1.884-1.151 3.485-2.753 4.07l.97 1.617-1.433 1.778 1.433 1.736-2.313 3.124-1.63-1.748v-6.62c-1.45-.662-2.467-2.18-2.467-3.95 0-2.375 1.834-4.306 4.097-4.306 2.262 0 4.096 1.925 4.096 4.305v-.006zm-4.096.957c.547 0 .987-.467.987-1.04 0-.572-.44-1.039-.987-1.039-.547 0-.988.467-.988 1.04 0 .572.44 1.039.988 1.039zm-2.522 3.325c-2.184-1.075-2.336-3.219-2.336-4.872H5.322c-1.49 0-2.691 1.281-2.691 2.858v3.579c0 .791.604 1.429 1.348 1.429h9.429c.745 0 1.348-.644 1.348-1.43v-1.564h-.005z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};
var PasskeyIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded237);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "passkey icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M18.748 18.815a.751.751 0 0 0-.173-.548c-1.402-1.667-3.144-2.85-5.08-3.485a6.375 6.375 0 1 0-6.74 0c-1.936.634-3.678 1.818-5.079 3.485a.75.75 0 0 0 1.149.966c1.886-2.247 4.48-3.483 7.3-3.483 2.82 0 5.414 1.236 7.3 3.483a.75.75 0 0 0 1.323-.418zm-5.915-5.387A4.875 4.875 0 1 1 7.417 5.32a4.875 4.875 0 0 1 5.416 8.108zm5.989-2.96a1.882 1.882 0 1 1 2.445 1.797v.862h.369a.563.563 0 0 1 0 1.125h-.37v.44h.658a.562.562 0 1 1 0 1.126h-.657v.127a.563.563 0 0 1-1.125 0v-3.68a1.883 1.883 0 0 1-1.32-1.797zm1.882-.758a.758.758 0 1 0 0 1.515.758.758 0 0 0 0-1.515z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};
var PasswordInputIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded238);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "password input icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.5 5.247v13.5a.75.75 0 0 1-1.5 0v-13.5a.75.75 0 0 1 1.5 0zm8.625 5.11l-1.875.609V8.997a.75.75 0 1 0-1.5 0v1.969l-1.875-.61a.751.751 0 0 0-.469 1.427l1.875.609-1.157 1.594a.75.75 0 1 0 1.213.88l1.157-1.593 1.157 1.594a.75.75 0 1 0 1.213-.882l-1.157-1.593 1.875-.609a.75.75 0 0 0-.457-1.427zm9.938.481a.75.75 0 0 0-.938-.482l-1.875.61V8.997a.75.75 0 1 0-1.5 0v1.969l-1.875-.609a.75.75 0 1 0-.464 1.427l1.875.609-1.157 1.593a.75.75 0 1 0 1.213.882l1.157-1.594 1.157 1.594a.75.75 0 1 0 1.213-.882l-1.157-1.593 1.875-.609a.75.75 0 0 0 .476-.946z",
    "data-ppui": "true"
  })), props.children);
};
var PauseIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded239);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "pause icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.75 2.997H15a1.5 1.5 0 0 0-1.5 1.5v15a1.5 1.5 0 0 0 1.5 1.5h3.75a1.5 1.5 0 0 0 1.5-1.5v-15a1.5 1.5 0 0 0-1.5-1.5zm0 16.5H15v-15h3.75v15zM9 2.997H5.25a1.5 1.5 0 0 0-1.5 1.5v15a1.5 1.5 0 0 0 1.5 1.5H9a1.5 1.5 0 0 0 1.5-1.5v-15a1.5 1.5 0 0 0-1.5-1.5zm0 16.5H5.25v-15H9v15z",
    "data-ppui": "true"
  })), props.children);
};
var PayIn3Icon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded240);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "pay in 3 icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3 4.5h18A1.5 1.5 0 0 1 22.5 6v3.775h-.004v.72a.75.75 0 0 1-1.5 0V9.75H3V18h6.268a.75.75 0 0 1 0 1.5H3A1.5 1.5 0 0 1 1.5 18V6A1.5 1.5 0 0 1 3 4.5zm18 2.645a.749.749 0 0 0-.004.078V8.25H3V6h18v1.145z",
    clipRule: "evenodd",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12.189 16.441a5.116 5.116 0 1 1 10.232 0 5.116 5.116 0 0 1-10.232 0zm4.44-3.706a3.767 3.767 0 0 0-2.845 5.047l2.846-1.643v-3.404zm.72 4.548l-2.865 1.654a3.757 3.757 0 0 0 2.82 1.27c1.14 0 2.16-.505 2.851-1.304l-2.806-1.62zm3.722-.842c0 .457-.081.894-.23 1.3l-2.861-1.653v-3.353a3.767 3.767 0 0 1 3.091 3.706z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};
var PayIn4Icon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded241);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "pay in 4 icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M21 4.5H3A1.5 1.5 0 0 0 1.5 6v12A1.5 1.5 0 0 0 3 19.5h6.268a.75.75 0 0 0 0-1.5H3V9.75h17.996v.745a.75.75 0 0 0 1.5 0v-.72h.004V6A1.5 1.5 0 0 0 21 4.5zm-.004 2.723A.68.68 0 0 1 21 7.145V6H3v2.25h17.996V7.223z",
    clipRule: "evenodd",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M17.305 11.325a5.116 5.116 0 1 0 0 10.232 5.116 5.116 0 0 0 0-10.232zm-3.706 4.441a3.77 3.77 0 0 1 3.03-3.03v3.03H13.6zm0 1.35a3.77 3.77 0 0 0 3.03 3.031v-3.03H13.6zm4.38 0v3.031a3.77 3.77 0 0 0 3.032-3.03H17.98zm3.032-1.35a3.764 3.764 0 0 0-3.03-3.03v3.03h3.03z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};
var PayLaterIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded242);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "pay later icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M21 4.5H3A1.5 1.5 0 0 0 1.5 6v12A1.5 1.5 0 0 0 3 19.5h6.268a.75.75 0 0 0 0-1.5H3V9.75h17.996v.745a.75.75 0 0 0 1.5 0v-.72h.004V6A1.5 1.5 0 0 0 21 4.5zm-.004 2.723A.68.68 0 0 1 21 7.145V6H3v2.25h17.996V7.223z",
    clipRule: "evenodd",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M20.817 17.488a.716.716 0 0 1-.716.715h-2.693a.716.716 0 0 1-.716-.715v-2.693a.716.716 0 0 1 1.432 0v1.977H20.1a.716.716 0 0 1 .716.716z",
    clipRule: "evenodd",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M17.5 12.111a5.382 5.382 0 0 1 5.375 5.376 5.377 5.377 0 1 1-5.376-5.375zm-2.144 8.583a3.857 3.857 0 1 0 4.286-6.415 3.857 3.857 0 0 0-4.286 6.415z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};
var PayMonthlyIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded243);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "pay monthly icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10.677 16.377a3.382 3.382 0 0 1-3.556-1.79 3.375 3.375 0 1 1 6.202-2.616 3.375 3.375 0 1 1-2.646 4.406zm4.756-.038a1.875 1.875 0 1 0-3.119-2.084 1.875 1.875 0 0 0 3.12 2.084zm-4.176-4.785a1.875 1.875 0 1 0-.734 3.325 3.376 3.376 0 0 1 1.406-2.337 1.875 1.875 0 0 0-.672-.988z",
    clipRule: "evenodd",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M17.25 3h2.25A1.5 1.5 0 0 1 21 4.5v15a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 3 19.5v-15A1.5 1.5 0 0 1 4.5 3h2.25v-.75a.75.75 0 0 1 1.5 0V3h7.5v-.75a.75.75 0 1 1 1.5 0V3zM6.75 5.25V4.5H4.5v3h15v-3h-2.25v.75a.75.75 0 1 1-1.5 0V4.5h-7.5v.75a.75.75 0 0 1-1.5 0zM4.5 19.5h15V9h-15v10.5z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};
var PayoutsIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded244);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "payouts icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.25 24a.75.75 0 0 1-.75-.75v-21a.75.75 0 0 1 .75-.75h12a.75.75 0 0 1 .75.75v9.34a8.521 8.521 0 0 1 3.75 7.033V22.5a.75.75 0 1 1-1.5 0v-3.873A7.016 7.016 0 0 0 18 13.5v5.466a.75.75 0 0 1-1.377.411l-1.002-1.529a1.126 1.126 0 1 0-1.98 1.073l2.075 3.168a.75.75 0 1 1-1.255.822l-2.087-3.188-.023-.036a2.625 2.625 0 0 1 4.149-3.15V6.595A5.324 5.324 0 0 1 12.905 3h-3.31A5.323 5.323 0 0 1 6 6.595v12.31A5.324 5.324 0 0 1 9.595 22.5h3.427a.75.75 0 0 1 0 1.5H5.25zm9.247-21A3.826 3.826 0 0 0 16.5 5.003V3h-2.003zM6 5.003A3.826 3.826 0 0 0 8.003 3H6v2.003zM8.003 22.5A3.826 3.826 0 0 0 6 20.497V22.5h2.003z",
    clipRule: "evenodd",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M14.368 10.667a3.75 3.75 0 1 1-6.235 4.166 3.75 3.75 0 0 1 6.235-4.166zm-4.989.833a2.25 2.25 0 1 0 3.742 2.5 2.25 2.25 0 0 0-3.742-2.5z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};
var PaypalAppIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded245);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "paypal app icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.636 8.77a5.232 5.232 0 0 0-1.892-1.517A5.25 5.25 0 0 0 13.5 2.25H7.875A1.5 1.5 0 0 0 6.42 3.386l-3.375 13.5A1.5 1.5 0 0 0 4.5 18.75h2.578l-.281 1.136A1.5 1.5 0 0 0 8.25 21.75h2.953a1.5 1.5 0 0 0 1.453-1.136l.844-3.364h3a5.25 5.25 0 0 0 4.138-8.48h-.002zM4.5 17.25l3.375-13.5H13.5a3.75 3.75 0 0 1 3.684 3.046 5.342 5.342 0 0 0-.684-.046h-5.25a1.5 1.5 0 0 0-1.456 1.136L7.455 17.25H4.5zm12.656-8.942l-.022.101A3.745 3.745 0 0 1 13.5 11.25h-3l.75-3h5.25c.22 0 .44.02.656.058zm2.978 4.601A3.745 3.745 0 0 1 16.5 15.75h-3a1.5 1.5 0 0 0-1.455 1.136l-.844 3.364H8.25l1.875-7.5H13.5a5.24 5.24 0 0 0 5.063-3.88 3.77 3.77 0 0 1 1.605 2.351 3.725 3.725 0 0 1-.032 1.688h-.002z",
    "data-ppui": "true"
  })), props.children);
};
var PaypalAssistantIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded246);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "paypal assistant icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16.902 2.602c-.5 1.772-.878 2.135-2.65 2.65a.223.223 0 0 0-.166.212c0 .091.075.182.166.212 1.772.515 2.135.894 2.65 2.665.03.106.121.167.212.167s.182-.076.212-.167c.515-1.787.893-2.15 2.665-2.665a.223.223 0 0 0 .167-.212c0-.09-.076-.182-.167-.212-1.771-.5-2.15-.878-2.665-2.65a.223.223 0 0 0-.212-.166c-.09 0-.182.075-.212.166zm-6.846 6.281c-1.127 3.995-1.98 4.815-5.976 5.976a.503.503 0 0 0-.375.478c0 .205.17.41.375.478 3.995 1.16 4.815 2.015 5.976 6.01a.503.503 0 0 0 .478.375c.205 0 .41-.17.478-.375 1.161-4.03 2.015-4.85 6.01-6.01a.503.503 0 0 0 .376-.478c0-.205-.171-.41-.376-.478-3.995-1.127-4.849-1.98-6.01-5.976a.503.503 0 0 0-.478-.376c-.205 0-.41.171-.478.376z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};
var PaypalBalanceIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded247);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "paypal balance icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M15.376 10.533a2.51 2.51 0 0 1-1.161 4.733h-1.207l-.344 1.374a.836.836 0 0 1-.812.633h-1.317a.837.837 0 0 1-.811-1.039l.075-.299h-.937a.835.835 0 0 1-.81-1.039l1.505-6.022a.836.836 0 0 1 .81-.633h2.51a2.509 2.509 0 0 1 2.5 2.292zm-2.5-1.289H10.5l-1.422 5.688h.973l1.012-4.05a.836.836 0 0 1 .811-.634h2.342l.043.001.04.002a1.512 1.512 0 0 0-.235-.427 1.495 1.495 0 0 0-1.186-.58zm.869 2.736c.254-.18.445-.433.55-.726-.027-.002-.054-.002-.08-.002h-2.21l-.252 1.003h1.124c.31 0 .614-.096.868-.275zm1.396 1.964c.264-.207.452-.496.533-.822h.001a1.511 1.511 0 0 0-.452-1.483 2.504 2.504 0 0 1-2.346 1.62h-1.375l-.752 3.01h.972l.344-1.373a.836.836 0 0 1 .81-.633h1.339c.336 0 .662-.113.926-.32z",
    clipRule: "evenodd",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.25 6h15a1.5 1.5 0 0 1 1.5 1.5V18a1.5 1.5 0 0 1-1.5 1.5h-15A2.25 2.25 0 0 1 3 17.25v-12A2.25 2.25 0 0 1 5.25 3H18a.75.75 0 1 1 0 1.5H5.25a.75.75 0 0 0 0 1.5zm0 12h15V7.5h-15c-.255 0-.51-.043-.75-.128v9.878a.75.75 0 0 0 .75.75z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};
var PaypalUsdIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded248);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "paypal usd icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9.923 2.393a28506.515 28506.515 0 0 1 4.306.001c1.75.118 3.41.596 4.645 1.65 1.26 1.075 1.983 2.67 1.983 4.81 0 1.596-.408 2.879-1.106 3.884-.694 1-1.642 1.678-2.649 2.124-1.675.74-3.575.865-4.982.742l-1.005 5.621a.75.75 0 0 1-.739.618H5.095a.75.75 0 0 1-.741-.867l1.49-9.438H3.68a.75.75 0 0 1 0-1.5h2.4l.374-2.369H4.401a.75.75 0 0 1 0-1.5h2.29l.497-3.143a.75.75 0 0 1 .74-.633h1.995zm-1.95 5.276L7.6 10.038h6.488c.244.008.6-.051.87-.226.222-.145.44-.398.44-.958 0-.623-.225-.842-.418-.959-.258-.155-.603-.203-.941-.226H7.973zm-.61 3.869L5.97 20.343h3.78l1.02-5.703a.75.75 0 0 1 .863-.607c1.224.207 3.216.185 4.864-.543.812-.36 1.518-.88 2.023-1.607.502-.723.838-1.7.838-3.03 0-1.773-.582-2.922-1.457-3.668-.895-.764-2.19-1.184-3.747-1.292H8.57l-.36 2.276h5.852c.017 0 .033 0 .049.002.35.022 1.036.075 1.64.439.676.406 1.146 1.132 1.146 2.244 0 1.07-.476 1.796-1.123 2.216-.593.385-1.272.48-1.723.467H7.362z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};
var PendingPausedIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded249);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "pending paused icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.75 10.786V6.75a.75.75 0 1 0-1.5 0V12a.75.75 0 0 0 1.086.67l4.5-2.25a.75.75 0 1 0-.672-1.341l-3.414 1.707z",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.417 18.86A8.25 8.25 0 0 0 12 20.25a.75.75 0 1 1 0 1.5A9.75 9.75 0 1 1 21.75 12a.75.75 0 1 1-1.5 0 8.25 8.25 0 1 0-12.833 6.86zm12.574-2.774v4.5a.75.75 0 1 0 1.5 0v-4.5a.75.75 0 1 0-1.5 0z",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.241 16.086v4.5a.75.75 0 1 0 1.5 0v-4.5a.75.75 0 1 0-1.5 0z",
    "data-ppui": "true"
  })), props.children);
};
var PersonalInfoIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded250);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "personal info icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.024 3.469a.75.75 0 0 1 .538-.91 9.76 9.76 0 0 1 4.875 0 .75.75 0 1 1-.375 1.451 8.25 8.25 0 0 0-4.125 0 .75.75 0 0 1-.913-.541zm-5.897 6.843a.75.75 0 0 0 .923-.522 8.239 8.239 0 0 1 2.062-3.57.75.75 0 0 0-1.068-1.05 9.742 9.742 0 0 0-2.438 4.218.75.75 0 0 0 .52.924zm10.935 9.677a8.25 8.25 0 0 1-4.125 0 .75.75 0 0 0-.375 1.452 9.76 9.76 0 0 0 4.875 0 .75.75 0 0 0-.375-1.452zM19.95 9.792a.75.75 0 1 0 1.446-.401 9.75 9.75 0 0 0-2.438-4.219.751.751 0 1 0-1.07 1.051 8.263 8.263 0 0 1 2.061 3.569zm1.447 4.818a9.72 9.72 0 0 1-2.876 4.638.75.75 0 0 1-1.17-.217 6 6 0 0 0-10.701 0 .75.75 0 0 1-1.17.218 9.726 9.726 0 0 1-2.877-4.64.75.75 0 1 1 1.446-.4 8.21 8.21 0 0 0 1.781 3.27 7.46 7.46 0 0 1 3.385-2.698 4.5 4.5 0 1 1 5.566 0 7.46 7.46 0 0 1 3.385 2.698 8.211 8.211 0 0 0 1.781-3.27.752.752 0 0 1 1.185-.39.75.75 0 0 1 .26.79h.005zM12 14.25a3 3 0 1 0 0-6 3 3 0 0 0 0 6z",
    "data-ppui": "true"
  })), props.children);
};
var PersonalSavingsIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded251);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "personal savings icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.25 8.397v-.522c0-2.351-3.547-4.125-8.25-4.125C4.297 3.75.75 5.524.75 7.875v3.75c0 1.958 2.46 3.515 6 3.98v.52c0 2.351 3.547 4.125 8.25 4.125 4.703 0 8.25-1.774 8.25-4.125v-3.75c0-1.94-2.383-3.499-6-3.978zm4.5 3.978C21.75 13.615 18.863 15 15 15c-.35 0-.697-.012-1.039-.035 2.022-.737 3.289-1.934 3.289-3.34V9.913c2.8.417 4.5 1.55 4.5 2.462zm-15 1.71v-2.23A17.22 17.22 0 0 0 9 12a17.22 17.22 0 0 0 2.25-.144v2.23a15.402 15.402 0 0 1-4.5 0zm9-3.78v1.32c0 .787-1.163 1.631-3 2.144v-2.19c1.21-.294 2.235-.731 3-1.273zM9 5.25c3.863 0 6.75 1.386 6.75 2.625 0 1.24-2.887 2.625-6.75 2.625S2.25 9.114 2.25 7.875C2.25 6.635 5.137 5.25 9 5.25zm-6.75 6.375v-1.32c.765.543 1.79.98 3 1.273v2.191c-1.837-.513-3-1.357-3-2.144zm6 4.5v-.39a18.074 18.074 0 0 0 1.818-.017c.387.138.782.256 1.182.352v2.2c-1.837-.514-3-1.358-3-2.145zm4.5 2.46V16.35a17.22 17.22 0 0 0 4.5.006v2.23a15.507 15.507 0 0 1-4.5 0zm6-.316v-2.19c1.21-.294 2.235-.731 3-1.273v1.319c0 .787-1.163 1.631-3 2.144z",
    "data-ppui": "true"
  })), props.children);
};
var PetSuppliesIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded252);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "pet supplies icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.875 7.5a2.625 2.625 0 1 0 0 5.25 2.625 2.625 0 0 0 0-5.25zm0 3.75a1.125 1.125 0 1 1 0-2.25 1.125 1.125 0 0 1 0 2.25zM6.75 10.125a2.625 2.625 0 1 0-5.25 0 2.625 2.625 0 0 0 5.25 0zM4.125 11.25a1.125 1.125 0 1 1 0-2.25 1.125 1.125 0 0 1 0 2.25zm4.5-3a2.625 2.625 0 1 0 0-5.25 2.625 2.625 0 0 0 0 5.25zm0-3.75a1.125 1.125 0 1 1 0 2.25 1.125 1.125 0 0 1 0-2.25zm6.75 3.75a2.625 2.625 0 1 0 0-5.25 2.625 2.625 0 0 0 0 5.25zm0-3.75a1.125 1.125 0 1 1 0 2.25 1.125 1.125 0 0 1 0-2.25zm2.168 9.456a3.309 3.309 0 0 1-1.582-1.982 4.124 4.124 0 0 0-7.922 0 3.305 3.305 0 0 1-1.57 1.978 3.75 3.75 0 0 0 3.236 6.755 6.009 6.009 0 0 1 4.582 0 3.75 3.75 0 0 0 3.255-6.75v-.001zM15.75 19.5a2.25 2.25 0 0 1-.886-.18 7.513 7.513 0 0 0-5.737 0 2.25 2.25 0 0 1-1.941-4.057 4.8 4.8 0 0 0 2.293-2.875 2.625 2.625 0 0 1 5.042 0 4.809 4.809 0 0 0 2.3 2.88A2.25 2.25 0 0 1 15.75 19.5z",
    "data-ppui": "true"
  })), props.children);
};
var Phone2Icon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded253);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "phone 2 icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.847 14.855l-4.416-1.979-.013-.005a1.5 1.5 0 0 0-1.492.184L12.644 15c-1.446-.702-2.938-2.184-3.64-3.61l1.948-2.317a1.5 1.5 0 0 0 .177-1.484v-.011L9.144 3.154a1.5 1.5 0 0 0-1.558-.893A5.274 5.274 0 0 0 3 7.5C3 14.944 9.056 21 16.5 21a5.274 5.274 0 0 0 5.239-4.586 1.5 1.5 0 0 0-.892-1.559zM16.5 19.5a12.014 12.014 0 0 1-12-12 3.769 3.769 0 0 1 3.27-3.75v.011l1.968 4.406-1.938 2.32a.574.574 0 0 0-.053.072 1.5 1.5 0 0 0-.094 1.472c.85 1.737 2.6 3.474 4.355 4.323a1.5 1.5 0 0 0 1.477-.107.804.804 0 0 0 .07-.053l2.278-1.944 4.407 1.973h.01A3.77 3.77 0 0 1 16.5 19.5z",
    "data-ppui": "true"
  })), props.children);
};
var PhoneDeclineIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded254);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "phone decline icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.711 10.323c-5.264-5.262-14.159-5.262-19.423 0-1.875 1.875-2.055 4.64-.44 6.723a1.5 1.5 0 0 0 1.724.476l4.593-1.628.028-.01a1.5 1.5 0 0 0 .914-1.1l.553-2.768a7.174 7.174 0 0 1 4.657-.01l.582 2.789a1.5 1.5 0 0 0 .912 1.087l.027.01 4.594 1.63a1.5 1.5 0 0 0 1.723-.474c1.611-2.085 1.43-4.85-.444-6.725zm-.742 5.8l-.028-.01-4.577-1.625-.582-2.789a1.5 1.5 0 0 0-.97-1.107 8.677 8.677 0 0 0-5.657.012 1.5 1.5 0 0 0-.967 1.125l-.553 2.767-4.576 1.614c-.01 0-.016.012-.025.016-1.156-1.491-1.032-3.396.315-4.742 2.343-2.343 5.498-3.518 8.65-3.518 3.154 0 6.307 1.173 8.652 3.518 1.343 1.346 1.474 3.25.318 4.74z",
    "data-ppui": "true"
  })), props.children);
};
var PhoneIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded255);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "phone icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5 1.5h-9a2.25 2.25 0 0 0-2.25 2.25v16.5A2.25 2.25 0 0 0 7.5 22.5h9a2.25 2.25 0 0 0 2.25-2.25V3.75A2.25 2.25 0 0 0 16.5 1.5zM6.75 6h10.5v12H6.75V6zm.75-3h9a.75.75 0 0 1 .75.75v.75H6.75v-.75A.75.75 0 0 1 7.5 3zm9 18h-9a.75.75 0 0 1-.75-.75v-.75h10.5v.75a.75.75 0 0 1-.75.75z",
    "data-ppui": "true"
  })), props.children);
};
var PhotoIdIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded256);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "photo id icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.75 10.5a.75.75 0 0 1-.75.75h-3.75a.75.75 0 1 1 0-1.5H18a.75.75 0 0 1 .75.75zM18 12.75h-3.75a.75.75 0 1 0 0 1.5H18a.75.75 0 1 0 0-1.5zm3.75-7.5v13.5a1.5 1.5 0 0 1-1.5 1.5H3.75a1.5 1.5 0 0 1-1.5-1.5V5.25a1.5 1.5 0 0 1 1.5-1.5h16.5a1.5 1.5 0 0 1 1.5 1.5zm-1.5 13.5V5.25H3.75v13.5h16.5zm-7.524-3.188a.75.75 0 1 1-1.454.376c-.246-.962-1.224-1.688-2.273-1.688-1.049 0-2.026.726-2.273 1.688a.75.75 0 1 1-1.454-.376 3.735 3.735 0 0 1 1.612-2.188 3 3 0 1 1 4.23 0c.794.5 1.37 1.282 1.613 2.188h-.001zM9 12.75a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z",
    "data-ppui": "true"
  })), props.children);
};
var PictureBrokenIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded257);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "picture broken icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.25 3.75H3.75a1.5 1.5 0 0 0-1.5 1.5v13.5a1.5 1.5 0 0 0 1.5 1.5h6a.75.75 0 0 0 .712-.513l1.39-4.17 3.43-1.37a.758.758 0 0 0 .417-.419l1.371-3.426 4.17-1.39a.75.75 0 0 0 .51-.712v-3a1.5 1.5 0 0 0-1.5-1.5zm-9.712 11.013L9.21 18.75H3.75v-2.625l4.875-4.875 2.852 2.852-.508.201a.75.75 0 0 0-.43.46zm9.712-7.054l-3.987 1.33a.75.75 0 0 0-.46.433l-1.38 3.451-1.431.577-3.307-3.307a1.5 1.5 0 0 0-2.12 0l-3.815 3.81V5.25h16.5v2.46zm1.189 3.094a.751.751 0 0 0-.676-.103l-2.231.744a.75.75 0 0 0-.46.432l-1.341 3.354-3.354 1.341a.75.75 0 0 0-.432.46l-.744 2.23a.751.751 0 0 0 .711.989h7.338a1.5 1.5 0 0 0 1.5-1.5v-7.338a.75.75 0 0 0-.311-.608v-.001zM20.25 18.75h-6.297l.305-.914 3.329-1.331a.758.758 0 0 0 .418-.418l1.33-3.33.915-.304v6.297z",
    "data-ppui": "true"
  })), props.children);
};
var PictureIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded258);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "picture icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.25 3.75H3.75a1.5 1.5 0 0 0-1.5 1.5v13.5a1.5 1.5 0 0 0 1.5 1.5h16.5a1.5 1.5 0 0 0 1.5-1.5V5.25a1.5 1.5 0 0 0-1.5-1.5zm0 1.5v9.633l-2.444-2.443a1.5 1.5 0 0 0-2.122 0l-1.875 1.875-4.125-4.125a1.5 1.5 0 0 0-2.12 0L3.75 14.003V5.25h16.5zM3.75 16.125l4.875-4.875 7.5 7.5H3.75v-2.625zm16.5 2.625h-2.003l-3.375-3.375 1.875-1.875 3.503 3.504v1.746zM13.5 9.375a1.125 1.125 0 1 1 2.25 0 1.125 1.125 0 0 1-2.25 0z",
    "data-ppui": "true"
  })), props.children);
};
var PinFilledIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded259);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "pin filled icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.062 9.75l-5.013 5.03c.428 1.187.605 3.177-1.236 5.624a1.495 1.495 0 0 1-1.094.596h-.106a1.502 1.502 0 0 1-1.061-.44l-4.525-4.529-3.996 4a.75.75 0 1 1-1.062-1.062l4-3.996-4.528-4.529a1.5 1.5 0 0 1 .122-2.229C5.946 6.292 8.226 6.67 9.224 6.983L14.25 1.94a1.5 1.5 0 0 1 2.122 0l5.69 5.69a1.5 1.5 0 0 1 0 2.12z",
    "data-ppui": "true"
  })), props.children);
};
var PinIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded260);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "pin icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.061 7.628l-5.69-5.689a1.499 1.499 0 0 0-2.121 0L9.222 6.983c-1-.313-3.281-.69-5.662 1.232a1.5 1.5 0 0 0-.121 2.23l4.53 4.528-4 3.996a.75.75 0 1 0 1.062 1.061l3.996-3.999 4.527 4.527a1.499 1.499 0 0 0 1.062.442h.106a1.493 1.493 0 0 0 1.09-.594c1.842-2.447 1.665-4.436 1.237-5.625l5.013-5.031a1.5 1.5 0 0 0 0-2.122zM21 8.69l-5.37 5.387a.75.75 0 0 0-.139.865c.887 1.774-.168 3.617-.875 4.558L4.5 9.382c1.132-.913 2.216-1.154 3.045-1.154a3.762 3.762 0 0 1 1.53.303.75.75 0 0 0 .868-.142L15.311 3 21 8.69z",
    "data-ppui": "true"
  })), props.children);
};
var PixIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded261);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "pix icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.063 10.942l-9.005-9.005a1.5 1.5 0 0 0-2.115 0l-9.006 9.005a1.5 1.5 0 0 0 0 2.115l9.005 9.006a1.5 1.5 0 0 0 2.115 0l9.006-9.006a1.5 1.5 0 0 0 0-2.115zM12 3l5.25 5.25H15a.75.75 0 0 0-.53.22L12 10.938l-2.47-2.47A.75.75 0 0 0 9 8.25H6.75L12 3zM5.25 9.75h3.44L10.94 12l-2.25 2.25H5.25L3 12l2.25-2.25zM12 21l-5.25-5.25H9a.75.75 0 0 0 .53-.22L12 13.06l2.47 2.47a.749.749 0 0 0 .53.22h2.25L12 21zm6.75-6.75h-3.439L13.061 12l2.25-2.25h3.439L21 12l-2.25 2.25z",
    "data-ppui": "true"
  })), props.children);
};
var PlayIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded262);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "play icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.788 10.733L8.28 2.47a1.5 1.5 0 0 0-2.075.517 1.487 1.487 0 0 0-.205.75v16.525a1.494 1.494 0 0 0 1.5 1.488c.277 0 .548-.076.784-.22l13.504-8.264a1.482 1.482 0 0 0 0-2.53v-.003zM7.5 20.244V3.75L20.984 12 7.5 20.244z",
    "data-ppui": "true"
  })), props.children);
};
var PledgeIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded263);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "pledge icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3 4.5h18a.75.75 0 0 1 .75.75V18a1.5 1.5 0 0 1-1.5 1.5H3.75a1.5 1.5 0 0 1-1.5-1.5V5.25A.75.75 0 0 1 3 4.5zm12.205 5.045a2.408 2.408 0 0 0-3.075.254l-.128.12-.13-.12a2.404 2.404 0 0 0-3.079-.256L4.928 6h14.144l-3.867 3.545zm-7.309 1.21a2.404 2.404 0 0 0 .585 2.453l3.01 3.054a.72.72 0 0 0 1.025 0l3.006-3.054a2.404 2.404 0 0 0 .582-2.452l4.146-3.8V18H3.75V6.955l4.146 3.8zm6.518 1.525v.004L12 14.73l-2.5-2.537-.002-.002a.965.965 0 1 1 1.365-1.365l.013.012.634.59a.72.72 0 0 0 .98 0l.635-.59.012-.012a.966.966 0 0 1 1.364 1.366l-.088.088z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};
var PlusSquareFillIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded264);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "plus square fill icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5 3h-15A1.5 1.5 0 0 0 3 4.5v15A1.5 1.5 0 0 0 4.5 21h15a1.5 1.5 0 0 0 1.5-1.5v-15A1.5 1.5 0 0 0 19.5 3zm-3.75 9.75h-3v3a.75.75 0 1 1-1.5 0v-3h-3a.75.75 0 1 1 0-1.5h3v-3a.75.75 0 1 1 1.5 0v3h3a.75.75 0 1 1 0 1.5z",
    "data-ppui": "true"
  })), props.children);
};
var PlusSquareIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded265);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "plus square icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5 3h-15A1.5 1.5 0 0 0 3 4.5v15A1.5 1.5 0 0 0 4.5 21h15a1.5 1.5 0 0 0 1.5-1.5v-15A1.5 1.5 0 0 0 19.5 3zm0 16.5h-15v-15h15v15zm-3-7.5a.75.75 0 0 1-.75.75h-3v3a.75.75 0 1 1-1.5 0v-3h-3a.75.75 0 1 1 0-1.5h3v-3a.75.75 0 1 1 1.5 0v3h3a.75.75 0 0 1 .75.75z",
    "data-ppui": "true"
  })), props.children);
};
var PosIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded266);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "pos icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M14.877 9.845H7.02a.655.655 0 0 1-.654-.654V5.262a.655.655 0 0 1 .654-.655h7.857a.655.655 0 0 1 .655.655v3.929a.655.655 0 0 1-.655.654zM7.675 5.917v2.619h6.548v-2.62H7.675zm.817 6.765a.982.982 0 1 0-1.633-1.09.982.982 0 0 0 1.633 1.09zm-.729-.486a.107.107 0 1 0-.177-.118.107.107 0 0 0 .177.118zm4.002.486a.981.981 0 1 0-1.63-1.09.981.981 0 0 0 1.63 1.09zm-.728-.486a.106.106 0 1 0-.177-.118.106.106 0 0 0 .177.118zm4.003.486a.982.982 0 1 0-1.634-1.09.982.982 0 0 0 1.633 1.09zm-.729-.486a.107.107 0 0 0-.013-.134.106.106 0 1 0 .013.134zm-5.819 3.76a.982.982 0 1 0-1.633-1.09.982.982 0 0 0 1.633 1.09zm-.729-.486a.106.106 0 1 0-.176-.118.106.106 0 0 0 .176.118zm4.002.486a.982.982 0 1 0-1.631-1.09.982.982 0 0 0 1.631 1.09zm-.728-.486a.106.106 0 1 0-.176-.118.106.106 0 0 0 .176.118zm4.003.486a.982.982 0 1 0-1.634-1.091.982.982 0 0 0 1.633 1.091zm-.729-.486a.107.107 0 0 0-.013-.135.106.106 0 1 0 .013.135z",
    clipRule: "evenodd",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.056 1.988h11.786a1.31 1.31 0 0 1 1.31 1.31v14.404a1.31 1.31 0 0 1-1.31 1.31h-.766v2.124a.876.876 0 0 1-.876.875H6.474a.876.876 0 0 1-.876-.875v-2.124h-.542a1.31 1.31 0 0 1-1.31-1.31V3.298a1.31 1.31 0 0 1 1.31-1.31zm11.786 15.714V3.298H5.056v14.404h11.786zm-9.93 2.996v-1.674h7.85v1.674h-7.85z",
    clipRule: "evenodd",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.254 4.995a.657.657 0 0 0-1.314 0v11.979a.657.657 0 1 0 1.314 0V4.994z",
    "data-ppui": "true"
  })), props.children);
};
var PreferredSelectedIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded267);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "preferred selected icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.965 10.767l-4.22 3.64 1.286 5.445a1.538 1.538 0 0 1-2.297 1.67L12 18.608l-4.737 2.914a1.538 1.538 0 0 1-2.294-1.67l1.29-5.445-4.22-3.64a1.543 1.543 0 0 1 .875-2.705l5.53-.446 2.135-5.164a1.534 1.534 0 0 1 2.837 0l2.133 5.164 5.532.446a1.543 1.543 0 0 1 .878 2.706h.006z",
    "data-ppui": "true"
  })), props.children);
};
var PreferredIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded268);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "preferred icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.423 9.118a1.536 1.536 0 0 0-1.337-1.056l-5.53-.446-2.137-5.165a1.533 1.533 0 0 0-2.837 0L8.448 7.615l-5.534.447a1.543 1.543 0 0 0-.879 2.706l4.22 3.64-1.286 5.443a1.536 1.536 0 0 0 2.297 1.671L12 18.608l4.737 2.914a1.538 1.538 0 0 0 2.294-1.67l-1.29-5.445 4.22-3.64a1.541 1.541 0 0 0 .462-1.649zm-1.438.513l-4.566 3.937a.751.751 0 0 0-.24.742l1.395 5.887a.035.035 0 0 1-.016.045c-.016.014-.021.01-.035 0l-5.13-3.154a.75.75 0 0 0-.786 0l-5.13 3.156c-.014.009-.018.012-.035 0a.034.034 0 0 1-.016-.045l1.395-5.887a.75.75 0 0 0-.24-.742L3.015 9.633c-.011-.01-.022-.018-.012-.047.01-.03.017-.026.03-.027l5.993-.484a.75.75 0 0 0 .63-.463l2.308-5.589c.008-.016.01-.023.033-.023s.026.007.033.023l2.314 5.589a.75.75 0 0 0 .633.461l5.992.484c.014 0 .023 0 .031.027.009.027 0 .037-.015.047z",
    "data-ppui": "true"
  })), props.children);
};
var PreviewIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded269);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "preview icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 14.472a2.472 2.472 0 1 0 0-4.944 2.472 2.472 0 0 0 0 4.944zm0-1.5a.972.972 0 1 0 0-1.944.972.972 0 0 0 0 1.944z",
    clipRule: "evenodd",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16.937 9.637a8.096 8.096 0 0 1 1.148 1.449c.21.338.32.576.343.628.04.091.06.19.06.288v.019a.74.74 0 0 1-.06.27c-.049.112-.51 1.093-1.488 2.072-1.35 1.349-3.06 2.065-4.939 2.065-1.88 0-3.59-.716-4.938-2.065a8.096 8.096 0 0 1-1.148-1.449 5.473 5.473 0 0 1-.343-.628.713.713 0 0 1 0-.576c.049-.113.51-1.094 1.488-2.073C8.41 8.29 10.12 7.572 12 7.572c1.88 0 3.59.717 4.938 2.065zm-9.908 2.36h.002c.04-.07.08-.139.122-.207h.003a6.28 6.28 0 0 1 .99-1.229c1.074-1.033 2.37-1.557 3.855-1.557 1.485 0 2.782.524 3.856 1.557.44.426.815.91 1.112 1.44l.006.002h-.006c-.039.07-.08.139-.122.207h-.002c-.276.448-.609.86-.99 1.229-1.075 1.033-2.372 1.557-3.856 1.557-1.485 0-2.782-.524-3.855-1.557a6.265 6.265 0 0 1-1.113-1.44l-.002-.001z",
    clipRule: "evenodd",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M20.25 3.75H3.75a1.5 1.5 0 0 0-1.5 1.5v13.5a1.5 1.5 0 0 0 1.5 1.5h16.5a1.5 1.5 0 0 0 1.5-1.5V5.25a1.5 1.5 0 0 0-1.5-1.5zm-16.5 15V5.25h16.5v13.5H3.75z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};
var PrintIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded270);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "print icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.125 6.75H18.75v-3A.75.75 0 0 0 18 3H6a.75.75 0 0 0-.75.75v3H3.875C2.565 6.75 1.5 7.76 1.5 9v7.5a.75.75 0 0 0 .75.75h3v3A.75.75 0 0 0 6 21h12a.75.75 0 0 0 .75-.75v-3h3a.75.75 0 0 0 .75-.75V9c0-1.24-1.065-2.25-2.375-2.25zM6.75 4.5h10.5v2.25H6.75V4.5zm10.5 15H6.75V15h10.5v4.5zM21 15.75h-2.25v-1.5a.75.75 0 0 0-.75-.75H6a.75.75 0 0 0-.75.75v1.5H3V9c0-.413.393-.75.875-.75h16.25c.482 0 .875.337.875.75v6.75zm-2.25-4.875a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0z",
    "data-ppui": "true"
  })), props.children);
};
var PropertyMgmtIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded271);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "property mgmt icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M14.55 14.032l.504.29a.865.865 0 1 1-.865 1.5l-.505-.293a2.6 2.6 0 0 1-.82.475v.581a.865.865 0 1 1-1.729 0v-.581a2.586 2.586 0 0 1-.82-.475l-.504.292a.866.866 0 0 1-1.119-1.276.865.865 0 0 1 .254-.222l.504-.291a2.551 2.551 0 0 1 0-.947l-.504-.291a.865.865 0 0 1 .865-1.498l.505.292c.241-.208.519-.369.819-.475v-.582a.865.865 0 0 1 1.73 0v.582c.3.106.578.267.82.475l.504-.292a.866.866 0 0 1 1.268.973.864.864 0 0 1-.403.525l-.504.29c.06.314.06.635 0 .948zm-3.27-.954a.865.865 0 1 0 1.44.961.865.865 0 0 0-1.44-.961z",
    clipRule: "evenodd",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M13.06 2.688l7.5 7.5A1.487 1.487 0 0 1 21 11.25v9a.75.75 0 0 1-.75.75H3.75a.75.75 0 0 1-.75-.75v-9a1.488 1.488 0 0 1 .44-1.062l7.5-7.5a1.5 1.5 0 0 1 2.12 0zM4.5 11.25v8.25h15v-8.25L12 3.75l-7.5 7.5z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};
var PurchaseProtectionIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded272);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "purchase protection icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5 3.75h-15A1.5 1.5 0 0 0 3 5.25v5.25c0 4.943 2.393 7.938 4.4 9.58 2.162 1.768 4.312 2.368 4.406 2.394a.752.752 0 0 0 .394 0c.093-.026 2.241-.626 4.406-2.394C18.608 18.438 21 15.443 21 10.5V5.25a1.5 1.5 0 0 0-1.5-1.5zm0 6.75c0 3.475-1.28 6.296-3.806 8.383A12.12 12.12 0 0 1 12 20.964a12.024 12.024 0 0 1-3.649-2.044C5.796 16.83 4.5 13.997 4.5 10.5V5.25h15v5.25zM7.72 13.28a.75.75 0 1 1 1.06-1.06l1.72 1.72 4.72-4.72a.751.751 0 0 1 1.06 1.06l-5.25 5.25a.747.747 0 0 1-1.06 0l-2.25-2.25z",
    "data-ppui": "true"
  })), props.children);
};
var QrcIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded273);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "qrc icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.75 3.75h-4.5a1.5 1.5 0 0 0-1.5 1.5v4.5a1.5 1.5 0 0 0 1.5 1.5h4.5a1.5 1.5 0 0 0 1.5-1.5v-4.5a1.5 1.5 0 0 0-1.5-1.5zm0 6h-4.5v-4.5h4.5v4.5zm0 3h-4.5a1.5 1.5 0 0 0-1.5 1.5v4.5a1.5 1.5 0 0 0 1.5 1.5h4.5a1.5 1.5 0 0 0 1.5-1.5v-4.5a1.5 1.5 0 0 0-1.5-1.5zm0 6h-4.5v-4.5h4.5v4.5zm9-15h-4.5a1.5 1.5 0 0 0-1.5 1.5v4.5a1.5 1.5 0 0 0 1.5 1.5h4.5a1.5 1.5 0 0 0 1.5-1.5v-4.5a1.5 1.5 0 0 0-1.5-1.5zm0 6h-4.5v-4.5h4.5v4.5zm-6 6.75v-3a.75.75 0 1 1 1.5 0v3a.75.75 0 1 1-1.5 0zm7.5-1.5a.75.75 0 0 1-.75.75h-2.25v3.75a.75.75 0 0 1-.75.75h-3a.75.75 0 1 1 0-1.5h2.25V13.5a.75.75 0 1 1 1.5 0v.75h2.25a.75.75 0 0 1 .75.75zm0 3v1.5a.75.75 0 1 1-1.5 0V18a.75.75 0 1 1 1.5 0z",
    "data-ppui": "true"
  })), props.children);
};
var QuestionSmIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded274);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "question sm icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 18 18",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9.868 13.236a1.043 1.043 0 1 0-1.735-1.16 1.043 1.043 0 0 0 1.735 1.16zM9 4.862c-1.641 0-3.012 1.206-3.012 2.732v.28a.763.763 0 0 0 1.525 0v-.28c0-.631.632-1.207 1.487-1.207.855 0 1.488.576 1.488 1.207 0 .63-.633 1.206-1.488 1.206a.763.763 0 0 0-.762.762v.563a.763.763 0 0 0 1.516.113c1.285-.301 2.259-1.36 2.259-2.644 0-1.526-1.372-2.732-3.013-2.732z",
    clipRule: "evenodd",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16.513 9A7.52 7.52 0 0 0 9 1.487 7.513 7.513 0 1 0 16.513 9zm-2.535-3.327A5.989 5.989 0 0 1 14.989 9 5.995 5.995 0 0 1 9 14.987a5.987 5.987 0 1 1 4.979-9.314z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};
var QuestionIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded275);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "question icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.125 16.875a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0zM12 6.75c-2.068 0-3.75 1.514-3.75 3.375v.375a.75.75 0 1 0 1.5 0v-.375c0-1.031 1.01-1.875 2.25-1.875s2.25.844 2.25 1.875C14.25 11.156 13.24 12 12 12a.75.75 0 0 0-.75.75v.75a.75.75 0 1 0 1.5 0v-.068c1.71-.314 3-1.678 3-3.307 0-1.86-1.682-3.375-3.75-3.375zM21.75 12A9.75 9.75 0 1 1 12 2.25 9.76 9.76 0 0 1 21.75 12zm-1.5 0A8.25 8.25 0 1 0 12 20.25 8.26 8.26 0 0 0 20.25 12z",
    "data-ppui": "true"
  })), props.children);
};
var RainyDayIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded276);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "rainy day icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5 11.871A10.542 10.542 0 0 0 4.852 5.04a10.459 10.459 0 0 0-3.347 6.832A1.5 1.5 0 0 0 3 13.5h8.25v5.25a3 3 0 1 0 6 0 .75.75 0 1 0-1.5 0 1.5 1.5 0 0 1-3 0V13.5H21a1.5 1.5 0 0 0 1.5-1.629zM3 12a9.014 9.014 0 0 1 7.144-8.052C9.045 5.438 7.674 8.073 7.516 12H3zm6.014 0c.13-2.885.987-4.951 1.716-6.21A9.974 9.974 0 0 1 12 4.046a10 10 0 0 1 1.268 1.744c1.244 2.15 1.638 4.455 1.715 6.21H9.014zm7.467 0c-.157-3.927-1.529-6.563-2.625-8.057A9.007 9.007 0 0 1 21 12h-4.519z",
    "data-ppui": "true"
  })), props.children);
};
var RecurrentIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded277);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "recurrent icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.25 9.75h-4.5A.75.75 0 0 1 3 9V4.5a.75.75 0 1 1 1.5 0v2.69l1.372-1.372a8.947 8.947 0 0 1 6.316-2.636h.05a8.94 8.94 0 0 1 6.287 2.562.75.75 0 0 1-1.048 1.072 7.455 7.455 0 0 0-5.24-2.134h-.042a7.459 7.459 0 0 0-5.263 2.196L5.56 8.25h2.69a.75.75 0 1 1 0 1.5zm12 4.5h-4.5a.75.75 0 1 0 0 1.5h2.69l-1.372 1.371a7.459 7.459 0 0 1-5.262 2.197h-.042a7.455 7.455 0 0 1-5.24-2.135.751.751 0 0 0-1.286.542.75.75 0 0 0 .238.53 8.94 8.94 0 0 0 6.288 2.563h.049a8.946 8.946 0 0 0 6.315-2.636L19.5 16.81v2.69a.75.75 0 1 0 1.5 0V15a.75.75 0 0 0-.75-.75z",
    "data-ppui": "true"
  })), props.children);
};
var RecurringPausedIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded278);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "recurring paused icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.25 9.75h-4.5A.75.75 0 0 1 3 9V4.5a.75.75 0 0 1 1.5 0v2.69l1.372-1.372a8.944 8.944 0 0 1 2.439-1.74 7.68 7.68 0 0 1 1.819-.65 8.944 8.944 0 0 1 2.057-.246h.05a9.338 9.338 0 0 1 1.63.135.75.75 0 1 1-.252 1.478 8.046 8.046 0 0 0-3.068.076 7.461 7.461 0 0 0-1.576.554 3.035 3.035 0 0 0-.117.067l-.004-.006a7.456 7.456 0 0 0-1.918 1.392L5.56 8.25h2.69a.75.75 0 0 1 0 1.5zm12 4.5h-4.5a.75.75 0 1 0 0 1.5h2.69l-1.372 1.371a7.459 7.459 0 0 1-5.262 2.197h-.042a7.455 7.455 0 0 1-5.24-2.135.751.751 0 0 0-1.286.542.75.75 0 0 0 .238.53 8.94 8.94 0 0 0 6.288 2.563h.049a8.946 8.946 0 0 0 6.315-2.636L19.5 16.81v2.69a.75.75 0 1 0 1.5 0V15a.75.75 0 0 0-.75-.75zm-.75-7.5v4.5a.75.75 0 1 0 1.5 0v-4.5a.75.75 0 1 0-1.5 0zm-3.75 0v4.5a.75.75 0 1 0 1.5 0v-4.5a.75.75 0 1 0-1.5 0z",
    "data-ppui": "true"
  })), props.children);
};
var RefreshIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded279);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "refresh icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5 5.25v4.5a.75.75 0 0 1-.75.75h-4.5a.75.75 0 1 1 0-1.5h2.569l-2.493-2.284-.024-.022a7.5 7.5 0 1 0-.156 10.76.75.75 0 0 1 1.031 1.09A8.947 8.947 0 0 1 12 21h-.124a9 9 0 1 1 6.476-15.375L21 8.044V5.25a.75.75 0 1 1 1.5 0z",
    "data-ppui": "true"
  })), props.children);
};
var RefundIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded280);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "refund icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.307 5.037a.75.75 0 0 0 1.224.243l1.72-1.72v3.682l-.001.012c0 .412.334.746.746.746h4.076a.746.746 0 1 0 0-1.492H12.75V3.56l1.72 1.72a.75.75 0 0 0 1.06-1.061l-3-3a.749.749 0 0 0-1.06 0l-3 3a.75.75 0 0 0-.163.818z",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9.917 12.94a3.75 3.75 0 1 1 4.166 6.235 3.75 3.75 0 0 1-4.166-6.235zm.833 4.989a2.25 2.25 0 1 0 2.5-3.742 2.25 2.25 0 0 0-2.5 3.742z",
    clipRule: "evenodd",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M22.5 9.308h-21a.75.75 0 0 0-.75.75v12a.75.75 0 0 0 .75.75h21a.75.75 0 0 0 .75-.75v-12a.75.75 0 0 0-.75-.75zm-4.345 12H5.845a5.324 5.324 0 0 0-3.595-3.595v-3.31a5.324 5.324 0 0 0 3.595-3.595h12.31a5.324 5.324 0 0 0 3.595 3.595v3.31a5.324 5.324 0 0 0-3.595 3.595zm3.595-8.496a3.826 3.826 0 0 1-2.003-2.004h2.003v2.004zM4.253 10.808a3.826 3.826 0 0 1-2.003 2.004v-2.004h2.003zM2.25 19.305a3.826 3.826 0 0 1 2.003 2.003H2.25v-2.003zm17.497 2.003a3.826 3.826 0 0 1 2.003-2.003v2.003h-2.003z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};
var RegistrationDocIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded281);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "registration doc icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 12.75a.75.75 0 0 1-.75.75h-4.5a.75.75 0 1 1 0-1.5h4.5a.75.75 0 0 1 .75.75zM11.25 9h-4.5a.75.75 0 0 0 0 1.5h4.5a.75.75 0 1 0 0-1.5zm10.5 6.138V21a.75.75 0 0 1-1.125.656l-2.25-1.288-2.25 1.288A.75.75 0 0 1 15 21v-2.25H3.75a1.5 1.5 0 0 1-1.5-1.5v-12a1.5 1.5 0 0 1 1.5-1.5h16.5a1.5 1.5 0 0 1 1.5 1.5v2.862a4.865 4.865 0 0 1 0 7.026zM15 17.25v-2.112a4.875 4.875 0 0 1 5.25-8.013V5.25H3.75v12H15zm5.25-1.125a4.863 4.863 0 0 1-3.75 0v3.583l1.5-.859a.75.75 0 0 1 .744 0l1.5.86.006-3.584zm1.5-4.5a3.375 3.375 0 1 0-6.75 0 3.375 3.375 0 0 0 6.75 0z",
    "data-ppui": "true"
  })), props.children);
};
var ReloadPhonesIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded282);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "reload phones icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.943 13.037a.75.75 0 0 1-.162.243l-2.25 2.25a.75.75 0 0 1-1.062 0l-2.25-2.25a.75.75 0 1 1 1.062-1.06l.97.97V9a.75.75 0 1 1 1.5 0v4.19l.968-.97a.75.75 0 0 1 1.224.817z",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.5 1.5h9a2.25 2.25 0 0 1 2.25 2.25v16.5a2.25 2.25 0 0 1-2.25 2.25h-9a2.25 2.25 0 0 1-2.25-2.25V3.75A2.25 2.25 0 0 1 7.5 1.5zM17.25 6H6.75v12h10.5V6zm-.75-3h-9a.75.75 0 0 0-.75.75v.75h10.5v-.75A.75.75 0 0 0 16.5 3zm-9 18h9a.75.75 0 0 0 .75-.75v-.75H6.75v.75a.75.75 0 0 0 .75.75z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};
var RentIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded283);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "rent icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.332 12.905a.75.75 0 0 0-.53-1.28h-7.5a.75.75 0 1 0 0 1.5h7.5a.75.75 0 0 0 .53-.22zm-3 3a.75.75 0 0 0-.53-1.28h-4.5a.75.75 0 1 0 0 1.5h4.5a.75.75 0 0 0 .53-.22z",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M13.06 2.689l7.5 7.5A1.487 1.487 0 0 1 21 11.25v9a.75.75 0 0 1-.75.75H3.75a.75.75 0 0 1-.75-.75v-9a1.488 1.488 0 0 1 .44-1.061l7.5-7.5a1.5 1.5 0 0 1 2.12 0zM4.5 19.5h15v-8.25L12 3.75l-7.5 7.5v8.25z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};
var ReportProblemIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded284);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "report problem icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 6.75a.75.75 0 0 1 .75.75v5.25a.75.75 0 1 1-1.5 0V7.5a.75.75 0 0 1 .75-.75zm-1.125 9.375a1.125 1.125 0 1 0 2.25 0 1.125 1.125 0 0 0-2.25 0zM22.5 12a1.484 1.484 0 0 1-.438 1.057l-9.005 9.006a1.5 1.5 0 0 1-2.114 0l-9-9.006a1.5 1.5 0 0 1 0-2.115l9.004-9.005a1.5 1.5 0 0 1 2.115 0l9.005 9.005A1.486 1.486 0 0 1 22.5 12zM21 12l-9-9-9 9 9 9 9-9z",
    "data-ppui": "true"
  })), props.children);
};
var RequestCryptoIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded285);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "request crypto icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.47 3.718a.75.75 0 0 0 0 1.062l3 3a.749.749 0 0 0 1.06 0l3-3a.75.75 0 1 0-1.06-1.062l-1.72 1.72V1.75a.75.75 0 1 0-1.5 0v3.69L9.53 3.72a.75.75 0 0 0-1.06 0zm1.547 5.765c.44 0 .796.357.796.796v1.848h2.374V10.28a.796.796 0 0 1 1.591 0v1.848h1.849c.44 0 .795.356.795.796v1.533a.796.796 0 0 1-1.591 0v-.737H8.169v5.018h7.662V17.7a.796.796 0 0 1 1.591 0v1.832a.795.795 0 0 1-.795.795h-1.848v1.848a.796.796 0 1 1-1.592 0v-1.848h-2.374v1.848a.796.796 0 0 1-1.592 0v-1.848H7.373a.796.796 0 0 1-.795-.795v-6.61c0-.44.356-.796.795-.796h1.848V10.28c0-.44.357-.796.796-.796z",
    "data-ppui": "true"
  })), props.children);
};
var RequestMoneyIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded286);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "request money icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.307 3.962a.75.75 0 0 1 1.224-.244l1.72 1.72V1.75a.75.75 0 1 1 1.5 0v3.69l1.719-1.72a.75.75 0 1 1 1.06 1.06l-3 3a.75.75 0 0 1-1.06 0l-3-3a.75.75 0 0 1-.163-.817z",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9.917 12.94a3.75 3.75 0 1 1 4.166 6.235 3.75 3.75 0 0 1-4.166-6.235zm.833 4.989a2.25 2.25 0 1 0 2.5-3.742 2.25 2.25 0 0 0-2.5 3.742z",
    clipRule: "evenodd",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M1.5 9.308h21a.75.75 0 0 1 .75.75v12a.75.75 0 0 1-.75.75h-21a.75.75 0 0 1-.75-.75v-12a.75.75 0 0 1 .75-.75zm4.345 12h12.31a5.324 5.324 0 0 1 3.595-3.595v-3.31a5.324 5.324 0 0 1-3.595-3.595H5.845a5.324 5.324 0 0 1-3.595 3.595v3.31a5.324 5.324 0 0 1 3.595 3.595zm13.902-10.5a3.826 3.826 0 0 0 2.003 2.004v-2.004h-2.003zM2.25 12.812a3.826 3.826 0 0 0 2.003-2.004H2.25v2.004zm2.003 8.496a3.826 3.826 0 0 0-2.003-2.003v2.003h2.003zm17.497-2.003a3.826 3.826 0 0 0-2.003 2.003h2.003v-2.003z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};
var ResolutionIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded287);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "resolution icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.84 10.116L21.449 5.33a1.5 1.5 0 0 0-2.013-.67l-2.331 1.165-4.912-1.299a.763.763 0 0 0-.384 0l-4.912 1.3L4.566 4.66a1.5 1.5 0 0 0-2.013.67L.159 10.115a1.5 1.5 0 0 0 .67 2.013l2.532 1.267 5.202 3.715a.756.756 0 0 0 .254.117l6 1.5a.75.75 0 0 0 .713-.197l5.162-5.163 2.477-1.239a1.5 1.5 0 0 0 .67-2.012h.002zm-5.145 3.129l-3.226-2.584a.75.75 0 0 0-1.002.057c-1.67 1.682-3.53 1.47-4.717.72L13.804 7.5h2.982l2.55 5.1-.641.645zM3.893 6l1.92.958-2.398 4.786-1.915-.957L3.893 6zm10.875 11.168l-5.447-1.361-4.613-3.294 2.625-5.25L12 6.026l.919.243L8.7 10.364l-.007.008a1.5 1.5 0 0 0 .255 2.326c1.927 1.231 4.253 1.031 6.085-.469l2.592 2.083-2.857 2.856zm5.813-5.425l-2.392-4.781L20.107 6l2.393 4.787-1.919.956zm-8.227 8.688a.75.75 0 0 1-.909.545L7.538 20a.742.742 0 0 1-.254-.118l-2.47-1.764a.75.75 0 0 1 .872-1.219l2.354 1.682 3.773.941a.75.75 0 0 1 .545.91l-.004-.001z",
    "data-ppui": "true"
  })), props.children);
};
var RetirementIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded288);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "retirement icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.293 4.99a6.268 6.268 0 0 0-9.163 0A6.77 6.77 0 0 0 12 6.584a6.77 6.77 0 0 0-1.125-1.594 6.268 6.268 0 0 0-9.163 0 .75.75 0 0 0 .244 1.205L7.219 8.49a6.696 6.696 0 0 0-4.065 3.114 6.622 6.622 0 0 0-.675 5.092.75.75 0 0 0 1.177.401l7.594-5.782V21a.75.75 0 1 0 1.5 0v-9.686l7.594 5.782a.75.75 0 0 0 1.178-.4 6.623 6.623 0 0 0-.675-5.093 6.695 6.695 0 0 0-4.066-3.114l5.27-2.294a.75.75 0 0 0 .245-1.205h-.003zM6.289 4.5a4.793 4.793 0 0 1 3.495 1.524A5.3 5.3 0 0 1 11.12 8.55L3.656 5.3a4.734 4.734 0 0 1 2.634-.8zM3.75 15.14a5.139 5.139 0 0 1 .7-2.784A5.208 5.208 0 0 1 7.638 9.93a5.299 5.299 0 0 1 2.893.047L3.75 15.141zm15.797-2.784c.494.843.738 1.809.703 2.785l-6.778-5.166a5.278 5.278 0 0 1 6.078 2.381h-.003zM12.879 8.55a5.3 5.3 0 0 1 1.337-2.525A4.794 4.794 0 0 1 17.711 4.5c.938 0 1.854.279 2.633.8l-7.465 3.25z",
    "data-ppui": "true"
  })), props.children);
};
var ReturnRightIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded289);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "return right icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.97 12.22L19.19 9H8.25a4.5 4.5 0 0 0 0 9h8.25a.75.75 0 1 1 0 1.5H8.25a6 6 0 1 1 0-12h10.94l-3.22-3.22a.75.75 0 1 1 1.06-1.06l4.5 4.5a.748.748 0 0 1 0 1.06l-4.5 4.5a.75.75 0 0 1-1.06-1.06z",
    "data-ppui": "true"
  })), props.children);
};
var RewardsIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded290);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "rewards icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.25 6.75h-3.289c.037-.031.074-.061.11-.094A2.768 2.768 0 0 0 18 4.647 3.057 3.057 0 0 0 14.854 1.5a2.769 2.769 0 0 0-2.01.929A5.15 5.15 0 0 0 12 3.786a5.15 5.15 0 0 0-.844-1.357 2.768 2.768 0 0 0-2.01-.93A3.058 3.058 0 0 0 6 4.648a2.768 2.768 0 0 0 .93 2.01c.035.03.072.06.109.093H3.75a1.5 1.5 0 0 0-1.5 1.5v3a1.5 1.5 0 0 0 1.5 1.5v6a1.5 1.5 0 0 0 1.5 1.5h13.5a1.5 1.5 0 0 0 1.5-1.5v-6a1.5 1.5 0 0 0 1.5-1.5v-3a1.5 1.5 0 0 0-1.5-1.5zm-6.281-3.327A1.283 1.283 0 0 1 14.906 3h.046A1.559 1.559 0 0 1 16.5 4.6a1.283 1.283 0 0 1-.422.938c-.89.787-2.366 1.065-3.281 1.162.112-.993.422-2.436 1.172-3.278zm-6.009.033A1.56 1.56 0 0 1 9.055 3h.046a1.284 1.284 0 0 1 .938.422c.786.888 1.064 2.362 1.161 3.273-.91-.093-2.385-.375-3.273-1.161a1.284 1.284 0 0 1-.422-.938 1.556 1.556 0 0 1 .452-1.14h.003zM3.75 8.25h7.5v3h-7.5v-3zm1.5 4.5h6v6h-6v-6zm13.5 6h-6v-6h6v6zm1.5-7.5h-7.5v-3h7.5v3z",
    "data-ppui": "true"
  })), props.children);
};
var RightAlignIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded291);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "right align icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 6a.75.75 0 0 1 .75-.75h16.5a.75.75 0 1 1 0 1.5H3.75A.75.75 0 0 1 3 6zm17.25 3h-12a.75.75 0 0 0 0 1.5h12a.75.75 0 1 0 0-1.5zm0 3.75H3.75a.75.75 0 1 0 0 1.5h16.5a.75.75 0 1 0 0-1.5zm0 3.75h-12a.75.75 0 1 0 0 1.5h12a.75.75 0 1 0 0-1.5z",
    "data-ppui": "true"
  })), props.children);
};
var SafariIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded292);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "safari icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 2.25A9.75 9.75 0 1 0 21.75 12 9.76 9.76 0 0 0 12 2.25zm0 18A8.25 8.25 0 1 1 20.25 12 8.26 8.26 0 0 1 12 20.25zm4.164-13.421l-6 3a.754.754 0 0 0-.335.335l-3 6a.75.75 0 0 0 1.007 1.007l6-3a.755.755 0 0 0 .335-.335l3-6a.75.75 0 0 0-1.007-1.007zm-3.227 6.109l-3.76 1.885 1.886-3.76 3.764-1.882-1.89 3.757z",
    "data-ppui": "true"
  })), props.children);
};
var SavingsIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded293);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "savings icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.25 3.75H3.75a1.5 1.5 0 0 0-1.5 1.5V18a1.5 1.5 0 0 0 1.5 1.5h1.5V21a.75.75 0 1 0 1.5 0v-1.5h10.5V21a.75.75 0 1 0 1.5 0v-1.5h1.5a1.5 1.5 0 0 0 1.5-1.5V5.25a1.5 1.5 0 0 0-1.5-1.5zm0 14.25H3.75V5.25h16.5v6h-1.564a4.5 4.5 0 1 0 0 1.5h1.564V18zm-4.703-6.75a1.5 1.5 0 1 0 0 1.5h1.61a3 3 0 1 1 0-1.5h-1.61z",
    "data-ppui": "true"
  })), props.children);
};
var ScanBarcodeIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded294);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "scan barcode icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.75 4.5v3.75a.75.75 0 1 1-1.5 0v-3h-3a.75.75 0 1 1 0-1.5H21a.75.75 0 0 1 .75.75zm-15 14.25h-3v-3a.75.75 0 1 0-1.5 0v3.75a.75.75 0 0 0 .75.75h3.75a.75.75 0 1 0 0-1.5zM21 15a.75.75 0 0 0-.75.75v3h-3a.75.75 0 1 0 0 1.5H21a.75.75 0 0 0 .75-.75v-3.75A.75.75 0 0 0 21 15zM3 9a.75.75 0 0 0 .75-.75v-3h3a.75.75 0 0 0 0-1.5H3a.75.75 0 0 0-.75.75v3.75A.75.75 0 0 0 3 9zm4.5-1.5a.75.75 0 0 0-.75.75v7.5a.75.75 0 1 0 1.5 0v-7.5a.75.75 0 0 0-.75-.75zm9.75 8.25v-7.5a.75.75 0 1 0-1.5 0v7.5a.75.75 0 1 0 1.5 0zM13.5 7.5a.75.75 0 0 0-.75.75v7.5a.75.75 0 1 0 1.5 0v-7.5a.75.75 0 0 0-.75-.75zm-3 0a.75.75 0 0 0-.75.75v7.5a.75.75 0 1 0 1.5 0v-7.5a.75.75 0 0 0-.75-.75z",
    "data-ppui": "true"
  })), props.children);
};
var ScanIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded295);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "scan icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 3.75V7.5a.75.75 0 1 1-1.5 0v-3h-3a.75.75 0 1 1 0-1.5h3.75a.75.75 0 0 1 .75.75zM7.5 19.5h-3v-3a.75.75 0 1 0-1.5 0v3.75a.75.75 0 0 0 .75.75H7.5a.75.75 0 1 0 0-1.5zm12.75-3.75a.75.75 0 0 0-.75.75v3h-3a.75.75 0 1 0 0 1.5h3.75a.75.75 0 0 0 .75-.75V16.5a.75.75 0 0 0-.75-.75zm-16.5-7.5a.75.75 0 0 0 .75-.75v-3h3a.75.75 0 0 0 0-1.5H3.75a.75.75 0 0 0-.75.75V7.5a.75.75 0 0 0 .75.75zm3.75-1.5h9a.75.75 0 0 1 .75.75v9a.75.75 0 0 1-.75.75h-9a.75.75 0 0 1-.75-.75v-9a.75.75 0 0 1 .75-.75zm.75 9h7.5v-7.5h-7.5v7.5z",
    "data-ppui": "true"
  })), props.children);
};
var ScienceIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded296);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "science icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.784 18.728L15 9.086V3.75h.75a.75.75 0 0 0 0-1.5h-7.5a.75.75 0 0 0 0 1.5H9v5.336l-5.783 9.642A1.5 1.5 0 0 0 4.5 21h15a1.5 1.5 0 0 0 1.286-2.272h-.003zM10.393 9.68a.742.742 0 0 0 .106-.386V3.75h3v5.544c0 .136.037.27.107.386l3.583 5.976c-1.125.222-2.725.129-4.852-.948-1.491-.754-2.91-1.155-4.239-1.2l2.294-3.828zM4.5 19.5l2.676-4.46c1.336-.164 2.841.173 4.483 1.004 1.781.901 3.281 1.208 4.5 1.208a6.555 6.555 0 0 0 1.833-.253L19.5 19.5h-15z",
    "data-ppui": "true"
  })), props.children);
};
var SearchSmIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded297);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "search sm icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 18 18",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16.455 15.458a.763.763 0 0 0-.166-.247l-3.393-3.393a6.395 6.395 0 1 0-1.078 1.078l3.393 3.394a.766.766 0 0 0 1.078 0 .762.762 0 0 0 .166-.832zM3.013 7.875a4.862 4.862 0 1 1 9.724 0 4.862 4.862 0 0 1-9.724 0z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};
var SearchIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded298);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "search icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.53 20.47l-4.694-4.693a8.26 8.26 0 1 0-1.06 1.06l4.693 4.694a.75.75 0 0 0 1.062-1.061zM3.75 10.5a6.75 6.75 0 1 1 6.75 6.75 6.758 6.758 0 0 1-6.75-6.75z",
    "data-ppui": "true"
  })), props.children);
};
var SecurityIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded299);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "security icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5 3.75h-15A1.5 1.5 0 0 0 3 5.25v5.25c0 4.943 2.393 7.938 4.4 9.58 2.162 1.768 4.312 2.37 4.406 2.394a.752.752 0 0 0 .394 0c.093-.025 2.241-.626 4.406-2.394C18.608 18.438 21 15.443 21 10.5V5.25a1.5 1.5 0 0 0-1.5-1.5zm0 6.75c0 3.475-1.28 6.296-3.806 8.383A12.12 12.12 0 0 1 12 20.964a12.024 12.024 0 0 1-3.649-2.044C5.796 16.83 4.5 13.997 4.5 10.5V5.25h15v5.25z",
    "data-ppui": "true"
  })), props.children);
};
var SendMoneyIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded300);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "send money icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.307 5.037a.75.75 0 0 0 1.224.243l1.72-1.72v3.69a.75.75 0 1 0 1.5 0V3.56l1.719 1.72a.75.75 0 0 0 1.06-1.061l-3-3a.749.749 0 0 0-1.06 0l-3 3a.75.75 0 0 0-.163.818z",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9.917 12.94a3.75 3.75 0 1 1 4.166 6.235 3.75 3.75 0 0 1-4.166-6.235zm.833 4.989a2.25 2.25 0 1 0 2.5-3.742 2.25 2.25 0 0 0-2.5 3.742z",
    clipRule: "evenodd",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M1.5 9.308h21a.75.75 0 0 1 .75.75v12a.75.75 0 0 1-.75.75h-21a.75.75 0 0 1-.75-.75v-12a.75.75 0 0 1 .75-.75zm4.345 12h12.31a5.324 5.324 0 0 1 3.595-3.595v-3.31a5.324 5.324 0 0 1-3.595-3.595H5.845a5.324 5.324 0 0 1-3.595 3.595v3.31a5.324 5.324 0 0 1 3.595 3.595zm13.902-10.5a3.826 3.826 0 0 0 2.003 2.004v-2.004h-2.003zM2.25 12.812a3.826 3.826 0 0 0 2.003-2.004H2.25v2.004zm2.003 8.496a3.826 3.826 0 0 0-2.003-2.003v2.003h2.003zm17.497-2.003a3.826 3.826 0 0 0-2.003 2.003h2.003v-2.003z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};
var SendRequestIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded301);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "send request icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.03 15.97a.748.748 0 0 1 0 1.06l-3 3a.748.748 0 0 1-1.06 0l-3-3a.751.751 0 0 1 1.06-1.06l1.72 1.72V4.5a.75.75 0 0 1 1.5 0v13.19l1.72-1.72a.75.75 0 0 1 1.06 0zm9-9l-3-3a.75.75 0 0 0-1.06 0l-3 3a.75.75 0 0 0 1.06 1.06l1.72-1.72V19.5a.75.75 0 1 0 1.5 0V6.31l1.72 1.72a.75.75 0 1 0 1.06-1.06z",
    "data-ppui": "true"
  })), props.children);
};
var SendToBankIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded302);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "send to bank icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.311 2.689a1.5 1.5 0 0 0-1.468-.383h-.014L1.835 7.766A1.5 1.5 0 0 0 1.6 10.56l7.961 3.877 3.872 7.957a1.487 1.487 0 0 0 1.484.85 1.489 1.489 0 0 0 1.312-1.079l5.456-17.994v-.014a1.5 1.5 0 0 0-.375-1.468zm-6.514 19.047l-.005.013v-.007l-3.756-7.715 4.5-4.5a.75.75 0 0 0-1.06-1.06l-4.5 4.5L2.257 9.21h-.006.013L20.25 3.75l-5.454 17.986z",
    "data-ppui": "true"
  })), props.children);
};
var ServicesIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded303);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "services icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M20.862 6.06l.437.253a.75.75 0 1 1-.75 1.3l-.438-.254c-.21.18-.45.32-.71.412v.504a.75.75 0 1 1-1.5 0V7.77a2.242 2.242 0 0 1-.71-.412l-.439.253a.75.75 0 0 1-.75-1.3l.437-.251a2.21 2.21 0 0 1 0-.822l-.437-.252a.75.75 0 0 1 .75-1.3l.438.254c.21-.18.45-.32.71-.412v-.504a.75.75 0 1 1 1.5 0v.504c.261.093.502.232.711.412l.438-.253a.75.75 0 0 1 .75 1.3l-.437.251c.052.272.052.55 0 .822zm-2.835-.827a.75.75 0 1 0 1.248.834.75.75 0 0 0-1.248-.834zm2.617 7.56c.346.07.67.217.95.431h.003a2.306 2.306 0 0 1-.368 3.897l-.041.018-3.644 1.551a.688.688 0 0 1-.112.037l-6 1.5a.744.744 0 0 1-.182.023H1.5a1.5 1.5 0 0 1-1.5-1.5V15a1.5 1.5 0 0 1 1.5-1.5h2.69l2.12-2.122a2.984 2.984 0 0 1 2.122-.878h4.693a2.625 2.625 0 0 1 2.555 3.23l3.922-.902a2.29 2.29 0 0 1 1.042-.035zM1.5 18.75h2.25V15H1.5v3.75zm15.51-1.463l3.562-1.517h-.003a.807.807 0 0 0-.59-1.49l-.03.007-6.281 1.444a.782.782 0 0 1-.168.019h-3a.75.75 0 1 1 0-1.5h2.625a1.125 1.125 0 1 0 0-2.25H8.432a1.487 1.487 0 0 0-1.06.44L5.25 14.56v4.19h5.906l5.853-1.463z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};
var SettingsIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded304);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "settings icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 7.5a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9zm0 7.5a3 3 0 1 1 0-6 3 3 0 0 1 0 6zm8.25-2.797a7.39 7.39 0 0 0 0-.405l1.399-1.748a.749.749 0 0 0 .139-.662 10.05 10.05 0 0 0-1.02-2.46.75.75 0 0 0-.563-.37l-2.224-.247a7.458 7.458 0 0 0-.281-.281l-.262-2.23a.75.75 0 0 0-.37-.562c-.772-.447-1.6-.79-2.46-1.019a.75.75 0 0 0-.663.14L12.203 3.75h-.405L10.05 2.354a.75.75 0 0 0-.662-.139c-.862.23-1.69.573-2.46 1.02a.75.75 0 0 0-.37.563l-.247 2.227a8.514 8.514 0 0 0-.281.282l-2.23.256a.75.75 0 0 0-.562.369c-.447.772-.79 1.6-1.019 2.46a.75.75 0 0 0 .14.663l1.391 1.742v.405L2.354 13.95a.75.75 0 0 0-.139.662c.23.862.573 1.69 1.02 2.46a.75.75 0 0 0 .563.37l2.224.247c.093.097.186.191.28.281l.26 2.23a.75.75 0 0 0 .37.562c.772.447 1.6.79 2.46 1.019a.75.75 0 0 0 .663-.14l1.742-1.391c.135.004.27.004.405 0l1.748 1.399a.75.75 0 0 0 .662.139 10.05 10.05 0 0 0 2.46-1.02.75.75 0 0 0 .37-.563l.247-2.224c.097-.092.191-.186.281-.281l2.23-.262a.75.75 0 0 0 .562-.37 10.1 10.1 0 0 0 1.019-2.46.749.749 0 0 0-.14-.663l-1.391-1.742zm-1.51-.61c.017.271.017.543 0 .814a.75.75 0 0 0 .164.514l1.33 1.662a8.585 8.585 0 0 1-.584 1.406l-2.119.24a.75.75 0 0 0-.478.248c-.18.203-.373.395-.576.575a.75.75 0 0 0-.247.478l-.235 2.117c-.45.236-.921.432-1.407.584l-1.663-1.33a.75.75 0 0 0-.469-.164h-.044a6.903 6.903 0 0 1-.814 0 .75.75 0 0 0-.514.163l-1.667 1.331a8.585 8.585 0 0 1-1.406-.584l-.24-2.116a.75.75 0 0 0-.248-.478 6.949 6.949 0 0 1-.575-.576.75.75 0 0 0-.478-.247l-2.117-.236a8.561 8.561 0 0 1-.584-1.406l1.33-1.664a.75.75 0 0 0 .163-.513 6.93 6.93 0 0 1 0-.814.75.75 0 0 0-.163-.514l-1.33-1.666c.152-.485.348-.956.584-1.406l2.116-.24a.75.75 0 0 0 .478-.248 7.09 7.09 0 0 1 .575-.575.75.75 0 0 0 .249-.48l.235-2.115c.45-.236.921-.432 1.406-.584l1.664 1.33a.75.75 0 0 0 .513.163c.271-.016.543-.016.814 0a.75.75 0 0 0 .514-.163l1.666-1.33c.485.152.956.348 1.406.584l.24 2.116a.75.75 0 0 0 .248.478c.203.18.395.373.575.576a.75.75 0 0 0 .478.247l2.117.235c.236.45.432.921.584 1.407l-1.33 1.663a.75.75 0 0 0-.163.518h.003z",
    "data-ppui": "true"
  })), props.children);
};
var SewingIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded305);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "sewing icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.78 6.22a.75.75 0 0 1 0 1.06l-1.5 1.5a.75.75 0 1 1-1.06-1.06l1.5-1.5a.749.749 0 0 1 1.06 0zm3.22.53a3.723 3.723 0 0 1-1.099 2.651l-2.25 2.25a.75.75 0 0 1-.403.21c-4.827.828-12.887 8.838-12.967 8.92a.75.75 0 1 1-1.06-1.061c.154-.151 8.094-8.162 8.919-12.97a.75.75 0 0 1 .209-.403l2.25-2.25A3.75 3.75 0 0 1 21 6.75zm-1.5 0a2.25 2.25 0 0 0-3.844-1.594l-2.084 2.09c-.413 1.983-1.772 4.33-3.327 6.51 2.179-1.556 4.526-2.915 6.509-3.328l2.09-2.084A2.237 2.237 0 0 0 19.5 6.75z",
    "data-ppui": "true"
  })), props.children);
};
var ShareAndroidIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded306);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "share android icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5 15a3.74 3.74 0 0 0-2.683 1.134l-4.322-2.778c.34-.872.34-1.84 0-2.712l4.322-2.777a3.75 3.75 0 1 0-.812-1.261L8.683 9.384a3.75 3.75 0 1 0 0 5.233l4.322 2.777A3.75 3.75 0 1 0 16.5 15zm0-12a2.25 2.25 0 1 1 0 4.5 2.25 2.25 0 0 1 0-4.5zM6 14.25a2.25 2.25 0 1 1 0-4.5 2.25 2.25 0 0 1 0 4.5zM16.5 21a2.25 2.25 0 1 1 0-4.501 2.25 2.25 0 0 1 0 4.501z",
    "data-ppui": "true"
  })), props.children);
};
var ShareFacebookIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded307);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "share facebook icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 2.25A9.75 9.75 0 1 0 21.75 12 9.76 9.76 0 0 0 12 2.25zm.75 17.965V14.25H15a.75.75 0 1 0 0-1.5h-2.25V10.5a1.5 1.5 0 0 1 1.5-1.5h1.5a.75.75 0 1 0 0-1.5h-1.5a3 3 0 0 0-3 3v2.25H9a.75.75 0 1 0 0 1.5h2.25v5.965a8.25 8.25 0 1 1 1.5 0z",
    "data-ppui": "true"
  })), props.children);
};
var ShareInstagramIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded308);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "share instagram icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 7.5a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9zm0 7.5a3 3 0 1 1 0-5.999A3 3 0 0 1 12 15zm4.5-12.75h-9A5.256 5.256 0 0 0 2.25 7.5v9a5.256 5.256 0 0 0 5.25 5.25h9a5.256 5.256 0 0 0 5.25-5.25v-9a5.256 5.256 0 0 0-5.25-5.25zm3.75 14.25a3.75 3.75 0 0 1-3.75 3.75h-9a3.75 3.75 0 0 1-3.75-3.75v-9A3.75 3.75 0 0 1 7.5 3.75h9a3.75 3.75 0 0 1 3.75 3.75v9zM18 7.125a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0z",
    "data-ppui": "true"
  })), props.children);
};
var ShareIosIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded309);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "share ios icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.25 10.5v9a1.5 1.5 0 0 1-1.5 1.5H5.25a1.5 1.5 0 0 1-1.5-1.5v-9A1.5 1.5 0 0 1 5.25 9H7.5a.75.75 0 0 1 0 1.5H5.25v9h13.5v-9H16.5a.75.75 0 1 1 0-1.5h2.25a1.5 1.5 0 0 1 1.5 1.5zM8.78 6.53l2.47-2.47v8.69a.75.75 0 1 0 1.5 0V4.06l2.47 2.47a.75.75 0 1 0 1.06-1.06l-3.75-3.75a.749.749 0 0 0-1.06 0L7.72 5.47a.75.75 0 1 0 1.06 1.06z",
    "data-ppui": "true"
  })), props.children);
};
var ShareLineIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded310);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "share line icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.379 9.321a.55.55 0 1 0-1.101 0v3.041c0 .304.246.55.55.55h1.503a.55.55 0 1 0 0-1.1h-.952v-2.49zm2.583-.551a.55.55 0 0 1 .552.55l.008 3.033a.55.55 0 1 1-1.1.003l-.01-3.033a.55.55 0 0 1 .55-.552zm2.078.24a.55.55 0 0 0-.987.337v3.008a.55.55 0 1 0 1.101 0v-1.39l1.329 1.725a.55.55 0 0 0 .987-.335V9.346a.55.55 0 1 0-1.101 0v1.39L12.04 9.01zm2.96.337a.55.55 0 0 1 .551-.55h1.62a.55.55 0 1 1 0 1.1h-1.07v.429h.994a.55.55 0 1 1 0 1.1h-.993v.428h1.07a.55.55 0 1 1 0 1.101h-1.62a.55.55 0 0 1-.551-.55V9.347z",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11.908 2.795c-5.178 0-9.658 3.426-9.658 7.963 0 4.052 3.582 7.223 8.022 7.85v1.461c0 .723.713 1.374 1.518 1.059 1.666-.653 4.87-2.588 7.103-4.865 1.633-1.408 2.673-3.341 2.673-5.505 0-4.537-4.48-7.963-9.658-7.963zM3.75 10.758c0-3.429 3.497-6.463 8.158-6.463s8.158 3.034 8.158 6.463c0 1.666-.801 3.213-2.174 4.388a.76.76 0 0 0-.05.046c-1.857 1.902-4.478 3.563-6.07 4.31v-1.566a.75.75 0 0 0-.69-.747c-4.255-.34-7.332-3.207-7.332-6.43z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};
var ShareLinkedinIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded311);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "share linkedin icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.25 2.25H3.75a1.5 1.5 0 0 0-1.5 1.5v16.5a1.5 1.5 0 0 0 1.5 1.5h16.5a1.5 1.5 0 0 0 1.5-1.5V3.75a1.5 1.5 0 0 0-1.5-1.5zm0 18H3.75V3.75h16.5v16.5zM9 10.5v6a.75.75 0 1 1-1.5 0v-6a.75.75 0 1 1 1.5 0zm8.25 2.625V16.5a.75.75 0 1 1-1.5 0v-3.375a1.875 1.875 0 1 0-3.75 0V16.5a.75.75 0 1 1-1.5 0v-6a.75.75 0 0 1 1.48-.167 3.375 3.375 0 0 1 5.27 2.792zm-7.875-5.25a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0z",
    "data-ppui": "true"
  })), props.children);
};
var ShareMessengerIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded312);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "share messenger icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.03 9.97a.748.748 0 0 1 0 1.06l-3 3a.747.747 0 0 1-1.06 0l-2.47-2.47-2.47 2.47a.75.75 0 1 1-1.06-1.06l3-3a.75.75 0 0 1 1.06 0l2.47 2.47 2.47-2.47a.749.749 0 0 1 1.06 0zM21.75 12a9.75 9.75 0 0 1-14.332 8.608l-3.193 1.064a1.5 1.5 0 0 1-1.897-1.897l1.064-3.193A9.75 9.75 0 1 1 21.75 12zm-1.5 0a8.25 8.25 0 1 0-15.393 4.13.75.75 0 0 1 .062.614L3.75 20.25l3.506-1.17a.75.75 0 0 1 .613.063A8.25 8.25 0 0 0 20.25 12z",
    "data-ppui": "true"
  })), props.children);
};
var ShareSnapchatIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded313);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "share snapchat icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.234 17.089a.751.751 0 0 0-.48-.553c-.037-.014-2.715-1.02-4.032-4.616l1.81-.723a.752.752 0 0 0-.563-1.394l-1.67.669A13.97 13.97 0 0 1 18 7.5a6 6 0 1 0-12 0c.006 1-.094 1.998-.298 2.977l-1.67-.674a.751.751 0 1 0-.563 1.394l1.816.726c-.372 1.04-.937 2-1.663 2.831-1.174 1.326-2.37 1.782-2.378 1.782a.75.75 0 0 0-.26 1.252c.666.625 1.657.723 2.614.818.592.058 1.203.119 1.537.302.316.175.642.621.957 1.052.506.695 1.08 1.482 1.991 1.714.85.218 1.72-.078 2.488-.34.52-.177 1.013-.344 1.426-.344.414 0 .906.168 1.426.345.581.197 1.219.415 1.866.415.21.001.419-.024.622-.076.91-.232 1.484-1.019 1.99-1.714.316-.43.642-.877.958-1.052.333-.187.945-.244 1.536-.302.957-.094 1.948-.193 2.614-.818a.75.75 0 0 0 .225-.7zm-2.983.024c-.742.073-1.508.15-2.112.481-.605.332-1.031.918-1.445 1.482-.375.514-.764 1.046-1.151 1.145-.418.108-1.009-.094-1.633-.307-.625-.212-1.248-.424-1.91-.424-.662 0-1.296.215-1.91.424-.613.21-1.218.415-1.633.307-.387-.099-.775-.631-1.151-1.145-.412-.562-.837-1.147-1.445-1.482-.607-.335-1.37-.408-2.111-.48a26.616 26.616 0 0 1-.444-.047c.5-.367.961-.785 1.377-1.246.785-.869 1.661-2.178 2.225-4.043l.006-.012c.02-.05.034-.1.043-.151.373-1.34.555-2.725.543-4.115a4.5 4.5 0 0 1 9 0c-.012 1.391.17 2.777.544 4.117.01.052.024.103.043.151l.006.013c.562 1.865 1.44 3.174 2.225 4.043a9.13 9.13 0 0 0 1.377 1.246c-.149.014-.298.03-.445.043z",
    "data-ppui": "true"
  })), props.children);
};
var ShareTwitterIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded314);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "share twitter icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.133 19.848l-5.869-9.223 5.791-6.37a.75.75 0 0 0-1.11-1.01l-5.516 6.068-3.796-5.965A.75.75 0 0 0 9 3H4.5a.75.75 0 0 0-.633 1.153l5.869 9.222-5.791 6.375a.75.75 0 1 0 1.11 1.01l5.516-6.068 3.796 5.965A.75.75 0 0 0 15 21h4.5a.75.75 0 0 0 .633-1.152zm-4.721-.348l-9.546-15h2.719l9.55 15h-2.723z",
    "data-ppui": "true"
  })), props.children);
};
var ShareWechatIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded315);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "share wechat icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5 13.125a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0zM17.625 12a1.125 1.125 0 1 0 0 2.25 1.125 1.125 0 0 0 0-2.25zm4.813 7.826a1.5 1.5 0 0 1-1.863 1.862l-2.316-.681a7.5 7.5 0 0 1-10.156-3.811 7.409 7.409 0 0 1-2.362-.69l-2.316.682a1.5 1.5 0 0 1-1.863-1.862l.681-2.317a7.5 7.5 0 1 1 13.655-6.203 7.5 7.5 0 0 1 5.859 10.703l.681 2.317zM7.622 15.59a7.494 7.494 0 0 1 6.598-8.8A6.002 6.002 0 0 0 3.2 8.016a6 6 0 0 0 .508 4.565.75.75 0 0 1 .059.562L3 15.75l2.603-.766a.75.75 0 0 1 .562.06c.46.245.95.429 1.457.547zm12.67 1.49a6 6 0 1 0-2.462 2.461.75.75 0 0 1 .563-.059L21 20.25l-.766-2.602a.75.75 0 0 1 .058-.567z",
    "data-ppui": "true"
  })), props.children);
};
var ShareWhatsappIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded316);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "share whatsapp icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.586 13.579l-3-1.5a.75.75 0 0 0-.75.047l-1.377.918a3.802 3.802 0 0 1-1.5-1.5l.918-1.377a.75.75 0 0 0 .047-.75l-1.5-3A.75.75 0 0 0 9.75 6 3.75 3.75 0 0 0 6 9.75 8.26 8.26 0 0 0 14.25 18 3.75 3.75 0 0 0 18 14.25a.75.75 0 0 0-.414-.671zM14.25 16.5A6.758 6.758 0 0 1 7.5 9.75a2.25 2.25 0 0 1 1.808-2.207L10.385 9.7l-.916 1.364a.75.75 0 0 0-.069.704 5.294 5.294 0 0 0 2.827 2.826.75.75 0 0 0 .71-.062l1.37-.913 2.156 1.076A2.25 2.25 0 0 1 14.25 16.5zM12 2.25a9.75 9.75 0 0 0-8.608 14.332l-1.064 3.193a1.5 1.5 0 0 0 1.897 1.897l3.193-1.064A9.75 9.75 0 1 0 12 2.25zm0 18a8.237 8.237 0 0 1-4.13-1.107.75.75 0 0 0-.614-.063L3.75 20.25l1.17-3.506a.75.75 0 0 0-.063-.613A8.25 8.25 0 1 1 12 20.25z",
    "data-ppui": "true"
  })), props.children);
};
var ShareIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded317);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "share icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.53 10.28l-4.5 4.5a.75.75 0 0 1-1.06-1.06l3.22-3.22h-3.721a8.25 8.25 0 0 0-7.99 6.187.75.75 0 1 1-1.454-.375A9.744 9.744 0 0 1 15.47 9h3.723L15.97 5.78a.75.75 0 1 1 1.062-1.06l4.5 4.5a.748.748 0 0 1 0 1.06zM18 19.5H3.75V8.25a.75.75 0 0 0-1.5 0v12A.75.75 0 0 0 3 21h15a.75.75 0 1 0 0-1.5z",
    "data-ppui": "true"
  })), props.children);
};
var ShippingLabelIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded318);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "shipping label icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M19.421 3.414l1.5 3c.052.105.079.22.079.336V19.5a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 3 19.5V6.75c0-.116.027-.231.079-.336l1.5-3A.75.75 0 0 1 5.25 3h13.5a.75.75 0 0 1 .671.414zM18.287 4.5H5.713L4.963 6h14.074l-.75-1.5zM4.5 19.5h15v-12h-3.752v8.277a.75.75 0 0 1-1.2.6l-2.55-1.913-2.55 1.913a.75.75 0 0 1-1.2-.6V7.5H4.5v12zm5.248-12v6.777l1.799-1.35a.75.75 0 0 1 .9 0l1.8 1.35V7.5h-4.5z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};
var ShippingPackIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded319);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "shipping pack icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.22 7.465l2.25 2.25a.751.751 0 0 0 .53.22.75.75 0 0 0 .53-.22l2.25-2.25a.75.75 0 1 0-1.06-1.061l-.97.97V2.058a.75.75 0 0 0-.75-.75.75.75 0 0 0-.75.75v5.314l-.97-.97A.752.752 0 0 0 9 6.935a.75.75 0 0 0 .22.53z",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9.215 4.521a.75.75 0 1 0-.722-1.315L3.03 6.203a1.5 1.5 0 0 0-.78 1.313v8.966a1.5 1.5 0 0 0 .78 1.313l8.25 4.516a1.489 1.489 0 0 0 1.44 0l8.25-4.516a1.5 1.5 0 0 0 .78-1.313V7.517a1.5 1.5 0 0 0-.78-1.316l-5.337-2.924a.75.75 0 1 0-.721 1.315l.838.46v.002l3.782 2.07L12 11.25 4.469 7.125l3.78-2.071V5.05l.966-.53zM3.75 8.437l7.5 4.105v8.043l-7.5-4.102V8.437zm9 12.148v-8.04l7.5-4.108v8.042l-7.5 4.106z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};
var ShippingSendIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded320);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "shipping send icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.921 6.414l-1.5-3A.75.75 0 0 0 18.75 3H5.25a.75.75 0 0 0-.671.414l-1.5 3A.757.757 0 0 0 3 6.75V19.5A1.5 1.5 0 0 0 4.5 21h15a1.5 1.5 0 0 0 1.5-1.5V6.75a.759.759 0 0 0-.079-.336zM5.713 4.5h12.574l.75 1.5H4.963l.75-1.5zm13.787 15h-15v-12h15v12zm-3.97-7.28a.75.75 0 1 1-1.06 1.06l-1.72-1.72v5.69a.75.75 0 1 1-1.5 0v-5.69l-1.72 1.72a.75.75 0 1 1-1.06-1.06l3-3a.749.749 0 0 1 1.06 0l3 3z",
    "data-ppui": "true"
  })), props.children);
};
var ShippingIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded321);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "shipping icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.946 10.969l-1.313-3.281a1.493 1.493 0 0 0-1.391-.938H18V6a.75.75 0 0 0-.75-.75H3a1.5 1.5 0 0 0-1.5 1.5v10.5a1.5 1.5 0 0 0 1.5 1.5h1.594a3 3 0 0 0 5.812 0h4.688a3 3 0 0 0 5.812 0H22.5a1.5 1.5 0 0 0 1.5-1.5v-6a.742.742 0 0 0-.054-.281zM18 8.25h3.242l.9 2.25H18V8.25zM3 6.75h13.5v6H3v-6zM7.5 19.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm7.594-2.25h-4.688a3 3 0 0 0-5.812 0H3v-3h13.5v1.154a3.008 3.008 0 0 0-1.406 1.846zM18 19.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm4.5-2.25h-1.594A3.007 3.007 0 0 0 18 15v-3h4.5v5.25z",
    "data-ppui": "true"
  })), /*#__PURE__*/React.createElement("defs", {
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "a",
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    "data-ppui": "true"
  })))), props.children);
};
var ShoesIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded322);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "shoes icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.436 12.104l-5.694-1.897a2.25 2.25 0 0 1-1.342-1.22L12.224 3.9v-.01a1.5 1.5 0 0 0-1.888-.796L3.237 5.67a1.505 1.505 0 0 0-.987 1.41V18a1.5 1.5 0 0 0 1.5 1.5H22.5A1.5 1.5 0 0 0 24 18v-2.338a3.75 3.75 0 0 0-2.564-3.558zM10.849 4.5l.666 1.56-2.02.735a.75.75 0 1 0 .51 1.41l2.1-.764.445 1.038-1.556.562a.75.75 0 0 0 .256 1.459.74.74 0 0 0 .256-.046l1.65-.6c.19.349.432.665.72.938l-1.382.502a.75.75 0 1 0 .512 1.411l2.625-.954 5.331 1.776A2.25 2.25 0 0 1 22.4 15H3.75V7.081L10.849 4.5zM3.75 18v-1.5H22.5V18H3.75z",
    "data-ppui": "true"
  })), /*#__PURE__*/React.createElement("defs", {
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "a",
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    "data-ppui": "true"
  })))), props.children);
};
var ShopIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded323);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "shop icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5 6h-3a4.5 4.5 0 1 0-9 0h-3A1.5 1.5 0 0 0 3 7.5v12.75a1.5 1.5 0 0 0 1.5 1.5h15a1.5 1.5 0 0 0 1.5-1.5V7.5A1.5 1.5 0 0 0 19.5 6zM12 3a3 3 0 0 1 3 3H9a3 3 0 0 1 3-3zm7.5 17.25h-15V7.5h3V9A.75.75 0 0 0 9 9V7.5h6V9a.75.75 0 1 0 1.5 0V7.5h3v12.75z",
    "data-ppui": "true"
  })), props.children);
};
var ShoppingBasketIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded324);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "shopping basket icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.75 11.25v5.25a.75.75 0 0 1-1.5 0v-5.25a.75.75 0 0 1 1.5 0zm3.454-.075l-.525 5.25a.75.75 0 0 0 .671.825h.076a.75.75 0 0 0 .745-.675l.525-5.25a.75.75 0 0 0-1.492-.15zm-8.408 0a.75.75 0 0 0-1.492.15l.525 5.25a.75.75 0 0 0 .75.675h.076a.75.75 0 0 0 .671-.821l-.53-5.254zm14.698-2.826l-1.413 10.6a1.505 1.505 0 0 1-1.487 1.3H4.406a1.505 1.505 0 0 1-1.487-1.3l-1.412-10.6a.75.75 0 0 1 .743-.85h4.16l5.027-5.743a.75.75 0 0 1 1.126 0L17.59 7.5h4.16a.75.75 0 0 1 .744.85zM8.403 7.5h7.194L12 3.39 8.403 7.5zM20.893 9H3.107l1.3 9.75h15.187l1.3-9.75z",
    "data-ppui": "true"
  })), props.children);
};
var ShoppingCartIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded325);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "shopping cart icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.576 5.52A.75.75 0 0 0 21 5.25H5.876l-.57-3.134a.75.75 0 0 0-.738-.616H2.25a.75.75 0 0 0 0 1.5h1.688l2.396 13.152c.07.39.243.755.5 1.057a2.625 2.625 0 1 0 4.162.791h4.258a2.625 2.625 0 1 0 2.37-1.5H8.548a.75.75 0 0 1-.738-.616l-.297-1.634h10.875a2.25 2.25 0 0 0 2.214-1.848l1.14-6.268a.75.75 0 0 0-.165-.615zM9.75 19.124a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0zm9 0a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0zm.375-6.99a.75.75 0 0 1-.74.615H7.238l-1.09-6H20.1l-.976 5.384z",
    "data-ppui": "true"
  })), props.children);
};
var SkipIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded326);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "skip icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.75 3a.75.75 0 0 0-.75.75v6.49L6.79 3.23A1.495 1.495 0 0 0 4.5 4.489V19.51a1.5 1.5 0 0 0 2.29 1.26L18 13.76v6.49a.75.75 0 1 0 1.5 0V3.75a.75.75 0 0 0-.75-.75zM6 19.493V4.505l11.985 7.5L6 19.493z",
    "data-ppui": "true"
  })), props.children);
};
var SmartphonePhotoIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded327);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "smartphone photo icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 3.75v3.375a.75.75 0 1 1-1.5 0V4.5h-2.625a.75.75 0 1 1 0-1.5h3.375a.75.75 0 0 1 .75.75zm-.75 12.375a.75.75 0 0 0-.75.75V19.5h-2.625a.75.75 0 1 0 0 1.5h3.375a.75.75 0 0 0 .75-.75v-3.375a.75.75 0 0 0-.75-.75zM7.125 19.5H4.5v-2.625a.75.75 0 1 0-1.5 0v3.375a.75.75 0 0 0 .75.75h3.375a.75.75 0 1 0 0-1.5zM3.75 7.875a.75.75 0 0 0 .75-.75V4.5h2.625a.75.75 0 0 0 0-1.5H3.75a.75.75 0 0 0-.75.75v3.375a.75.75 0 0 0 .75.75zM12 18.75A6.75 6.75 0 1 1 18.75 12 6.758 6.758 0 0 1 12 18.75zM17.25 12a5.25 5.25 0 1 0-10.5 0 5.25 5.25 0 0 0 10.5 0zm-6.375-1.125a1.125 1.125 0 1 0-2.25 0 1.125 1.125 0 0 0 2.25 0zM14.25 9.75a1.125 1.125 0 1 0 0 2.25 1.125 1.125 0 0 0 0-2.25zm-.496 3.938c-.357.315-1.125.562-1.754.562-.63 0-1.397-.247-1.754-.563a.75.75 0 1 0-.992 1.126c.734.647 1.908.937 2.746.937.838 0 2.012-.29 2.746-.938a.749.749 0 1 0-.992-1.124z",
    "data-ppui": "true"
  })), props.children);
};
var SnoozeIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded328);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "snooze icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.25 13.5a.75.75 0 0 1-.75.75h-3a.75.75 0 0 1-.623-1.166l2.221-3.334H10.5a.75.75 0 1 1 0-1.5h3a.75.75 0 0 1 .623 1.166l-2.217 3.334H13.5a.75.75 0 0 1 .75.75zm6.548 4.5a1.482 1.482 0 0 1-1.298.75h-3.826a3.75 3.75 0 0 1-7.348 0H4.5a1.5 1.5 0 0 1-1.294-2.256c.52-.896 1.294-3.43 1.294-6.744a7.5 7.5 0 0 1 15 0c0 3.312.774 5.848 1.295 6.744A1.49 1.49 0 0 1 20.798 18zm-6.677.75H9.879a2.25 2.25 0 0 0 4.242 0zm5.38-1.5c-.726-1.244-1.5-4.12-1.5-7.5A6 6 0 0 0 6 9.75c0 3.38-.776 6.257-1.5 7.5h15z",
    "data-ppui": "true"
  })), props.children);
};
var SocialJusticeIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded329);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "social justice icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.371 10.139a2.999 2.999 0 0 1 3.134 2.24.8.8 0 0 1-1.55.4A1.4 1.4 0 1 0 7.6 14.53a.8.8 0 0 1 0 1.6 3.302 3.302 0 0 0-2.659 1.33.8.8 0 0 1-1.28-.96 4.921 4.921 0 0 1 1.663-1.417A3 3 0 0 1 7.37 10.14zm7.891.215a2.999 2.999 0 0 1 3.414 4.728c.653.34 1.223.824 1.665 1.417a.8.8 0 0 1-.755 1.272.799.799 0 0 1-.527-.312 3.302 3.302 0 0 0-2.659-1.33.804.804 0 0 1-.738-.489.8.8 0 0 1 .737-1.11 1.4 1.4 0 1 0-1.356-1.75.799.799 0 0 1-1.464.206.8.8 0 0 1-.085-.607 3 3 0 0 1 1.768-2.025zm-5.331 3.738a3.55 3.55 0 0 1 4.528 5.445 5.204 5.204 0 0 1 2.08 1.988.8.8 0 1 1-1.384.801 3.668 3.668 0 0 0-6.312 0 .8.8 0 1 1-1.383-.802 5.204 5.204 0 0 1 2.08-1.987 3.55 3.55 0 0 1 .39-5.445zm2.449.975a1.95 1.95 0 1 0-.76 3.825 1.95 1.95 0 0 0 .76-3.825z",
    clipRule: "evenodd",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.25 4.499c0 3.423-4.714 5.82-4.914 5.92a.75.75 0 0 1-.671 0c-.201-.1-4.915-2.497-4.915-5.92A3 3 0 0 1 12 2.517a3 3 0 0 1 5.25 1.982zm-1.5 0a1.5 1.5 0 1 0-3 0 .75.75 0 1 1-1.5 0 1.5 1.5 0 1 0-3 0c0 1.891 2.457 3.669 3.75 4.4 1.293-.73 3.75-2.508 3.75-4.4z",
    "data-ppui": "true"
  })), props.children);
};
var SpiritualityIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded330);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "spirituality icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.061 16.875l-3.397-3.399L15.246 2.2A2.04 2.04 0 0 0 12 1.212a2.04 2.04 0 0 0-3.246.987L5.336 13.477 1.94 16.875a1.5 1.5 0 0 0 0 2.12l3.064 3.065a1.499 1.499 0 0 0 2.122 0l4.526-4.529c.126-.126.242-.26.349-.402.107.142.223.276.349.402l4.526 4.53a1.5 1.5 0 0 0 2.122 0l3.064-3.064a1.5 1.5 0 0 0 0-2.122zM6.064 21L3 17.936l1.19-1.19 3.064 3.065L6.064 21zm5.186-6.117a2.235 2.235 0 0 1-.656 1.594l-2.28 2.273-3.064-3.064 1.28-1.28a.75.75 0 0 0 .187-.314l3.469-11.458a.542.542 0 0 1 1.064.158v12.09zm2.156 1.594a2.236 2.236 0 0 1-.656-1.594V2.789a.541.541 0 0 1 1.06-.158l3.47 11.459a.75.75 0 0 0 .187.313l1.358 1.358-3.131 3-2.288-2.284zM17.936 21l-1.177-1.178 3.13-3L21 17.936 17.936 21z",
    "data-ppui": "true"
  })), props.children);
};
var SplitBillIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded331);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "split bill icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 12a.75.75 0 0 1-.75.75H3.75a.75.75 0 1 1 0-1.5h16.5A.75.75 0 0 1 21 12zM9.53 5.03l1.72-1.72V9a.75.75 0 1 0 1.5 0V3.31l1.72 1.72a.75.75 0 1 0 1.06-1.06l-3-3a.749.749 0 0 0-1.06 0l-3 3a.75.75 0 1 0 1.06 1.06zm4.94 13.94l-1.72 1.72V15a.75.75 0 1 0-1.5 0v5.69l-1.72-1.72a.75.75 0 1 0-1.06 1.06l3 3a.747.747 0 0 0 1.06 0l3-3a.75.75 0 1 0-1.06-1.06z",
    "data-ppui": "true"
  })), props.children);
};
var SportsIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded332);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "sports icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.25 11.25h-.75v-3a1.5 1.5 0 0 0-1.5-1.5h-1.5V6A1.5 1.5 0 0 0 18 4.5h-2.25a1.5 1.5 0 0 0-1.5 1.5v5.25h-4.5V6a1.5 1.5 0 0 0-1.5-1.5H6A1.5 1.5 0 0 0 4.5 6v.75H3a1.5 1.5 0 0 0-1.5 1.5v3H.75a.75.75 0 1 0 0 1.5h.75v3a1.5 1.5 0 0 0 1.5 1.5h1.5V18A1.5 1.5 0 0 0 6 19.5h2.25a1.5 1.5 0 0 0 1.5-1.5v-5.25h4.5V18a1.5 1.5 0 0 0 1.5 1.5H18a1.5 1.5 0 0 0 1.5-1.5v-.75H21a1.5 1.5 0 0 0 1.5-1.5v-3h.75a.75.75 0 1 0 0-1.5zM3 15.75v-7.5h1.5v7.5H3zM8.25 18H6V6h2.25v12zM18 18h-2.25V6H18v12zm3-2.25h-1.5v-7.5H21v7.5z",
    "data-ppui": "true"
  })), props.children);
};
var SubscriptionsIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded333);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "subscriptions icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 2.25H9a1.5 1.5 0 0 0-1.5 1.5v1.5H6a1.5 1.5 0 0 0-1.5 1.5V21a.75.75 0 0 0 1.186.61l4.814-3.438 4.815 3.438A.75.75 0 0 0 16.5 21v-3.685l1.814 1.295A.749.749 0 0 0 19.5 18V3.75a1.5 1.5 0 0 0-1.5-1.5zm-3 17.293l-4.065-2.906a.75.75 0 0 0-.872 0L6 19.542V6.75h9v12.793zm3-3l-1.5-1.074V6.75a1.5 1.5 0 0 0-1.5-1.5H9v-1.5h9v12.793z",
    "data-ppui": "true"
  })), props.children);
};
var SubtractIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded334);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "subtract icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 12a.75.75 0 0 1-.75.75H3.75a.75.75 0 1 1 0-1.5h16.5A.75.75 0 0 1 21 12z",
    "data-ppui": "true"
  })), props.children);
};
var SurveyIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded335);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "survey icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.75 14.25A.75.75 0 0 1 15 15H9a.75.75 0 0 1 0-1.5h6a.75.75 0 0 1 .75.75zM15 10.5H9A.75.75 0 1 0 9 12h6a.75.75 0 0 0 0-1.5zm5.25-6v15.75a1.5 1.5 0 0 1-1.5 1.5H5.25a1.5 1.5 0 0 1-1.5-1.5V4.5A1.5 1.5 0 0 1 5.25 3h3.4a4.492 4.492 0 0 1 6.7 0h3.4a1.5 1.5 0 0 1 1.5 1.5zM9 6h6a3 3 0 0 0-6 0zm9.75-1.5h-2.508c.17.482.258.989.258 1.5v.75a.75.75 0 0 1-.75.75h-7.5a.75.75 0 0 1-.75-.75V6c0-.511.087-1.018.258-1.5H5.25v15.75h13.5V4.5z",
    "data-ppui": "true"
  })), props.children);
};
var SwitchCardIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded336);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "switch card icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.03 6.837a.75.75 0 0 1-1.06-1.062l.97-.969H2.25a.75.75 0 1 1 0-1.5h17.69l-.97-.97a.75.75 0 1 1 1.06-1.06l2.25 2.25a.75.75 0 0 1 0 1.06l-2.25 2.25zM3.97 22.724a.75.75 0 1 0 1.06-1.06l-.97-.97h17.69a.75.75 0 1 0 0-1.5H4.06l.97-.97a.75.75 0 1 0-1.06-1.06l-2.25 2.25a.749.749 0 0 0 0 1.06l2.25 2.25z",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.305 8.166h8.264a1.079 1.079 0 0 1 1.079 1.079v5.51a1.079 1.079 0 0 1-1.079 1.078H7.305a1.079 1.079 0 0 1-1.08-1.079v-5.51a1.079 1.079 0 0 1 1.08-1.078zm7.874 2.472V9.635H7.695v1.003h7.484zm-7.484 3.726v-2.257h7.484v2.258H7.695z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};
var TermsIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded337);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "terms icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 12a.75.75 0 0 1-.75.75H12a.75.75 0 1 1 0-1.5h8.25A.75.75 0 0 1 21 12zm-9-5.25h8.25a.75.75 0 1 0 0-1.5H12a.75.75 0 1 0 0 1.5zm8.25 10.5H12a.75.75 0 1 0 0 1.5h8.25a.75.75 0 1 0 0-1.5zM7.72 3.97L5.25 6.44l-.97-.97a.75.75 0 1 0-1.06 1.06l1.5 1.5a.75.75 0 0 0 1.06 0l3-3a.75.75 0 1 0-1.06-1.06zm0 6l-2.47 2.47-.97-.97a.75.75 0 0 0-1.06 1.06l1.5 1.5a.75.75 0 0 0 1.06 0l3-3a.75.75 0 0 0-1.06-1.06zm0 6l-2.47 2.47-.97-.97a.75.75 0 1 0-1.06 1.06l1.5 1.5a.75.75 0 0 0 1.06 0l3-3a.75.75 0 0 0-1.06-1.06z",
    "data-ppui": "true"
  })), props.children);
};
var TextSizeIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded338);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "text size icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.179 4.93a.75.75 0 0 0-1.358 0l-6 12.75a.75.75 0 1 0 1.358.639L3.74 15h7.518l1.562 3.319a.75.75 0 0 0 1.358-.639l-6-12.75zM4.447 13.5L7.5 7.012l3.053 6.488H4.447zM18.75 9c-1.196 0-2.131.325-2.778.968a.75.75 0 0 0 1.056 1.065c.356-.354.937-.533 1.722-.533 1.24 0 2.25.844 2.25 1.875v.302A4.009 4.009 0 0 0 18.75 12C16.682 12 15 13.514 15 15.375s1.682 3.375 3.75 3.375a4.006 4.006 0 0 0 2.25-.68.751.751 0 0 0 1.5-.07v-5.625C22.5 10.515 20.818 9 18.75 9zm0 8.25c-1.24 0-2.25-.844-2.25-1.875 0-1.031 1.01-1.875 2.25-1.875s2.25.844 2.25 1.875c0 1.031-1.01 1.875-2.25 1.875z",
    "data-ppui": "true"
  })), props.children);
};
var TimerIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded339);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "timer icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 3.75a9 9 0 1 0 9 9 9.01 9.01 0 0 0-9-9zm0 16.5a7.5 7.5 0 1 1 7.5-7.5 7.508 7.508 0 0 1-7.5 7.5zm4.28-11.78a.748.748 0 0 1 0 1.06l-3.75 3.75a.75.75 0 1 1-1.06-1.06l3.75-3.75a.75.75 0 0 1 1.06 0zM9 1.5a.75.75 0 0 1 .75-.75h4.5a.75.75 0 1 1 0 1.5h-4.5A.75.75 0 0 1 9 1.5z",
    "data-ppui": "true"
  })), props.children);
};
var TipJarIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded340);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "tip jar icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.25 4.576V3a1.5 1.5 0 0 0-1.5-1.5h-7.5A1.5 1.5 0 0 0 6.75 3v1.576a3.755 3.755 0 0 0-3 3.674v10.5A3.75 3.75 0 0 0 7.5 22.5h9a3.75 3.75 0 0 0 3.75-3.75V8.25a3.755 3.755 0 0 0-3-3.674zm-1.5-.076h-1.5V3h1.5v1.5zm-4.5 0V3h1.5v1.5h-1.5zM9.75 3v1.5h-1.5V3h1.5zm9 15.75A2.25 2.25 0 0 1 16.5 21h-9a2.25 2.25 0 0 1-2.25-2.25V8.25A2.25 2.25 0 0 1 7.5 6h9a2.25 2.25 0 0 1 2.25 2.25v10.5zM15 15a2.25 2.25 0 0 1-2.25 2.25V18a.75.75 0 1 1-1.5 0v-.75h-.75a.75.75 0 1 1 0-1.5h2.25a.75.75 0 1 0 0-1.5h-1.5a2.25 2.25 0 0 1 0-4.5V9a.75.75 0 1 1 1.5 0v.75h.75a.75.75 0 1 1 0 1.5h-2.25a.75.75 0 1 0 0 1.5h1.5A2.25 2.25 0 0 1 15 15z",
    "data-ppui": "true"
  })), props.children);
};
var ToolsIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded341);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "tools icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.28 4.718a.751.751 0 0 1 0 1.06l-5.25 5.25a.75.75 0 0 1-1.06-1.06l5.25-5.25a.75.75 0 0 1 1.06 0zm3.97.758a4.702 4.702 0 0 1-1.385 3.343l-4.99 4.99a1.486 1.486 0 0 1-1.06.441H14.25v1.578a1.5 1.5 0 0 1-.305.906.768.768 0 0 1-.067.077l-.75.75a1.5 1.5 0 0 1-2.12 0l-1.755-1.755-7.219 7.225a.75.75 0 0 1-1.06-1.061l7.223-7.224-1.754-1.754a1.5 1.5 0 0 1 0-2.122l.75-.75a.737.737 0 0 1 .077-.067c.26-.195.577-.302.902-.303H9.75V8.185a1.493 1.493 0 0 1 .439-1.06l4.991-4.99a4.728 4.728 0 0 1 8.07 3.341zm-1.5 0a3.229 3.229 0 0 0-5.51-2.283l-4.99 4.992V9.75a1.5 1.5 0 0 1-1.5 1.5H8.182l-.682.682 4.568 4.568.682-.682V14.25a1.5 1.5 0 0 1 1.5-1.5h1.565l4.99-4.991a3.207 3.207 0 0 0 .945-2.283z",
    "data-ppui": "true"
  })), /*#__PURE__*/React.createElement("defs", {
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "a",
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    "data-ppui": "true"
  })))), props.children);
};
var TopUpIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded342);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "top up icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.28 12.97a.75.75 0 1 1-1.06 1.06l-5.47-5.47V21a.75.75 0 1 1-1.5 0V8.56l-5.47 5.47a.75.75 0 1 1-1.06-1.06l6.75-6.75a.749.749 0 0 1 1.06 0l6.75 6.75zM20.25 3H3.75a.75.75 0 0 0 0 1.5h16.5a.75.75 0 1 0 0-1.5z",
    "data-ppui": "true"
  })), props.children);
};
var ToysIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded343);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "toys icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.836 6.829l-4.34-2.17C17.956 3.68 16.613 3 15 3c-2.103 0-3.75 1.153-3.75 2.625 0 .208.034.415.1.612l-1.83.915A5.033 5.033 0 0 0 7.5 6.75c-2.103 0-3.75 1.153-3.75 2.625 0 .208.034.415.1.612L1.163 11.33A.75.75 0 0 0 .75 12v6a.75.75 0 0 0 .414.671l6 3a.75.75 0 0 0 .672 0l15-7.5a.75.75 0 0 0 .414-.671v-6a.75.75 0 0 0-.414-.671zM7.5 14.162L3.177 12l1.604-.802C5.46 11.694 6.42 12 7.5 12c2.103 0 3.75-1.153 3.75-2.625a2.042 2.042 0 0 0-.408-1.207l1.44-.72c.678.496 1.638.802 2.718.802 1.723 0 3.14-.774 3.595-1.864L20.823 7.5 7.5 14.162zM15 4.5c1.288 0 2.25.594 2.25 1.125 0 .53-.962 1.125-2.25 1.125s-2.25-.594-2.25-1.125c0-.53.962-1.125 2.25-1.125zM7.5 8.25c1.288 0 2.25.594 2.25 1.125 0 .53-.962 1.125-2.25 1.125-.907 0-1.65-.294-2.013-.656a.778.778 0 0 0-.079-.087.62.62 0 0 1-.158-.382c0-.53.962-1.125 2.25-1.125zm-5.25 4.963l4.5 2.25v4.324l-4.5-2.25v-4.324zm6 6.574v-4.324l13.5-6.75v4.324l-13.5 6.75z",
    "data-ppui": "true"
  })), props.children);
};
var TransferIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded344);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "transfer icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.03 17.03l-3 3a.75.75 0 0 1-1.06-1.06l1.72-1.72H4.5a.75.75 0 1 1 0-1.5h13.19l-1.72-1.72a.75.75 0 1 1 1.06-1.06l3 3a.75.75 0 0 1 0 1.06zm-13.06-6a.75.75 0 0 0 1.06-1.06L6.31 8.25H19.5a.75.75 0 1 0 0-1.5H6.31l1.72-1.72a.75.75 0 1 0-1.06-1.06l-3 3a.75.75 0 0 0 0 1.06l3 3z",
    "data-ppui": "true"
  })), props.children);
};
var TravelIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded345);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "travel icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.375 10.707l2.731-2.57.016-.017a3 3 0 1 0-4.243-4.243c0 .006-.01.01-.016.016l-2.57 2.732L5.51 3.794a.75.75 0 0 0-.786.174l-2.25 2.25a.75.75 0 0 0 .114 1.154l5.99 3.993-1.39 1.385H5.25a.75.75 0 0 0-.529.22l-2.25 2.25a.75.75 0 0 0 .249 1.225l3.452 1.381 1.378 3.446.005.015a.75.75 0 0 0 1.236.231l2.238-2.239a.75.75 0 0 0 .222-.53V16.81l1.384-1.384 3.992 5.99a.752.752 0 0 0 1.154.114l2.25-2.25a.75.75 0 0 0 .175-.786l-2.83-7.787zm-.007 9.115l-3.993-5.988a.75.75 0 0 0-.55-.334h-.074a.75.75 0 0 0-.53.22l-2.25 2.25a.75.75 0 0 0-.221.53v1.94l-1.225 1.225-1.079-2.696a.75.75 0 0 0-.415-.416l-2.694-1.078L5.56 14.25H7.5a.748.748 0 0 0 .53-.22l2.25-2.25a.75.75 0 0 0-.114-1.155L4.177 6.632l1.266-1.265 7.802 2.837a.75.75 0 0 0 .802-.188l2.901-3.085a1.5 1.5 0 0 1 2.12 2.122l-3.08 2.9a.75.75 0 0 0-.188.802l2.836 7.802-1.268 1.265z",
    "data-ppui": "true"
  })), props.children);
};
var TreatYourselfIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded346);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "treat yourself icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.517 6.957a.75.75 0 0 0-.668-.187 4.125 4.125 0 0 0-5.099-2.863 4.124 4.124 0 0 0-7.5 0 4.125 4.125 0 0 0-5.1 2.86.75.75 0 0 0-.881.905l2.865 12.172A1.5 1.5 0 0 0 6.594 21h10.812a1.5 1.5 0 0 0 1.46-1.156L21.73 7.672a.75.75 0 0 0-.213-.715zM7.125 5.25c.429-.001.85.104 1.23.306a.75.75 0 0 0 1.083-.501 2.625 2.625 0 0 1 5.124 0 .751.751 0 0 0 1.084.5 2.625 2.625 0 0 1 3.76 1.62l-3.615 1.032-3.233-1.294a1.5 1.5 0 0 0-1.114 0L8.21 8.21 4.594 7.176A2.625 2.625 0 0 1 7.125 5.25zm-.53 14.25L4.022 8.572 7.57 9.586 8.893 19.5H6.594zm6.999 0h-3.188L9.07 9.48 12 8.308l2.93 1.172-1.336 10.02zm3.812 0h-2.3l1.323-9.914 3.548-1.014L17.406 19.5z",
    "data-ppui": "true"
  })), props.children);
};
var TreeViewIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded347);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "tree view icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5 14.25h3a1.5 1.5 0 0 0 1.5-1.5v-3a1.5 1.5 0 0 0-1.5-1.5h-3a1.5 1.5 0 0 0-1.5 1.5v.75H8.25v-3H9A1.5 1.5 0 0 0 10.5 6V3A1.5 1.5 0 0 0 9 1.5H6A1.5 1.5 0 0 0 4.5 3v3A1.5 1.5 0 0 0 6 7.5h.75V18A2.25 2.25 0 0 0 9 20.25h6V21a1.5 1.5 0 0 0 1.5 1.5h3A1.5 1.5 0 0 0 21 21v-3a1.5 1.5 0 0 0-1.5-1.5h-3A1.5 1.5 0 0 0 15 18v.75H9a.75.75 0 0 1-.75-.75v-6H15v.75a1.5 1.5 0 0 0 1.5 1.5zM6 3h3v3H6V3zm10.5 15h3v3h-3v-3zm0-8.25h3v3h-3v-3z",
    "data-ppui": "true"
  })), props.children);
};
var TrophyIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded348);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "trophy icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.75 6H19.5V4.5a.75.75 0 0 0-.75-.75H5.25a.75.75 0 0 0-.75.75V6H2.25a1.5 1.5 0 0 0-1.5 1.5V9a3.75 3.75 0 0 0 3.75 3.75h.342a7.512 7.512 0 0 0 6.408 5.213v2.287H9a.75.75 0 1 0 0 1.5h6a.75.75 0 1 0 0-1.5h-2.25v-2.29c2.994-.302 5.479-2.403 6.383-5.21h.367A3.75 3.75 0 0 0 23.25 9V7.5a1.5 1.5 0 0 0-1.5-1.5zM4.5 11.25A2.25 2.25 0 0 1 2.25 9V7.5H4.5v3c0 .25.012.5.037.75H4.5zm13.5-.834c0 3.33-2.719 6.06-6 6.084a6 6 0 0 1-6-6V5.25h12v5.166zM21.75 9a2.25 2.25 0 0 1-2.25 2.25h-.047c.03-.277.047-.556.047-.834V7.5h2.25V9z",
    "data-ppui": "true"
  })), props.children);
};
var TuitionIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded349);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "tuition icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.237 5.288l-9-3a.75.75 0 0 0-.474 0l-9 3A.75.75 0 0 0 2.25 6v7.5a.75.75 0 0 0 1.5 0V7.04L6.9 8.09a6 6 0 0 0 1.935 8.254c-1.688.662-3.146 1.86-4.213 3.496a.75.75 0 1 0 1.256.82c1.413-2.168 3.644-3.41 6.122-3.41 2.478 0 4.71 1.242 6.122 3.41a.75.75 0 0 0 1.256-.82c-1.067-1.637-2.531-2.834-4.213-3.496a6 6 0 0 0 1.936-8.25l4.136-1.378a.75.75 0 0 0 0-1.423v-.005zM16.5 11.25a4.5 4.5 0 1 1-8.123-2.667l3.386 1.125a.75.75 0 0 0 .474 0l3.386-1.125a4.49 4.49 0 0 1 .877 2.667zM12 8.21L5.372 6 12 3.79 18.628 6 12 8.21z",
    "data-ppui": "true"
  })), props.children);
};
var UndoIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded350);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "undo icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.75 13.5a6.007 6.007 0 0 1-6 6H7.5a.75.75 0 1 1 0-1.5h8.25a4.5 4.5 0 0 0 0-9H4.81l3.22 3.22a.75.75 0 1 1-1.06 1.06l-4.5-4.5a.75.75 0 0 1 0-1.06l4.5-4.5a.75.75 0 0 1 1.06 1.06L4.81 7.5h10.94a6.007 6.007 0 0 1 6 6z",
    "data-ppui": "true"
  })), props.children);
};
var UnlinkIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded351);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "unlink icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.622 5.378a3 3 0 0 0-4.237-.005l-1.092 1.144a.75.75 0 0 1-1.086-1.03l1.099-1.153a4.5 4.5 0 0 1 6.364 6.364l-1.153 1.099a.75.75 0 0 1-1.03-1.086l1.144-1.092a3 3 0 0 0-.01-4.24zm-7.915 12.105l-1.092 1.144a3 3 0 0 1-4.242-4.242l1.144-1.092a.75.75 0 0 0-1.03-1.086L4.33 13.306a4.5 4.5 0 0 0 6.364 6.364l1.099-1.153a.75.75 0 1 0-1.086-1.03v-.004zm9.543-3.233H18a.75.75 0 1 0 0 1.5h2.25a.75.75 0 1 0 0-1.5zm-16.5-4.5H6a.75.75 0 0 0 0-1.5H3.75a.75.75 0 0 0 0 1.5zM15 17.25a.75.75 0 0 0-.75.75v2.25a.75.75 0 1 0 1.5 0V18a.75.75 0 0 0-.75-.75zM9 6.75A.75.75 0 0 0 9.75 6V3.75a.75.75 0 0 0-1.5 0V6a.75.75 0 0 0 .75.75z",
    "data-ppui": "true"
  })), props.children);
};
var UnlockIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded352);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "unlock icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5 7.5H9V5.25a3 3 0 0 1 3-3c1.44 0 2.738 1.031 3.015 2.4a.75.75 0 0 0 1.47-.3C16.061 2.265 14.175.75 12 .75a4.505 4.505 0 0 0-4.5 4.5V7.5h-3A1.5 1.5 0 0 0 3 9v10.5A1.5 1.5 0 0 0 4.5 21h15a1.5 1.5 0 0 0 1.5-1.5V9a1.5 1.5 0 0 0-1.5-1.5zm0 12h-15V9h15v10.5zm-7.5-9a2.625 2.625 0 0 0-.75 5.14v1.61a.75.75 0 1 0 1.5 0v-1.61A2.625 2.625 0 0 0 12 10.5zm0 3.75A1.125 1.125 0 1 1 12 12a1.125 1.125 0 0 1 0 2.25z",
    "data-ppui": "true"
  })), props.children);
};
var UnmuteIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded353);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "unmute icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.58 2.326a.75.75 0 0 0-.79.082L7.242 7.5H3A1.5 1.5 0 0 0 1.5 9v6A1.5 1.5 0 0 0 3 16.5h4.242l6.548 5.091A.75.75 0 0 0 15 21V3a.75.75 0 0 0-.42-.674zM3 9h3.75v6H3V9zm10.5 10.466l-5.25-4.083V8.616l5.25-4.082v14.932zm5.063-9.945a3.75 3.75 0 0 1 0 4.958.75.75 0 0 1-1.125-.992 2.25 2.25 0 0 0 0-2.974.75.75 0 0 1 1.125-.992zM23.25 12a7.49 7.49 0 0 1-1.91 5 .75.75 0 0 1-1.117-1 6 6 0 0 0 0-8 .751.751 0 1 1 1.117-1 7.484 7.484 0 0 1 1.91 5z",
    "data-ppui": "true"
  })), props.children);
};
var UploadIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded354);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "upload icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 13.5v6a.75.75 0 0 1-.75.75H3.75A.75.75 0 0 1 3 19.5v-6a.75.75 0 1 1 1.5 0v5.25h15V13.5a.75.75 0 1 1 1.5 0zM8.78 7.28l2.47-2.47v8.69a.75.75 0 1 0 1.5 0V4.81l2.47 2.47a.75.75 0 1 0 1.06-1.06l-3.75-3.75a.749.749 0 0 0-1.06 0L7.72 6.22a.75.75 0 1 0 1.06 1.06z",
    "data-ppui": "true"
  })), props.children);
};
var UserProfileIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded355);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "user profile icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.649 19.875c-1.428-2.468-3.628-4.238-6.196-5.077a6.75 6.75 0 1 0-6.906 0c-2.568.838-4.768 2.608-6.196 5.077a.75.75 0 1 0 1.299.75C5.416 17.573 8.538 15.75 12 15.75c3.462 0 6.584 1.823 8.35 4.875a.751.751 0 1 0 1.299-.75zM6.75 9a5.25 5.25 0 1 1 10.5 0 5.25 5.25 0 0 1-10.5 0z",
    "data-ppui": "true"
  })), props.children);
};
var VacationIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded356);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "vacation icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.336 21.469a.75.75 0 0 1-1.055.117c-.034-.028-3.64-2.836-9.281-2.836-5.642 0-9.248 2.812-9.281 2.837a.75.75 0 1 1-.938-1.173c.153-.122 3.612-2.837 9.215-3.136a11.246 11.246 0 0 1-.309-3.556c.164-2.035 1.024-4.746 4.032-6.795a6.062 6.062 0 0 0-1.57-.177c-1.78.058-2.9 1.098-3.421 3.18a.75.75 0 1 1-1.455-.362C9.14 6.104 11.377 5.31 13.1 5.256a7.638 7.638 0 0 1 2.032.23c-.359-.594-.884-1.213-1.613-1.524-.938-.398-2.079-.224-3.404.516a.751.751 0 1 1-.732-1.312c1.757-.98 3.35-1.176 4.733-.581 1.17.502 1.943 1.479 2.425 2.343.58-.903 1.301-1.516 2.1-1.775 1.111-.363 2.31-.068 3.562.878a.75.75 0 0 1-.904 1.196c-.835-.63-1.572-.849-2.19-.65-.683.221-1.206.938-1.534 1.558a6.606 6.606 0 0 1 1.924.715c1.37.783 3 2.442 3 5.9a.75.75 0 1 1-1.5 0c0-2.198-.757-3.75-2.25-4.593a4.734 4.734 0 0 0-.54-.262c.473.96.639 2.042.475 3.099a5.57 5.57 0 0 1-.83 2.195.75.75 0 0 1-1.227-.863 3.923 3.923 0 0 0-.306-4.628c-2.531 1.426-3.927 3.492-4.14 6.149a9.776 9.776 0 0 0 .359 3.416c5.873.17 9.517 3.031 9.675 3.156a.75.75 0 0 1 .12 1.05zM2.25 13.125a2.625 2.625 0 1 1 5.25 0 2.625 2.625 0 0 1-5.25 0zm1.5 0a1.125 1.125 0 1 0 2.25 0 1.125 1.125 0 0 0-2.25 0z",
    "data-ppui": "true"
  })), props.children);
};
var VenmoIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded357);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "venmo icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M19.456 2.368a.75.75 0 0 1 .83.397c.896 1.79.901 4.672-.03 7.913-.942 3.28-2.877 7.054-6.046 10.712a.75.75 0 0 1-.567.259h-7.02a.75.75 0 0 1-.74-.625L3.054 4.254a.75.75 0 0 1 .66-.87l6.172-.668a.75.75 0 0 1 .825.654l1.239 10.05c1.194-2.03 2.328-5.328 1.3-8.888a.75.75 0 0 1 .562-.94l5.644-1.224zm-4.569 2.525C15.975 9.914 13.468 14.28 12 15.919a.75.75 0 0 1-1.303-.409L9.313 4.287l-4.647.503 2.59 15.359h6.042c2.903-3.421 4.66-6.903 5.516-9.886.78-2.714.791-4.921.345-6.296l-4.272.926z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};
var VerifiedIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded358);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "verified icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.174 9.64c-.353-.37-.719-.75-.857-1.085-.127-.307-.135-.815-.142-1.307-.014-.915-.03-1.952-.75-2.673-.721-.72-1.758-.736-2.673-.75-.492-.008-1-.015-1.307-.143-.334-.137-.715-.503-1.085-.856C13.714 2.204 12.98 1.5 12 1.5c-.979 0-1.713.704-2.36 1.326-.37.353-.75.719-1.085.857-.305.127-.815.135-1.307.142-.915.014-1.952.03-2.673.75-.721.72-.731 1.758-.75 2.673-.008.492-.015 1-.143 1.307-.137.333-.503.715-.857 1.084C2.204 10.286 1.5 11.021 1.5 12c0 .979.704 1.713 1.325 2.36.354.37.72.75.857 1.085.128.307.135.815.143 1.307.014.915.029 1.952.75 2.673.72.72 1.758.736 2.673.75.492.008 1 .015 1.307.142.333.138.715.504 1.084.857.647.622 1.382 1.326 2.36 1.326.98 0 1.714-.704 2.361-1.326.37-.353.75-.719 1.085-.857.307-.127.815-.134 1.307-.142.915-.014 1.952-.03 2.673-.75.72-.72.736-1.758.75-2.673.007-.492.015-1 .142-1.307.138-.333.504-.715.857-1.084.622-.647 1.326-1.382 1.326-2.361 0-.979-.704-1.713-1.326-2.36zm-1.083 3.683c-.449.469-.914.953-1.16 1.549-.236.571-.247 1.225-.256 1.858-.01.656-.02 1.343-.311 1.634-.292.29-.974.302-1.634.311-.633.01-1.287.02-1.859.256-.595.246-1.08.711-1.548 1.16-.47.45-.948.909-1.323.909s-.858-.461-1.323-.908c-.465-.448-.953-.915-1.549-1.161-.572-.236-1.225-.247-1.858-.256-.656-.01-1.343-.02-1.634-.311-.29-.292-.302-.974-.311-1.634-.01-.633-.02-1.287-.256-1.858-.247-.596-.712-1.08-1.16-1.55-.45-.468-.91-.947-.91-1.322 0-.375.462-.858.91-1.323.447-.465.913-.953 1.16-1.549.236-.571.247-1.225.256-1.858.01-.656.02-1.343.311-1.634.292-.29.974-.302 1.634-.311.633-.01 1.286-.02 1.858-.256.596-.247 1.08-.712 1.55-1.16C11.145 3.458 11.624 3 12 3c.375 0 .858.461 1.323.908.465.448.953.914 1.548 1.161.572.236 1.226.247 1.859.256.656.01 1.343.02 1.634.311.29.292.302.974.31 1.634.01.633.02 1.287.257 1.858.246.596.711 1.08 1.16 1.55.45.468.909.947.909 1.322 0 .375-.461.858-.909 1.323zm-3.81-4.104a.75.75 0 0 1 0 1.062l-5.25 5.25a.75.75 0 0 1-1.062 0l-2.25-2.25a.75.75 0 1 1 1.061-1.062l1.72 1.72 4.72-4.72a.749.749 0 0 1 1.06 0z",
    "data-ppui": "true"
  })), props.children);
};
var VideoGamesIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded359);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "video games icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5 10.5h-2.25a.75.75 0 1 1 0-1.5h2.25a.75.75 0 1 1 0 1.5zM9.75 9H9v-.75a.75.75 0 0 0-1.5 0V9h-.75a.75.75 0 0 0 0 1.5h.75v.75a.75.75 0 1 0 1.5 0v-.75h.75a.75.75 0 1 0 0-1.5zm12.889 9.81a3.374 3.374 0 0 1-5.15.452l-.034-.035L13.733 15h-3.47l-3.718 4.227-.033.035a3.382 3.382 0 0 1-3.813.671A3.374 3.374 0 0 1 .802 16.29v-.013l1.535-7.883A5.614 5.614 0 0 1 7.865 3.75h8.26a5.632 5.632 0 0 1 5.531 4.617v.017l1.535 7.891v.013a3.351 3.351 0 0 1-.552 2.523zm-6.514-5.31a4.125 4.125 0 0 0 0-8.25h-8.26a4.116 4.116 0 0 0-4.051 3.41v.012l-1.536 7.883a1.875 1.875 0 0 0 3.16 1.66l3.93-4.46a.75.75 0 0 1 .562-.255h6.195zm5.597 3.055l-.82-4.218A5.626 5.626 0 0 1 16.125 15h-.394l2.832 3.217a1.883 1.883 0 0 0 1.636.505 1.875 1.875 0 0 0 1.522-2.167z",
    "data-ppui": "true"
  })), props.children);
};
var ViewIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded360);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "view icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.185 11.696c-.032-.074-.827-1.835-2.592-3.6C18.241 5.742 15.27 4.5 12 4.5c-3.27 0-6.24 1.243-8.593 3.595C1.642 9.861.844 11.625.815 11.696a.75.75 0 0 0 0 .61c.032.074.827 1.834 2.592 3.6C5.759 18.256 8.73 19.5 12 19.5c3.27 0 6.24-1.243 8.593-3.594 1.765-1.766 2.56-3.526 2.592-3.6a.75.75 0 0 0 0-.61zM12 18c-2.886 0-5.407-1.05-7.493-3.117A12.511 12.511 0 0 1 2.344 12a12.499 12.499 0 0 1 2.163-2.883C6.593 7.05 9.114 6 12 6s5.407 1.05 7.493 3.117A12.507 12.507 0 0 1 21.661 12c-.676 1.262-3.62 6-9.661 6zm0-10.5a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9zm0 7.5a3 3 0 1 1 0-5.999A3 3 0 0 1 12 15z",
    "data-ppui": "true"
  })), props.children);
};
var WalletIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded361);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "wallet icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.25 6h-15a.75.75 0 0 1 0-1.5H18A.75.75 0 1 0 18 3H5.25A2.25 2.25 0 0 0 3 5.25v12a2.25 2.25 0 0 0 2.25 2.25h15a1.5 1.5 0 0 0 1.5-1.5V7.5a1.5 1.5 0 0 0-1.5-1.5zm0 12h-15a.75.75 0 0 1-.75-.75V7.372c.24.085.495.128.75.128h15V18zm-4.5-5.625a1.125 1.125 0 1 1 2.25 0 1.125 1.125 0 0 1-2.25 0z",
    "data-ppui": "true"
  })), props.children);
};
var WandIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded362);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "wand icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.5 6a.75.75 0 0 1 .75-.75h1.5v-1.5a.75.75 0 0 1 1.5 0v1.5h1.5a.75.75 0 1 1 0 1.5h-1.5v1.5a.75.75 0 0 1-1.5 0v-1.5h-1.5A.75.75 0 0 1 4.5 6zm12.75 12h-.75v-.75a.75.75 0 1 0-1.5 0V18h-.75a.75.75 0 1 0 0 1.5H15v.75a.75.75 0 1 0 1.5 0v-.75h.75a.75.75 0 1 0 0-1.5zm5.25-4.5H21V12a.75.75 0 1 0-1.5 0v1.5H18a.75.75 0 1 0 0 1.5h1.5v1.5a.75.75 0 1 0 1.5 0V15h1.5a.75.75 0 1 0 0-1.5zm-1.94-6L7.5 20.56a1.5 1.5 0 0 1-2.12 0l-1.941-1.938a1.5 1.5 0 0 1 0-2.122L16.5 3.44a1.5 1.5 0 0 1 2.122 0l1.938 1.938a1.5 1.5 0 0 1 0 2.122zm-5.121 3L13.5 8.56l-9 9 1.939 1.94 9-9zM19.5 6.44L17.56 4.5l-3 3 1.94 1.94 3-3z",
    "data-ppui": "true"
  })), props.children);
};
var WarningSmIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded363);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "warning sm icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 18 18",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8.237 5.625v3.937a.763.763 0 0 0 1.525 0V5.625a.762.762 0 1 0-1.525 0zm1.631 7.048a1.043 1.043 0 1 0-1.735-1.159 1.043 1.043 0 0 0 1.735 1.16z",
    clipRule: "evenodd",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9 1.487A7.513 7.513 0 1 0 16.512 9 7.521 7.521 0 0 0 9 1.487zm0 13.5A5.987 5.987 0 1 1 14.988 9 5.994 5.994 0 0 1 9 14.987z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};
var WarningIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded364);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "warning icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 2.25A9.75 9.75 0 1 0 21.75 12 9.76 9.76 0 0 0 12 2.25zm0 18A8.25 8.25 0 1 1 20.25 12 8.26 8.26 0 0 1 12 20.25zm-.75-7.5V7.5a.75.75 0 1 1 1.5 0v5.25a.75.75 0 1 1-1.5 0zm1.875 3.375a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0z",
    "data-ppui": "true"
  })), props.children);
};
var WebsiteIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded365);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "website icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.25 3.75H3.75a1.5 1.5 0 0 0-1.5 1.5v13.5a1.5 1.5 0 0 0 1.5 1.5h16.5a1.5 1.5 0 0 0 1.5-1.5V5.25a1.5 1.5 0 0 0-1.5-1.5zm0 1.5v3H3.75v-3h16.5zm0 13.5H3.75v-9h16.5v9z",
    "data-ppui": "true"
  })), props.children);
};
var WellnessIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded366);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "wellness icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.75 13.5H3A.75.75 0 1 1 3 12h3.349l1.277-1.916a.75.75 0 0 1 1.248 0l2.376 3.562.876-1.312A.75.75 0 0 1 12.75 12H15a.75.75 0 1 1 0 1.5h-1.849l-1.277 1.916a.75.75 0 0 1-1.248 0L8.25 11.852l-.876 1.312a.75.75 0 0 1-.624.336zm9.938-9.75c-1.936 0-3.631.832-4.688 2.24-1.057-1.408-2.752-2.24-4.688-2.24A5.82 5.82 0 0 0 1.5 9.563v.21A.75.75 0 0 0 3 9.727v-.165A4.318 4.318 0 0 1 7.313 5.25c1.823 0 3.354.971 3.993 2.531a.75.75 0 0 0 1.388 0c.64-1.563 2.17-2.531 3.993-2.531A4.318 4.318 0 0 1 21 9.563c0 5.025-7.29 9.576-9 10.574-1.015-.591-3.997-2.437-6.251-4.894a.752.752 0 0 0-1.234.19.75.75 0 0 0 .128.824c2.922 3.188 6.837 5.314 7.002 5.403a.75.75 0 0 0 .71 0C12.77 21.437 22.5 16.125 22.5 9.562a5.819 5.819 0 0 0-5.813-5.812z",
    "data-ppui": "true"
  })), props.children);
};
var WildlifeIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded367);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "wildlife icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.816 4.732c-.347-.448-1.018-.982-2.222-.982-1.58 0-3.606 1.058-5.42 2.827a13.13 13.13 0 0 0-1.424 1.629V5.25a.75.75 0 1 0-1.5 0v2.956a13.129 13.129 0 0 0-1.42-1.628C8.015 4.807 5.989 3.75 4.406 3.75c-1.203 0-1.875.534-2.222.982-.639.823-1.141 2.258-.02 6.676.568 2.234 1.83 3.093 2.872 3.414A4.125 4.125 0 0 0 12 19.244a4.125 4.125 0 0 0 6.964-4.422c1.042-.319 2.303-1.18 2.871-3.414.63-2.48 1.12-5.211-.02-6.675zM8.625 19.5a2.637 2.637 0 0 1-.294-5.25.75.75 0 1 0-.165-1.49 4.096 4.096 0 0 0-1.945.74c-.79.008-2.062-.335-2.602-2.462-.27-1.064-1.088-4.301-.25-5.385.134-.172.39-.403 1.037-.403 2.557 0 6.844 4.207 6.844 6.72v4.905A2.625 2.625 0 0 1 8.625 19.5zm11.756-8.462c-.54 2.127-1.812 2.47-2.603 2.462a4.088 4.088 0 0 0-1.945-.745.75.75 0 1 0-.165 1.49 2.637 2.637 0 0 1 .133 5.223 2.635 2.635 0 0 1-3.051-2.593v-4.906c0-2.511 4.283-6.719 6.844-6.719.651 0 .905.23 1.04.403.84 1.084.017 4.321-.253 5.385z",
    "data-ppui": "true"
  })), props.children);
};
var WithdrawCashIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded368);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "withdraw cash icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.75 18.623V22.5a.75.75 0 1 1-1.5 0v-3.877A7.018 7.018 0 0 0 18 13.5v5.47a.75.75 0 0 1-1.377.41l-1.001-1.528a1.125 1.125 0 1 0-1.98 1.073l2.074 3.168a.75.75 0 1 1-1.255.821l-2.087-3.187-.022-.036a2.625 2.625 0 0 1 4.148-3.153V6H15a.75.75 0 1 1 0-1.5h1.5A1.5 1.5 0 0 1 18 6v5.59a8.52 8.52 0 0 1 3.75 7.033zM8.25 5.25a.75.75 0 0 0-.75-.75H6A1.5 1.5 0 0 0 4.5 6v12.75a.75.75 0 1 0 1.5 0V6h1.5a.75.75 0 0 0 .75-.75zm6.53 3.97a.749.749 0 0 0-1.06 0L12 10.94V1.5a.75.75 0 1 0-1.5 0v9.44L8.78 9.22a.75.75 0 0 0-1.06 1.06l3 3a.747.747 0 0 0 1.06 0l3-3a.747.747 0 0 0 0-1.06z",
    "data-ppui": "true"
  })), props.children);
};
var WorkingCapitalIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded369);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "working capital icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.568 6.633a.75.75 0 1 1-1.501 0V4.2l-4.023 4.024a.75.75 0 1 1-1.06-1.061l4.023-4.023h-2.432a.75.75 0 1 1 0-1.5h4.242a.75.75 0 0 1 .75.75v4.243z",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M20.644 12.794c.346.069.67.216.95.431h.003a2.307 2.307 0 0 1-.368 3.896l-.041.019-3.645 1.55a.652.652 0 0 1-.111.038l-6 1.5a.744.744 0 0 1-.182.023H1.5a1.5 1.5 0 0 1-1.5-1.5V15a1.5 1.5 0 0 1 1.5-1.5h2.69l2.12-2.122a2.982 2.982 0 0 1 2.122-.878h4.693a2.624 2.624 0 0 1 2.555 3.23l3.922-.902a2.28 2.28 0 0 1 1.042-.035zM3.75 15H1.5v3.75h2.25V15zm13.26 2.286l3.562-1.517h-.003a.806.806 0 0 0-.59-1.49l-.03.007-6.281 1.445a.782.782 0 0 1-.168.019h-3a.75.75 0 0 1 0-1.5h2.625a1.125 1.125 0 0 0 0-2.25H8.432a1.485 1.485 0 0 0-1.06.44L5.25 14.56v4.19h5.906l5.853-1.464z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};
var XoomIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded370);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "xoom icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M15.29 3.68a.75.75 0 0 1 .582-.275h4.852a.75.75 0 0 1 .58 1.226l-4.465 5.438a.75.75 0 0 1-1.14.021l-2.516-2.838a.75.75 0 0 1-.019-.972l2.127-2.6zm.937 1.225l-1.497 1.83 1.508 1.702 2.9-3.532h-2.911zM2.517 3.893a.75.75 0 0 1 .682-.438h5.004a.75.75 0 0 1 .569.261l6.25 7.27a.75.75 0 0 1-.006.984l-7.27 8.267a.75.75 0 0 1-.564.254h-4.93a.75.75 0 0 1-.573-1.233l6.683-7.926-5.731-6.637a.75.75 0 0 1-.114-.802zm2.32 1.062l5.079 5.88a.75.75 0 0 1 .006.974l-6.056 7.182h2.977l6.616-7.521-5.6-6.515H4.837zm11.955 7.934a.75.75 0 0 0-1.135-.007l-2.476 2.828a.75.75 0 0 0-.018.968l2.966 3.64a.75.75 0 0 0 .582.277h5.036a.75.75 0 0 0 .57-1.237l-5.525-6.47zm.275 6.206l-2.34-2.873 1.487-1.7 3.906 4.573h-3.053z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};
var ZettleIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded371);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "zettle icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.614 2.309a.75.75 0 0 0-.75.75v2.984c0 .414.336.75.75.75h7.35L4.76 17.143a.75.75 0 0 0-.162.466v3.144c0 .415.335.75.75.75h13.164a.75.75 0 0 0 .75-.75V17.61a.75.75 0 0 0-.75-.75h-7.107a.737.737 0 0 0-.077-.004h-.19L19.107 6.5a.75.75 0 0 0 .155-.458V3.06a.75.75 0 0 0-.75-.75H5.614zm3.631 14.546L16.99 6.79h-2.111L6.902 16.855h2.343zm-3.147 1.5v1.648h11.664V18.36h-8.15a.759.759 0 0 1-.078-.004H6.098zm6.701-13.062a.762.762 0 0 1 .051-.002h4.912V3.81H6.364v1.484H12.8z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};
var ZoomInIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded372);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "zoom in icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.25 10.5a.75.75 0 0 1-.75.75h-2.25v2.25a.75.75 0 1 1-1.5 0v-2.25H7.5a.75.75 0 1 1 0-1.5h2.25V7.5a.75.75 0 0 1 1.5 0v2.25h2.25a.75.75 0 0 1 .75.75zm7.28 11.03a.75.75 0 0 1-1.06 0l-4.694-4.693a8.26 8.26 0 1 1 1.06-1.06l4.695 4.693a.751.751 0 0 1 0 1.06zM10.5 17.25a6.75 6.75 0 1 0-6.75-6.75 6.757 6.757 0 0 0 6.75 6.75z",
    "data-ppui": "true"
  })), props.children);
};
var ZoomOutIcon = function (props) {
  props.svgElementRef;
    var rest = _objectWithoutProperties(props, _excluded373);
  return /*#__PURE__*/React.createElement(IconContainer, _extends({
    "aria-label": "zoom out icon"
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.25 10.5a.75.75 0 0 1-.75.75h-6a.75.75 0 1 1 0-1.5h6a.75.75 0 0 1 .75.75zm7.28 11.03a.75.75 0 0 1-1.06 0l-4.694-4.693a8.26 8.26 0 1 1 1.06-1.06l4.695 4.693a.751.751 0 0 1 0 1.06zM10.5 17.25a6.75 6.75 0 1 0-6.75-6.75 6.757 6.757 0 0 0 6.75 6.75z",
    "data-ppui": "true"
  })), props.children);
};

var _excluded = ["name", "as", "size", "className", "children", "color", "cdnHost"];
var Icon = function (_ref) {
  var _ref$name = _ref.name,
    name = _ref$name === void 0 ? 'acorns' : _ref$name,
    _ref$as = _ref.as,
    as = _ref$as === void 0 ? 'span' : _ref$as,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'md' : _ref$size,
    className = _ref.className;
    _ref.children;
    var color = _ref.color,
    cdnHost = _ref.cdnHost,
    rest = _objectWithoutProperties(_ref, _excluded);
  var iconURL = "".concat(svgBasePath(cdnHost), "/").concat(name, ".svg");
  var iconColor = getColor(color, styles.legalColors, styles.ICON_FALLBACK_COLOR);
  var classNames = cx(styles.base, styles.backgroundBase, size === 'xs' && styles.sizeXs, size === 'sm' && styles.sizeSm, size === 'md' && styles.sizeMd, size === 'lg' && styles.sizeLg, size === 'xl' && styles.sizeXl, className);
  return /*#__PURE__*/React.createElement(as, _extends({
    style: {
      backgroundColor: fallbackVar(contextColors.main, iconColor),
      mask: "url(".concat(iconURL, ") center no-repeat")
    },
    className: classNames,
    role: "img",
    "aria-label": "".concat(name, " icon")
  }, rest, {
    "data-ppui": "true"
  }));
};

export { AcornsIcon, ActivityIcon, AddCameraIcon, AddCashIcon, AddIcon, AddUserIcon, AddVideoIcon, AlarmClockIcon, AnimalsIcon, AppMenuIcon, AppliancesIcon, ArchiveIcon, ArrowDownIcon, ArrowDownSmIcon, ArrowLeftIcon, ArrowRightIcon, ArrowUpIcon, ArrowUpSmIcon, ArrowsInIcon, ArrowsOutIcon, ArrowsUpDownIcon, ArtIcon, AttachIcon, AutoIcon, AutopayIcon, AutopayNoIcon, BabyProductsIcon, BackspaceIcon, BankDepositIcon, BankIcon, BankInfoIcon, BeautyIcon, BigPurchaseIcon, BillPaymentIcon, BirthdayIcon, BitcoinCashIcon, BitcoinIcon, BlockIcon, BooksIcon, BoxIcon, BusinessIcon, ButtonIcon, CalculatorIcon, CalendarIcon, CalendarPausedIcon, CalendarSmIcon, CameraIcon, CardStackIcon, CardholderIcon, CashBackIcon, CashBackSmIcon, CashIcon, CashPickupIcon, CausesIcon, CenterAlignIcon, ChangePlanIcon, CharitiesIcon, ChartPieSliceIcon, ChatCurrencyIcon, ChatIcon, CheckCaptureIcon, CheckIcon, CheckmarkBackgroundIcon, CheckmarkBackgroundSmIcon, CheckmarkIcon, CheckmarkSelectedIcon, CheckmarkSelectedSmIcon, CheckmarkSmIcon, ChevronDownIcon, ChevronDownSmIcon, ChevronLeftIcon, ChevronRightIcon, ChevronUpIcon, ChevronUpSmIcon, ChildrenIcon, CircleIcon, ClockIcon, ClockSmIcon, CloseIcon, CloseSmIcon, ClothingIcon, CloudStorageIcon, CodeIcon, CommunityIcon, ConfettiIcon, ConnectionIcon, ContactUsIcon, ContactlessPaymentIcon, ContactlessPaymentSelectedIcon, ContactsIcon, CopyToClipboardIcon, CreditCardIcon, CreditMastercardIcon, CriticalIcon, CriticalSmIcon, CrowdfundIcon, CryptoIcon, CultureIcon, CurrencyChfIcon, CurrencyDollarIcon, CurrencyEuroIcon, CurrencyPoundIcon, CurrencyRupeeIcon, CurrencyYenIcon, CustomersIcon, DailyDealIcon, DashboardIcon, DayIcon, DealsIcon, DeclineIcon, DeleteIcon, DesktopIcon, DetailedListIcon, DirectDepositIcon, DisasterIcon, DisasterReliefIcon, DislikeIcon, DislikeSelectedIcon, DisputesIcon, DocumentIcon, DonateIcon, DownloadIcon, DressIcon, EditIcon, EducationIcon, ElectricityIcon, EmailIcon, EmojiIcon, EnvironmentIcon, EthereumIcon, FaceIdIcon, FamilySupportIcon, FaqIcon, FavoriteIcon, FavoriteSelectedIcon, FilterIcon, FingerprintIcon, FlagIcon, FlashIcon, FlashOffIcon, FlashSelectedIcon, FlowersIcon, FolderStarFillIcon, FoodIcon, FundraiserIcon, FurnitureIcon, GasPumpIcon, GeneralSupportIcon, GetDirectionsIcon, GiftCardIcon, GoalsIcon, GoldIcon, GourmetFoodIcon, GrantsIcon, HandSwipeRightIcon, HandbagsIcon, HealthIcon, HelpIcon, HideIcon, HighHeelIcon, HomeIcon, HomeownerIcon, HoneyIcon, HourglassIcon, HouseholdIcon, HouseholdSuppliesIcon, HumanIcon, HumanServicesIcon, HungerIcon, Icon, IconContainer, InFlightIcon, IndustrialIcon, InformationIcon, InformationSmIcon, InsightsIcon, InstallmentsIcon, InsuranceIcon, InsuredIcon, InternationalIcon, InternetIcon, InvestIcon, InvoiceIcon, JewelryIcon, JusticeIcon, LaptopIcon, LawnIcon, LeftAlignIcon, LetterCheckmarkIcon, LightBulbIcon, LikeIcon, LikeSelectedIcon, LinkIcon, ListSimpleIcon, LitecoinIcon, LoansIcon, LocationIcon, LockIcon, LogoutIcon, LoyaltyCardIcon, LuggageIcon, MedicalIcon, MegaphoneIcon, MembershipsIcon, MemorialsIcon, MenuIcon, MerchantIcon, MessageCenterIcon, MessageIcon, MgmIcon, MicrophoneIcon, MilitaryIcon, MoveIcon, MovieIcon, MusicIcon, MusicalInstrumentsIcon, MuteIcon, NavigateIcon, NfcIcon, NightIcon, NoIconIcon, NotificationIcon, NotificationPreferencesIcon, NumberPadIcon, NumberedListIcon, OccasionIcon, OffersIcon, OfficeSuppliesIcon, OfflineIcon, OnlineIcon, OnlineShoppingIcon, OpenBrowserIcon, OrderAheadIcon, OthersIcon, OverflowIcon, PackageSizeIcon, PartySuppliesIcon, PasskeyFilledIcon, PasskeyIcon, PasswordInputIcon, PauseIcon, PayIn3Icon, PayIn4Icon, PayLaterIcon, PayMonthlyIcon, PayoutsIcon, PaypalAppIcon, PaypalAssistantIcon, PaypalBalanceIcon, PaypalUsdIcon, PendingPausedIcon, PersonalInfoIcon, PersonalSavingsIcon, PetSuppliesIcon, Phone2Icon, PhoneDeclineIcon, PhoneIcon, PhotoIdIcon, PictureBrokenIcon, PictureIcon, PinFilledIcon, PinIcon, PixIcon, PlayIcon, PledgeIcon, PlusSquareFillIcon, PlusSquareIcon, PosIcon, PreferredIcon, PreferredSelectedIcon, PreviewIcon, PrintIcon, PropertyMgmtIcon, PurchaseProtectionIcon, QrcIcon, QuestionIcon, QuestionSmIcon, RainyDayIcon, RecurrentIcon, RecurringPausedIcon, RefreshIcon, RefundIcon, RegistrationDocIcon, ReloadPhonesIcon, RentIcon, ReportProblemIcon, RequestCryptoIcon, RequestMoneyIcon, ResolutionIcon, RetirementIcon, ReturnRightIcon, RewardsIcon, RightAlignIcon, SafariIcon, SavingsIcon, ScanBarcodeIcon, ScanIcon, ScienceIcon, SearchIcon, SearchSmIcon, SecurityIcon, SendMoneyIcon, SendRequestIcon, SendToBankIcon, ServicesIcon, SettingsIcon, SewingIcon, ShareAndroidIcon, ShareFacebookIcon, ShareIcon, ShareInstagramIcon, ShareIosIcon, ShareLineIcon, ShareLinkedinIcon, ShareMessengerIcon, ShareSnapchatIcon, ShareTwitterIcon, ShareWechatIcon, ShareWhatsappIcon, ShippingIcon, ShippingLabelIcon, ShippingPackIcon, ShippingSendIcon, ShoesIcon, ShopIcon, ShoppingBasketIcon, ShoppingCartIcon, SkipIcon, SmartphonePhotoIcon, SnoozeIcon, SocialJusticeIcon, SpiritualityIcon, SplitBillIcon, SportsIcon, SubscriptionsIcon, SubtractIcon, SurveyIcon, SwitchCardIcon, TermsIcon, TextSizeIcon, TimerIcon, TipJarIcon, ToolsIcon, TopUpIcon, ToysIcon, TransferIcon, TravelIcon, TreatYourselfIcon, TreeViewIcon, TrophyIcon, TuitionIcon, UndoIcon, UnlinkIcon, UnlockIcon, UnmuteIcon, UploadIcon, UserProfileIcon, VacationIcon, VenmoIcon, VerifiedIcon, VideoGamesIcon, ViewIcon, WalletIcon, WandIcon, WarningIcon, WarningSmIcon, WebsiteIcon, WellnessIcon, WildlifeIcon, WithdrawCashIcon, WorkingCapitalIcon, XoomIcon, ZettleIcon, ZoomInIcon, ZoomOutIcon };
